import * as Xr from "react";
import Yt, { useEffect as Se, useState as z, createContext as zr, useContext as qr, useCallback as $t, useMemo as En, useRef as Ft, Fragment as Lu } from "react";
import Ae from "@mui/material/Box";
import Uu from "@mui/material/Avatar";
import Nu from "@mui/material/Menu";
import yr from "@mui/material/MenuItem";
import ys from "@mui/material/ListItemIcon";
import Du from "@mui/material/Divider";
import $u from "@mui/material/IconButton";
import Qo from "@mui/material/Tooltip";
import Fu from "@mui/icons-material/Person";
import Bu from "@mui/material/AppBar";
import Mu from "@mui/material/Toolbar";
import { Box as ue, CircularProgress as Un, Typography as ze, Button as Ne, Breadcrumbs as zu, CardActionArea as qu, Card as br, CardContent as wr, Stack as rn, Chip as ea, IconButton as xr, TextField as Tn, FormControlLabel as ta, Checkbox as na, Link as wi, Alert as jn, List as Zu, ListItemButton as Hu, ListItemText as Wu, MenuItem as Ju, Table as Vu, TableHead as Gu, TableRow as xi, TableCell as jt, TableBody as Ku, Divider as Yu, Dialog as tr, DialogTitle as Qr, DialogContent as nr, DialogActions as bs, Snackbar as Xu } from "@mui/material";
import { AuthProvider as Qu, useAuth as qt } from "react-oidc-context";
import { Delete as ec, ArrowBack as tc, Add as nc, People as rc, Edit as sc } from "@mui/icons-material";
import Sr from "@mui/material/Skeleton";
import Rr from "@mui/material/Stack";
import { ThemeProvider as ic, styled as Zs, useColorScheme as oc } from "@mui/material/styles";
import ac from "@mui/material/CssBaseline";
import uc from "@mui/material/List";
import cc from "@mui/material/ListItem";
import lc from "@mui/material/ListItemText";
import ra from "@mui/icons-material/Home";
import sa from "@mui/icons-material/Settings";
import { Navigate as ia, useLocation as dc } from "react-router-dom";
import _r from "@mui/material/Typography";
import oa from "@mui/material/Select";
import fc from "@mui/icons-material/Event";
import aa from "@mui/material/Chip";
import hc from "@mui/icons-material/Business";
import pc from "@mui/icons-material/AdminPanelSettings";
import { Logo as mc } from "brand";
import gc from "@mui/icons-material/DeleteOutline";
import vc from "@mui/icons-material/Lock";
import yc from "@mui/icons-material/Brightness4";
import bc from "@mui/icons-material/Brightness7";
import wc from "@mui/icons-material/Logout";
import xc from "axios";
var ws = { exports: {} }, fn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Si;
function Sc() {
  if (Si) return fn;
  Si = 1;
  var t = Yt, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, u, c) {
    var l, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), u.key !== void 0 && (f = "" + u.key), u.ref !== void 0 && (h = u.ref);
    for (l in u) r.call(u, l) && !i.hasOwnProperty(l) && (d[l] = u[l]);
    if (a && a.defaultProps) for (l in u = a.defaultProps, u) d[l] === void 0 && (d[l] = u[l]);
    return { $$typeof: e, type: a, key: f, ref: h, props: d, _owner: s.current };
  }
  return fn.Fragment = n, fn.jsx = o, fn.jsxs = o, fn;
}
var hn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ri;
function Rc() {
  return Ri || (Ri = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Yt, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), v = Symbol.iterator, p = "@@iterator";
    function R(g) {
      if (g === null || typeof g != "object")
        return null;
      var _ = v && g[v] || g[p];
      return typeof _ == "function" ? _ : null;
    }
    var J = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(g) {
      {
        for (var _ = arguments.length, C = new Array(_ > 1 ? _ - 1 : 0), q = 1; q < _; q++)
          C[q - 1] = arguments[q];
        W("error", g, C);
      }
    }
    function W(g, _, C) {
      {
        var q = J.ReactDebugCurrentFrame, ae = q.getStackAddendum();
        ae !== "" && (_ += "%s", C = C.concat([ae]));
        var fe = C.map(function(re) {
          return String(re);
        });
        fe.unshift("Warning: " + _), Function.prototype.apply.call(console[g], console, fe);
      }
    }
    var M = !1, ne = !1, K = !1, je = !1, me = !1, Me;
    Me = Symbol.for("react.module.reference");
    function Qe(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === r || g === i || me || g === s || g === c || g === l || je || g === h || M || ne || K || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === o || g.$$typeof === a || g.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === Me || g.getModuleId !== void 0));
    }
    function le(g, _, C) {
      var q = g.displayName;
      if (q)
        return q;
      var ae = _.displayName || _.name || "";
      return ae !== "" ? C + "(" + ae + ")" : C;
    }
    function Ce(g) {
      return g.displayName || "Context";
    }
    function ce(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case a:
            var _ = g;
            return Ce(_) + ".Consumer";
          case o:
            var C = g;
            return Ce(C._context) + ".Provider";
          case u:
            return le(g, g.render, "ForwardRef");
          case d:
            var q = g.displayName || null;
            return q !== null ? q : ce(g.type) || "Memo";
          case f: {
            var ae = g, fe = ae._payload, re = ae._init;
            try {
              return ce(re(fe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var se = Object.assign, oe = 0, qe, ye, ht, xt, he, pe, ke;
    function V() {
    }
    V.__reactDisabledLog = !0;
    function de() {
      {
        if (oe === 0) {
          qe = console.log, ye = console.info, ht = console.warn, xt = console.error, he = console.group, pe = console.groupCollapsed, ke = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: V,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        oe++;
      }
    }
    function Pe() {
      {
        if (oe--, oe === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: se({}, g, {
              value: qe
            }),
            info: se({}, g, {
              value: ye
            }),
            warn: se({}, g, {
              value: ht
            }),
            error: se({}, g, {
              value: xt
            }),
            group: se({}, g, {
              value: he
            }),
            groupCollapsed: se({}, g, {
              value: pe
            }),
            groupEnd: se({}, g, {
              value: ke
            })
          });
        }
        oe < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var et = J.ReactCurrentDispatcher, St;
    function It(g, _, C) {
      {
        if (St === void 0)
          try {
            throw Error();
          } catch (ae) {
            var q = ae.stack.trim().match(/\n( *(at )?)/);
            St = q && q[1] || "";
          }
        return `
` + St + g;
      }
    }
    var tt = !1, Rt;
    {
      var Wr = typeof WeakMap == "function" ? WeakMap : Map;
      Rt = new Wr();
    }
    function ii(g, _) {
      if (!g || tt)
        return "";
      {
        var C = Rt.get(g);
        if (C !== void 0)
          return C;
      }
      var q;
      tt = !0;
      var ae = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var fe;
      fe = et.current, et.current = null, de();
      try {
        if (_) {
          var re = function() {
            throw Error();
          };
          if (Object.defineProperty(re.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(re, []);
            } catch ($e) {
              q = $e;
            }
            Reflect.construct(g, [], re);
          } else {
            try {
              re.call();
            } catch ($e) {
              q = $e;
            }
            g.call(re.prototype);
          }
        } else {
          try {
            throw Error();
          } catch ($e) {
            q = $e;
          }
          g();
        }
      } catch ($e) {
        if ($e && q && typeof $e.stack == "string") {
          for (var Q = $e.stack.split(`
`), Ue = q.stack.split(`
`), Re = Q.length - 1, _e = Ue.length - 1; Re >= 1 && _e >= 0 && Q[Re] !== Ue[_e]; )
            _e--;
          for (; Re >= 1 && _e >= 0; Re--, _e--)
            if (Q[Re] !== Ue[_e]) {
              if (Re !== 1 || _e !== 1)
                do
                  if (Re--, _e--, _e < 0 || Q[Re] !== Ue[_e]) {
                    var Ze = `
` + Q[Re].replace(" at new ", " at ");
                    return g.displayName && Ze.includes("<anonymous>") && (Ze = Ze.replace("<anonymous>", g.displayName)), typeof g == "function" && Rt.set(g, Ze), Ze;
                  }
                while (Re >= 1 && _e >= 0);
              break;
            }
        }
      } finally {
        tt = !1, et.current = fe, Pe(), Error.prepareStackTrace = ae;
      }
      var Ht = g ? g.displayName || g.name : "", Lt = Ht ? It(Ht) : "";
      return typeof g == "function" && Rt.set(g, Lt), Lt;
    }
    function lu(g, _, C) {
      return ii(g, !1);
    }
    function du(g) {
      var _ = g.prototype;
      return !!(_ && _.isReactComponent);
    }
    function qn(g, _, C) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return ii(g, du(g));
      if (typeof g == "string")
        return It(g);
      switch (g) {
        case c:
          return It("Suspense");
        case l:
          return It("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case u:
            return lu(g.render);
          case d:
            return qn(g.type, _, C);
          case f: {
            var q = g, ae = q._payload, fe = q._init;
            try {
              return qn(fe(ae), _, C);
            } catch {
            }
          }
        }
      return "";
    }
    var dn = Object.prototype.hasOwnProperty, oi = {}, ai = J.ReactDebugCurrentFrame;
    function Zn(g) {
      if (g) {
        var _ = g._owner, C = qn(g.type, g._source, _ ? _.type : null);
        ai.setExtraStackFrame(C);
      } else
        ai.setExtraStackFrame(null);
    }
    function fu(g, _, C, q, ae) {
      {
        var fe = Function.call.bind(dn);
        for (var re in g)
          if (fe(g, re)) {
            var Q = void 0;
            try {
              if (typeof g[re] != "function") {
                var Ue = Error((q || "React class") + ": " + C + " type `" + re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[re] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ue.name = "Invariant Violation", Ue;
              }
              Q = g[re](_, re, q, C, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Re) {
              Q = Re;
            }
            Q && !(Q instanceof Error) && (Zn(ae), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", C, re, typeof Q), Zn(null)), Q instanceof Error && !(Q.message in oi) && (oi[Q.message] = !0, Zn(ae), T("Failed %s type: %s", C, Q.message), Zn(null));
          }
      }
    }
    var hu = Array.isArray;
    function Jr(g) {
      return hu(g);
    }
    function pu(g) {
      {
        var _ = typeof Symbol == "function" && Symbol.toStringTag, C = _ && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return C;
      }
    }
    function mu(g) {
      try {
        return ui(g), !1;
      } catch {
        return !0;
      }
    }
    function ui(g) {
      return "" + g;
    }
    function ci(g) {
      if (mu(g))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pu(g)), ui(g);
    }
    var li = J.ReactCurrentOwner, gu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, di, fi;
    function vu(g) {
      if (dn.call(g, "ref")) {
        var _ = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function yu(g) {
      if (dn.call(g, "key")) {
        var _ = Object.getOwnPropertyDescriptor(g, "key").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function bu(g, _) {
      typeof g.ref == "string" && li.current;
    }
    function wu(g, _) {
      {
        var C = function() {
          di || (di = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        C.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: C,
          configurable: !0
        });
      }
    }
    function xu(g, _) {
      {
        var C = function() {
          fi || (fi = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        C.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: C,
          configurable: !0
        });
      }
    }
    var Su = function(g, _, C, q, ae, fe, re) {
      var Q = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: g,
        key: _,
        ref: C,
        props: re,
        // Record the component responsible for creating this element.
        _owner: fe
      };
      return Q._store = {}, Object.defineProperty(Q._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Q, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(Q, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ae
      }), Object.freeze && (Object.freeze(Q.props), Object.freeze(Q)), Q;
    };
    function Ru(g, _, C, q, ae) {
      {
        var fe, re = {}, Q = null, Ue = null;
        C !== void 0 && (ci(C), Q = "" + C), yu(_) && (ci(_.key), Q = "" + _.key), vu(_) && (Ue = _.ref, bu(_, ae));
        for (fe in _)
          dn.call(_, fe) && !gu.hasOwnProperty(fe) && (re[fe] = _[fe]);
        if (g && g.defaultProps) {
          var Re = g.defaultProps;
          for (fe in Re)
            re[fe] === void 0 && (re[fe] = Re[fe]);
        }
        if (Q || Ue) {
          var _e = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          Q && wu(re, _e), Ue && xu(re, _e);
        }
        return Su(g, Q, Ue, ae, q, li.current, re);
      }
    }
    var Vr = J.ReactCurrentOwner, hi = J.ReactDebugCurrentFrame;
    function Zt(g) {
      if (g) {
        var _ = g._owner, C = qn(g.type, g._source, _ ? _.type : null);
        hi.setExtraStackFrame(C);
      } else
        hi.setExtraStackFrame(null);
    }
    var Gr;
    Gr = !1;
    function Kr(g) {
      return typeof g == "object" && g !== null && g.$$typeof === e;
    }
    function pi() {
      {
        if (Vr.current) {
          var g = ce(Vr.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function _u(g) {
      return "";
    }
    var mi = {};
    function Ou(g) {
      {
        var _ = pi();
        if (!_) {
          var C = typeof g == "string" ? g : g.displayName || g.name;
          C && (_ = `

Check the top-level render call using <` + C + ">.");
        }
        return _;
      }
    }
    function gi(g, _) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var C = Ou(_);
        if (mi[C])
          return;
        mi[C] = !0;
        var q = "";
        g && g._owner && g._owner !== Vr.current && (q = " It was passed a child from " + ce(g._owner.type) + "."), Zt(g), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', C, q), Zt(null);
      }
    }
    function vi(g, _) {
      {
        if (typeof g != "object")
          return;
        if (Jr(g))
          for (var C = 0; C < g.length; C++) {
            var q = g[C];
            Kr(q) && gi(q, _);
          }
        else if (Kr(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var ae = R(g);
          if (typeof ae == "function" && ae !== g.entries)
            for (var fe = ae.call(g), re; !(re = fe.next()).done; )
              Kr(re.value) && gi(re.value, _);
        }
      }
    }
    function Eu(g) {
      {
        var _ = g.type;
        if (_ == null || typeof _ == "string")
          return;
        var C;
        if (typeof _ == "function")
          C = _.propTypes;
        else if (typeof _ == "object" && (_.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _.$$typeof === d))
          C = _.propTypes;
        else
          return;
        if (C) {
          var q = ce(_);
          fu(C, g.props, "prop", q, g);
        } else if (_.PropTypes !== void 0 && !Gr) {
          Gr = !0;
          var ae = ce(_);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ae || "Unknown");
        }
        typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Tu(g) {
      {
        for (var _ = Object.keys(g.props), C = 0; C < _.length; C++) {
          var q = _[C];
          if (q !== "children" && q !== "key") {
            Zt(g), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), Zt(null);
            break;
          }
        }
        g.ref !== null && (Zt(g), T("Invalid attribute `ref` supplied to `React.Fragment`."), Zt(null));
      }
    }
    var yi = {};
    function bi(g, _, C, q, ae, fe) {
      {
        var re = Qe(g);
        if (!re) {
          var Q = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (Q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ue = _u();
          Ue ? Q += Ue : Q += pi();
          var Re;
          g === null ? Re = "null" : Jr(g) ? Re = "array" : g !== void 0 && g.$$typeof === e ? (Re = "<" + (ce(g.type) || "Unknown") + " />", Q = " Did you accidentally export a JSX literal instead of a component?") : Re = typeof g, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Re, Q);
        }
        var _e = Ru(g, _, C, ae, fe);
        if (_e == null)
          return _e;
        if (re) {
          var Ze = _.children;
          if (Ze !== void 0)
            if (q)
              if (Jr(Ze)) {
                for (var Ht = 0; Ht < Ze.length; Ht++)
                  vi(Ze[Ht], g);
                Object.freeze && Object.freeze(Ze);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vi(Ze, g);
        }
        if (dn.call(_, "key")) {
          var Lt = ce(g), $e = Object.keys(_).filter(function(Iu) {
            return Iu !== "key";
          }), Yr = $e.length > 0 ? "{key: someKey, " + $e.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!yi[Lt + Yr]) {
            var Au = $e.length > 0 ? "{" + $e.join(": ..., ") + ": ...}" : "{}";
            T(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Yr, Lt, Au, Lt), yi[Lt + Yr] = !0;
          }
        }
        return g === r ? Tu(_e) : Eu(_e), _e;
      }
    }
    function ju(g, _, C) {
      return bi(g, _, C, !0);
    }
    function Cu(g, _, C) {
      return bi(g, _, C, !1);
    }
    var ku = Cu, Pu = ju;
    hn.Fragment = r, hn.jsx = ku, hn.jsxs = Pu;
  }()), hn;
}
process.env.NODE_ENV === "production" ? ws.exports = Sc() : ws.exports = Rc();
var m = ws.exports;
function Lh({ menuItems: t }) {
  const [e, n] = Xr.useState(null), r = !!e, s = (o) => {
    n(o.currentTarget);
  }, i = () => {
    n(null);
  };
  return /* @__PURE__ */ m.jsxs(Xr.Fragment, { children: [
    /* @__PURE__ */ m.jsx(Ae, { sx: { display: "flex", alignItems: "center", textAlign: "center" }, children: /* @__PURE__ */ m.jsx(Qo, { title: "Account settings", children: /* @__PURE__ */ m.jsx(
      $u,
      {
        onClick: s,
        size: "small",
        sx: { ml: 2 },
        "aria-controls": r ? "account-menu" : void 0,
        "aria-haspopup": "true",
        "aria-expanded": r ? "true" : void 0,
        children: /* @__PURE__ */ m.jsx(Uu, { sx: { width: 32, height: 32 }, children: /* @__PURE__ */ m.jsx(Fu, {}) })
      }
    ) }) }),
    /* @__PURE__ */ m.jsx(
      Nu,
      {
        anchorEl: e,
        id: "account-menu",
        open: r,
        onClose: i,
        onClick: i,
        disableScrollLock: !0,
        slotProps: {
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }
        },
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        children: t.map((o, a) => /* @__PURE__ */ m.jsxs(Xr.Fragment, { children: [
          o.divider && /* @__PURE__ */ m.jsx(Du, {}),
          o.href ? /* @__PURE__ */ m.jsxs(yr, { component: "a", href: o.href, onClick: i, children: [
            o.icon && /* @__PURE__ */ m.jsx(ys, { children: o.icon }),
            o.text
          ] }) : /* @__PURE__ */ m.jsxs(
            yr,
            {
              onClick: () => {
                var u;
                (u = o.onClick) == null || u.call(o), i();
              },
              children: [
                o.icon && /* @__PURE__ */ m.jsx(ys, { children: o.icon }),
                o.text
              ]
            }
          )
        ] }, a))
      }
    )
  ] });
}
const _c = 64, Oc = () => typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev", Uh = ({ rightContent: t = null, brandLogo: e = null, sx: n = {} }) => {
  const r = Oc();
  return /* @__PURE__ */ m.jsx(Bu, { sx: { ...n }, position: "fixed", elevation: 1, children: /* @__PURE__ */ m.jsxs(
    Mu,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        pl: 0,
        minHeight: `${_c}px !important`
      },
      children: [
        e,
        /* @__PURE__ */ m.jsxs(Ae, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [
          t,
          r && /* @__PURE__ */ m.jsx(
            Ae,
            {
              component: "span",
              "data-testid": "app-version",
              "aria-hidden": "true",
              sx: {
                color: "rgba(255, 255, 255, 0.4)",
                fontFamily: "monospace",
                fontSize: "11px",
                lineHeight: 1,
                whiteSpace: "nowrap",
                userSelect: "none",
                pr: 1
              },
              children: r
            }
          )
        ] })
      ]
    }
  ) });
}, Nh = ({ children: t, sx: e = {} }) => /* @__PURE__ */ m.jsx(
  Ae,
  {
    component: "footer",
    sx: {
      position: "fixed",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "56px",
      borderTop: 1,
      borderColor: "divider",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: (n) => n.zIndex.appBar,
      ...e
    },
    children: t
  }
), Ec = 64, Tc = ({ children: t }) => /* @__PURE__ */ m.jsx(
  Ae,
  {
    component: "main",
    sx: {
      p: "20px",
      pb: 0,
      flexGrow: 1,
      mb: "56px",
      // space for footer
      minHeight: `calc(100vh - ${Ec}px - 56px)`,
      overflow: "auto"
    },
    children: t || /* @__PURE__ */ m.jsx("div", { children: "MainContent (stub)" })
  }
), es = 64, _i = 72, jc = { xs: 2, sm: 4, md: 8 }, Dh = ({
  appFooterEnabled: t = !0,
  children: e,
  appFooter: n = null,
  appBar: r = null,
  navRail: s = null
}) => /* @__PURE__ */ m.jsxs(Ae, { sx: { minHeight: "100vh", width: "100%" }, children: [
  /* @__PURE__ */ m.jsx(
    Ae,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        zIndex: 1300
      },
      children: r
    }
  ),
  /* @__PURE__ */ m.jsxs(
    Ae,
    {
      sx: {
        display: "flex",
        flexDirection: "row",
        pt: `${es}px`
      },
      children: [
        s && /* @__PURE__ */ m.jsx(
          Ae,
          {
            sx: {
              width: _i,
              flexShrink: 0,
              position: "fixed",
              height: `calc(100vh - ${es}px)`,
              top: es,
              left: 0,
              zIndex: 1200
            },
            children: s
          }
        ),
        /* @__PURE__ */ m.jsx(
          Ae,
          {
            sx: {
              flexGrow: 1,
              minWidth: 0,
              ml: s ? `${_i}px` : 0,
              px: jc
            },
            children: /* @__PURE__ */ m.jsx(Tc, { children: e })
          }
        )
      ]
    }
  ),
  t && n
] });
function rr({ message: t }) {
  return /* @__PURE__ */ m.jsxs(
    ue,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal
      },
      children: [
        /* @__PURE__ */ m.jsx(Un, {}),
        t && /* @__PURE__ */ m.jsx(ze, { variant: "h6", sx: { mt: 2 }, children: t })
      ]
    }
  );
}
const ua = ["/", "/callback", "/logout", "/logged-out"];
function Cc(t) {
  return typeof t == "string" && t.startsWith("/") && !ua.includes(t);
}
function $h({ navigateFunction: t, location: e }) {
  return Se(() => {
    const n = setTimeout(() => {
      const r = localStorage.getItem("redirect_url");
      localStorage.removeItem("redirect_url");
      const s = Cc(r) ? r : "/";
      t(s, { replace: !0 });
    }, 500);
    return () => clearTimeout(n);
  }, [t, e]), /* @__PURE__ */ m.jsx(rr, { message: "Signing you in..." });
}
let ca = !1;
function Fh() {
  ca = !0;
}
function kc() {
  return ca;
}
function Pc({ children: t }) {
  const e = qt();
  return Se(() => {
    const n = window.location.pathname;
    ua.includes(n) || localStorage.setItem("redirect_url", n);
  }, []), Se(() => {
    !e.isLoading && !e.isAuthenticated && !e.error && !kc() && e.signinRedirect();
  }, [e.isLoading, e.isAuthenticated, e.error, e]), e.isLoading ? /* @__PURE__ */ m.jsx(rr, { message: "Loading..." }) : e.error ? /* @__PURE__ */ m.jsx(
    rr,
    {
      message: `Encountering error... ${e.error.message}`
    }
  ) : e.isAuthenticated ? t : /* @__PURE__ */ m.jsx(rr, { message: "Redirecting to login..." });
}
function Bh({ cognitoAuthConfig: t, children: e }) {
  return /* @__PURE__ */ m.jsx(Qu, { ...t, children: /* @__PURE__ */ m.jsx(Pc, { children: e }) });
}
const Mh = ({
  onConfirm: t,
  onCancel: e,
  confirmText: n = "Confirm",
  cancelText: r = "Cancel",
  buttonText: s = "Delete",
  buttonIcon: i = /* @__PURE__ */ m.jsx(ec, {}),
  variant: o = "outlined",
  color: a = "error",
  size: u = "small",
  disabled: c = !1,
  "data-testid": l,
  confirmButtonTestId: d,
  cancelButtonTestId: f
}) => {
  const [h, v] = z(!1), p = () => {
    v(!0);
  }, R = () => {
    v(!1), t();
  }, J = () => {
    v(!1), e && e();
  };
  return h ? /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", gap: 1 }, children: [
    /* @__PURE__ */ m.jsx(
      Ne,
      {
        variant: "contained",
        color: a,
        size: u,
        onClick: R,
        "data-testid": d,
        children: n
      }
    ),
    /* @__PURE__ */ m.jsx(
      Ne,
      {
        variant: "outlined",
        size: u,
        onClick: J,
        "data-testid": f,
        children: r
      }
    )
  ] }) : /* @__PURE__ */ m.jsx(
    Ne,
    {
      variant: o,
      color: a,
      size: u,
      startIcon: i,
      onClick: p,
      disabled: c,
      "data-testid": l,
      children: s
    }
  );
};
function zh({
  rows: t = 5,
  columns: e = 1,
  showHeader: n = !0,
  dense: r = !1,
  sx: s,
  ...i
}) {
  const o = r ? 28 : 40, a = r ? 0.75 : 1.25, u = Math.max(1, e), c = (l, d) => /* @__PURE__ */ m.jsx(Rr, { direction: "row", spacing: a, sx: { width: "100%" }, children: Array.from({ length: u }).map((f, h) => /* @__PURE__ */ m.jsx(
    Sr,
    {
      variant: "rounded",
      height: d,
      sx: { flex: 1, borderRadius: 1 }
    },
    h
  )) }, l);
  return /* @__PURE__ */ m.jsx(
    Ae,
    {
      role: "progressbar",
      "aria-busy": "true",
      "aria-label": "Loading",
      "data-testid": "table-skeleton",
      sx: { width: "100%", ...s },
      ...i,
      children: /* @__PURE__ */ m.jsxs(Rr, { spacing: a, children: [
        n && c("header", o * 0.7),
        Array.from({ length: Math.max(1, t) }).map(
          (l, d) => c(`row-${d}`, o)
        )
      ] })
    }
  );
}
function qh() {
  return /* @__PURE__ */ m.jsxs("div", { children: [
    "You have been logged out. ",
    /* @__PURE__ */ m.jsx("a", { href: "/", children: "Go to home" })
  ] });
}
function Zh({ navigateFunction: t }) {
  const e = qt();
  return Se(() => {
    let n = !0;
    async function r() {
      await e.removeUser(), n && t("/logged-out", { replace: !0 });
    }
    return r(), () => {
      n = !1;
    };
  }, [e, t]), /* @__PURE__ */ m.jsx("div", { children: "You have been logged out." });
}
function Hh({ theme: t, children: e }) {
  return !t || typeof t != "object" ? (console.error("Invalid theme object provided to MuiThemeProvider"), e) : /* @__PURE__ */ m.jsxs(ic, { theme: t, children: [
    /* @__PURE__ */ m.jsx(ac, {}),
    e
  ] });
}
const Ac = Zs(Ae)(({ theme: t, backgroundColor: e, color: n }) => ({
  width: 72,
  height: "100%",
  backgroundColor: e || t.palette.background.paper,
  color: n || t.palette.text.primary,
  borderRight: `1px solid ${t.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: t.spacing(2)
})), Wh = ({
  navItems: t,
  backgroundColor: e = "#1a1a1a",
  color: n = "inherit"
}) => {
  const r = [
    {
      icon: /* @__PURE__ */ m.jsx(ra, {}),
      text: "Home",
      onClick: () => {
      }
    },
    {
      icon: /* @__PURE__ */ m.jsx(sa, {}),
      text: "Settings",
      onClick: () => {
      }
    }
  ], s = t && t.length > 0 ? t : r;
  return /* @__PURE__ */ m.jsx(Ac, { backgroundColor: e, color: n, children: /* @__PURE__ */ m.jsx(uc, { sx: { width: "100%", p: 0 }, children: s.map((i, o) => /* @__PURE__ */ m.jsxs(
    cc,
    {
      onClick: i.onClick,
      sx: {
        flexDirection: "column",
        py: 1,
        px: 0,
        color: "inherit",
        // #582 — nav items are clickable; show the pointer (hand) cursor
        // on hover (ListItem alone doesn't imply a button cursor).
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "transparent",
          opacity: 0.8
        }
      },
      children: [
        /* @__PURE__ */ m.jsx(
          ys,
          {
            sx: {
              minWidth: "auto",
              color: "inherit"
            },
            children: i.icon
          }
        ),
        /* @__PURE__ */ m.jsx(
          lc,
          {
            primary: i.text,
            primaryTypographyProps: {
              variant: "caption",
              align: "center",
              sx: {
                fontSize: "0.7rem",
                mt: 0.5,
                color: "inherit"
              }
            }
          }
        )
      ]
    },
    o
  )) }) });
};
function Jh({ children: t }) {
  return qt().isAuthenticated ? t : /* @__PURE__ */ m.jsx(ia, { to: "/callback", replace: !0 });
}
const Vh = ({
  children: t,
  maxWidth: e = 600,
  minWidth: n = 320,
  backTo: r,
  backLabel: s,
  breadcrumbs: i,
  onBack: o
}) => {
  const a = () => {
    o && o();
  };
  return /* @__PURE__ */ m.jsxs(
    ue,
    {
      maxWidth: e,
      minWidth: n,
      mt: 4,
      pb: 8,
      sx: {
        overflowX: "auto"
      },
      children: [
        /* @__PURE__ */ m.jsx(
          ue,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 3
            },
            children: /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", alignItems: "center", gap: 2, flex: 1 }, children: [
              r && /* @__PURE__ */ m.jsx(
                Ne,
                {
                  startIcon: /* @__PURE__ */ m.jsx(tc, {}),
                  onClick: a,
                  variant: "outlined",
                  size: "small",
                  children: s || "Back"
                }
              ),
              i && /* @__PURE__ */ m.jsx(zu, { separator: "", children: Yt.Children.map(i, (u, c) => {
                const l = Yt.Children.count(i);
                let d = "middle";
                return l === 1 ? d = "single" : c === 0 ? d = "first" : c === l - 1 && (d = "last"), Yt.cloneElement(u, { position: d });
              }) })
            ] })
          }
        ),
        t
      ]
    }
  );
}, nt = "12px", Ic = Zs(Ae, {
  shouldForwardProp: (t) => t !== "position"
})(({ theme: t, position: e }) => {
  const n = () => {
    switch (e) {
      case "first":
        return `polygon(0 0, 100% 0, calc(100% - ${nt}) 100%, 0 100%)`;
      case "middle":
        return `polygon(${nt} 0, 100% 0, calc(100% - ${nt}) 100%, 0 100%)`;
      case "last":
        return `polygon(${nt} 0, calc(100% - ${nt}) 0, 100% 50%, calc(100% - ${nt}) 100%, 0 100%)`;
      case "single":
      default:
        return `polygon(0 0, calc(100% - ${nt}) 0, 100% 50%, calc(100% - ${nt}) 100%, 0 100%)`;
    }
  };
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "24px",
    backgroundColor: t.palette.mode === "dark" ? t.palette.grey[800] : t.palette.grey[200],
    color: t.palette.getContrastText(
      t.palette.mode === "dark" ? t.palette.grey[800] : t.palette.grey[200]
    ),
    cursor: "pointer",
    textDecoration: "none",
    clipPath: n(),
    // Nudge the items together to overlap
    marginLeft: e === "middle" || e === "last" ? `-${nt}` : 0,
    // Adjust padding to make space for the clipped areas
    paddingLeft: e === "middle" || e === "last" ? `calc(${nt} + ${t.spacing(1)})` : t.spacing(2),
    paddingRight: `calc(${nt} + ${t.spacing(1)})`,
    "&:hover, &:focus-within": {
      backgroundColor: t.palette.mode === "dark" ? t.palette.grey[700] : t.palette.grey[300]
    }
  };
}), Lc = Zs(_r)({
  whiteSpace: "nowrap",
  fontSize: "0.8125rem",
  fontWeight: 400,
  color: "inherit"
}), Gh = ({ label: t, component: e = "a", ...n }) => /* @__PURE__ */ m.jsx(Ic, { component: e, ...n, children: /* @__PURE__ */ m.jsx(Lc, { children: t }) }), Kh = ({ onClick: t, label: e, "data-testid": n }) => /* @__PURE__ */ m.jsx(
  qu,
  {
    onClick: t,
    sx: {
      height: "100%",
      minHeight: 140,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (r) => r.palette.mode === "dark" ? r.palette.grey[800] : r.palette.grey[200],
      borderRadius: (r) => r.shape.borderRadius,
      padding: 2,
      "&:hover": {
        backgroundColor: (r) => r.palette.mode === "dark" ? r.palette.grey[700] : r.palette.grey[300]
      }
    },
    "data-testid": n || "new-item-card-button",
    children: /* @__PURE__ */ m.jsxs(
      ue,
      {
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "3px dashed",
          borderColor: "grey.500",
          borderRadius: "10px",
          padding: "20px",
          color: "grey.500"
        },
        children: [
          /* @__PURE__ */ m.jsx(
            ue,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: "inherit",
                mb: 1
              },
              children: /* @__PURE__ */ m.jsx(nc, { sx: { fontSize: 32 } })
            }
          ),
          /* @__PURE__ */ m.jsx(ze, { variant: "button", component: "span", children: e })
        ]
      }
    )
  }
), Yh = ({ title: t, icon: e, tags: n = [], onEdit: r, showEdit: s, onMembers: i, showMembers: o, "data-testid": a, editButtonTestId: u, membersButtonTestId: c }) => /* @__PURE__ */ m.jsxs(
  br,
  {
    sx: {
      position: "relative",
      minHeight: 120,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      backgroundColor: (l) => l.palette.mode === "dark" ? l.palette.grey[900] : l.palette.background.paper
    },
    "data-testid": a,
    elevation: 1,
    children: [
      /* @__PURE__ */ m.jsx(wr, { sx: { pb: 1 }, children: /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
        e && Yt.cloneElement(e, { sx: { mr: 1.5, color: "text.secondary" } }),
        /* @__PURE__ */ m.jsx(ze, { variant: "h6", component: "div", noWrap: !0, children: t })
      ] }) }),
      /* @__PURE__ */ m.jsx(wr, { sx: { pt: 0, flexGrow: 1 }, children: /* @__PURE__ */ m.jsx(rn, { direction: "row", spacing: 1, children: n.map((l, d) => /* @__PURE__ */ m.jsx(
        ea,
        {
          label: l.label,
          color: l.color || "default",
          size: l.size || "small",
          variant: "outlined"
        },
        d
      )) }) }),
      /* @__PURE__ */ m.jsxs(ue, { sx: { position: "absolute", top: 8, right: 8, display: "flex", gap: 0.5 }, children: [
        o && /* @__PURE__ */ m.jsx(
          xr,
          {
            "aria-label": `manage members for ${t}`,
            onClick: i,
            sx: {
              color: "text.secondary"
            },
            "data-testid": c,
            children: /* @__PURE__ */ m.jsx(rc, {})
          }
        ),
        s && /* @__PURE__ */ m.jsx(
          xr,
          {
            "aria-label": `edit ${t}`,
            onClick: r,
            sx: {
              color: "text.secondary"
            },
            "data-testid": u,
            children: /* @__PURE__ */ m.jsx(sc, {})
          }
        )
      ] })
    ]
  }
);
class xn extends Error {
}
xn.prototype.name = "InvalidTokenError";
function Uc(t) {
  return decodeURIComponent(atob(t).replace(/(.)/g, (e, n) => {
    let r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function Nc(t) {
  let e = t.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Uc(e);
  } catch {
    return atob(e);
  }
}
function la(t, e) {
  if (typeof t != "string")
    throw new xn("Invalid token specified: must be a string");
  e || (e = {});
  const n = e.header === !0 ? 0 : 1, r = t.split(".")[n];
  if (typeof r != "string")
    throw new xn(`Invalid token specified: missing part #${n + 1}`);
  let s;
  try {
    s = Nc(r);
  } catch (i) {
    throw new xn(`Invalid token specified: invalid base64 for part #${n + 1} (${i.message})`);
  }
  try {
    return JSON.parse(s);
  } catch (i) {
    throw new xn(`Invalid token specified: invalid json for part #${n + 1} (${i.message})`);
  }
}
const xs = "common-fe.activeOrgId", Dc = "426e8750-5b55-59f4-90c7-835b46d6a990", $c = (t) => {
  const e = t.filter((n) => n.id !== Dc);
  return e.length ? e : t;
}, Fc = (t) => {
  if (!t) return !1;
  try {
    const e = la(t), n = e["custom:super"] ?? e.super;
    return n === "true" || n === !0;
  } catch {
    return !1;
  }
}, da = zr({
  orgs: [],
  activeOrgId: null,
  setActiveOrgId: () => {
  },
  loading: !1,
  error: null,
  isSuper: !1
}), Bc = () => {
  try {
    return window.localStorage.getItem(xs) || null;
  } catch {
    return null;
  }
}, Mc = (t) => {
  try {
    t ? window.localStorage.setItem(xs, t) : window.localStorage.removeItem(xs);
  } catch {
  }
}, Xh = ({ listOrgs: t, children: e }) => {
  var v;
  const r = (v = qt().user) == null ? void 0 : v.access_token, s = Fc(r), [i, o] = z([]), [a, u] = z(!0), [c, l] = z(null), [d, f] = z(() => Bc()), h = $t((p) => {
    f(p), Mc(p);
  }, []);
  return Se(() => {
    if (!t) {
      u(!1);
      return;
    }
    let p = !1;
    return (async () => {
      try {
        u(!0), l(null);
        const R = await t(s);
        if (p) return;
        o($c(Array.isArray(R) ? R : []));
      } catch (R) {
        if (p) return;
        console.error("Failed to load orgs for switcher:", R), l(R), o([]);
      } finally {
        p || u(!1);
      }
    })(), () => {
      p = !0;
    };
  }, [t, s]), Se(() => {
    if (!i.length) return;
    i.some((R) => R.id === d) || h(i[0].id);
  }, [i, d, h]), /* @__PURE__ */ m.jsx(
    da.Provider,
    {
      value: { orgs: i, activeOrgId: d, setActiveOrgId: h, loading: a, error: c, isSuper: s },
      children: e
    }
  );
}, fa = () => qr(da), Ss = "common-fe.activeShowId", ha = zr({
  shows: [],
  activeShowId: null,
  activeShow: null,
  setActiveShowId: () => {
  },
  loading: !1,
  error: null
}), zc = () => {
  try {
    return window.localStorage.getItem(Ss) || null;
  } catch {
    return null;
  }
}, qc = (t) => {
  try {
    t ? window.localStorage.setItem(Ss, t) : window.localStorage.removeItem(Ss);
  } catch {
  }
}, Qh = ({ listShows: t, orgId: e, children: n }) => {
  const [r, s] = z([]), [i, o] = z(!0), [a, u] = z(null), [c, l] = z(() => zc()), d = $t((v) => {
    l(v), qc(v);
  }, []);
  Se(() => {
    if (!t) {
      o(!1);
      return;
    }
    let v = !1;
    return (async () => {
      try {
        o(!0), u(null);
        const p = await t();
        if (v) return;
        s(Array.isArray(p) ? p : []);
      } catch (p) {
        if (v) return;
        console.error("Failed to load shows for switcher:", p), u(p), s([]);
      } finally {
        v || o(!1);
      }
    })(), () => {
      v = !0;
    };
  }, [t, e]), Se(() => {
    if (!r.length) return;
    r.some((p) => p.id === c) || d(r[0].id);
  }, [r, c, d]);
  const f = En(
    () => r.find((v) => v.id === c) || null,
    [r, c]
  ), h = En(
    () => ({ shows: r, activeShowId: c, activeShow: f, setActiveShowId: d, loading: i, error: a }),
    [r, c, f, d, i, a]
  );
  return /* @__PURE__ */ m.jsx(ha.Provider, { value: h, children: n });
}, Zc = () => qr(ha), ep = ({ onShowChange: t }) => {
  const { shows: e, activeShowId: n, setActiveShowId: r, loading: s } = Zc();
  if (s && !e.length)
    return /* @__PURE__ */ m.jsx(
      Sr,
      {
        "data-testid": "show-switcher-loading",
        variant: "rounded",
        width: 140,
        height: 24,
        sx: { bgcolor: "rgba(255,255,255,0.18)" }
      }
    );
  if (!e || e.length === 0) return null;
  const i = (o) => {
    const a = o.target.value;
    r(a), t && t(a);
  };
  return /* @__PURE__ */ m.jsxs(
    Ae,
    {
      "data-testid": "show-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        /* @__PURE__ */ m.jsx(fc, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ m.jsx(
          oa,
          {
            value: n || "",
            onChange: i,
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Show switcher" },
            renderValue: (o) => {
              const a = e.find((u) => u.id === o);
              return a ? a.name || a.id : "";
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 240,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: e.map((o) => /* @__PURE__ */ m.jsx(yr, { value: o.id, children: o.name || o.id }, o.id))
          }
        )
      ]
    }
  );
}, pa = zr({
  appNamespace: null,
  isSuper: !1,
  permissions: /* @__PURE__ */ new Set()
}), Hc = (t, e) => typeof e == "string" && e.includes(":") ? e : `${t}:${e}`, Wc = (t) => {
  if (!t) return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  try {
    const e = la(t), n = e["custom:super"] ?? e.super, r = n === "true" || n === !0, s = new Set(
      Array.isArray(e.permissions) ? e.permissions : []
    );
    return { isSuper: r, permissions: s };
  } catch {
    return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  }
}, tp = ({ appNamespace: t, children: e }) => {
  var i;
  const r = (i = qt().user) == null ? void 0 : i.access_token, s = En(() => {
    const { isSuper: o, permissions: a } = Wc(r);
    return { appNamespace: t, isSuper: o, permissions: a };
  }, [t, r]);
  return /* @__PURE__ */ m.jsx(pa.Provider, { value: s, children: e });
}, np = (t) => {
  const { appNamespace: e, isSuper: n, permissions: r } = qr(pa);
  return n ? !0 : r.has(Hc(e, t));
}, Jc = (t, e) => t.length > e ? `${t.slice(0, Math.max(0, e - 1))}…` : t;
function rp({ maxEmailChars: t = 28 }) {
  var u;
  const n = ((u = qt().user) == null ? void 0 : u.profile) || {}, r = (n.given_name || "").trim(), s = (n.family_name || "").trim(), i = [r, s].filter(Boolean).join(" "), o = (n.email || "").trim(), a = i || (o ? Jc(o, t) : "");
  return a ? /* @__PURE__ */ m.jsx(Qo, { title: i || o, children: /* @__PURE__ */ m.jsx(
    _r,
    {
      variant: "body2",
      noWrap: !0,
      "data-testid": "nav-user-name",
      sx: { color: "inherit", maxWidth: 220 },
      children: a
    }
  ) }) : null;
}
const sp = () => {
  const { orgs: t, activeOrgId: e, setActiveOrgId: n, isSuper: r } = fa();
  return !t || t.length <= 1 ? null : /* @__PURE__ */ m.jsxs(
    Ae,
    {
      "data-testid": "org-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        r && /* @__PURE__ */ m.jsx(
          aa,
          {
            size: "small",
            "data-testid": "super-badge",
            icon: /* @__PURE__ */ m.jsx(
              pc,
              {
                fontSize: "small",
                sx: { color: "inherit !important" }
              }
            ),
            label: "All orgs",
            sx: {
              color: "inherit",
              bgcolor: "rgba(255, 255, 255, 0.18)",
              fontWeight: 600
            }
          }
        ),
        /* @__PURE__ */ m.jsx(hc, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ m.jsx(
          oa,
          {
            value: e || "",
            onChange: (s) => n(s.target.value),
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Organization switcher" },
            renderValue: (s) => {
              const i = t.find((o) => o.id === s);
              return i ? i.name : "";
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 220,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: t.map((s) => /* @__PURE__ */ m.jsx(yr, { value: s.id, children: s.name }, s.id))
          }
        )
      ]
    }
  );
}, ma = "common-fe.mockAuth", ga = zr(null), Vc = {
  email: "jaybill@foxvillage.com",
  displayName: "Jaybill"
};
function Gc() {
  try {
    const t = localStorage.getItem(ma);
    return t ? JSON.parse(t) : { signedIn: !1, user: null };
  } catch {
    return { signedIn: !1, user: null };
  }
}
function Kc(t) {
  try {
    localStorage.setItem(ma, JSON.stringify(t));
  } catch {
  }
}
function ip({ children: t, defaultUser: e = Vc }) {
  const [n, r] = z(Gc);
  Se(() => {
    Kc(n);
  }, [n]);
  const s = $t(
    (a) => {
      r({ signedIn: !0, user: a ?? e });
    },
    [e]
  ), i = $t(() => {
    r({ signedIn: !1, user: null });
  }, []), o = En(
    () => ({
      isAuthenticated: n.signedIn,
      user: n.user,
      signIn: s,
      signOut: i
    }),
    [n, s, i]
  );
  return /* @__PURE__ */ m.jsx(ga.Provider, { value: o, children: t });
}
function va() {
  const t = qr(ga);
  if (!t)
    throw new Error("useMockAuth must be used within a MockAuthProvider");
  return t;
}
function op({ children: t, loginPath: e = "/login" }) {
  const { isAuthenticated: n } = va(), r = dc();
  return n ? t : /* @__PURE__ */ m.jsx(ia, { to: e, replace: !0, state: { from: r.pathname } });
}
const Yc = "jaybill@foxvillage.com", Xc = "demo-password", Qc = {
  heading: "Sign in",
  subheading: "Sign in to your account.",
  emailLabel: "Email address",
  passwordLabel: "Password",
  showPassword: "Show password",
  forgotPassword: "Forgot your password?",
  submit: "Sign in",
  newUserPrompt: "New user?",
  createAccount: "Create an account"
};
function ap({
  onSignIn: t,
  brandLogo: e,
  labels: n = {}
}) {
  const { signIn: r } = va(), [s, i] = z(Yc), [o, a] = z(Xc), [u, c] = z(!1), l = { ...Qc, ...n }, d = (h) => {
    h.preventDefault();
    const v = { email: s, displayName: s.split("@")[0] };
    t ? t(v) : r(v);
  }, f = e ?? mc;
  return /* @__PURE__ */ m.jsx(
    ue,
    {
      sx: {
        minHeight: "100vh",
        width: "100%",
        bgcolor: (h) => h.palette.mode === "dark" ? "#2a2a2a" : "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      },
      children: /* @__PURE__ */ m.jsxs(
        br,
        {
          elevation: 6,
          sx: {
            width: "100%",
            maxWidth: 480,
            p: { xs: 3, sm: 5 },
            bgcolor: (h) => h.palette.mode === "dark" ? "#000" : "background.paper",
            color: (h) => h.palette.mode === "dark" ? "#fff" : "text.primary",
            borderRadius: 3
          },
          children: [
            /* @__PURE__ */ m.jsx(
              ue,
              {
                sx: {
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                  color: "inherit"
                },
                children: /* @__PURE__ */ m.jsx(f, { style: { width: 240, height: "auto" } })
              }
            ),
            /* @__PURE__ */ m.jsx(ze, { variant: "h4", component: "h1", fontWeight: 700, gutterBottom: !0, children: l.heading }),
            /* @__PURE__ */ m.jsx(
              ze,
              {
                variant: "body1",
                sx: { opacity: 0.7, mb: 4 },
                children: l.subheading
              }
            ),
            /* @__PURE__ */ m.jsx(ue, { component: "form", onSubmit: d, children: /* @__PURE__ */ m.jsxs(rn, { spacing: 3, children: [
              /* @__PURE__ */ m.jsx(
                Tn,
                {
                  label: l.emailLabel,
                  type: "email",
                  fullWidth: !0,
                  value: s,
                  onChange: (h) => i(h.target.value),
                  InputLabelProps: {
                    sx: { fontWeight: 600 }
                  }
                }
              ),
              /* @__PURE__ */ m.jsxs(ue, { children: [
                /* @__PURE__ */ m.jsx(
                  Tn,
                  {
                    label: l.passwordLabel,
                    type: u ? "text" : "password",
                    fullWidth: !0,
                    value: o,
                    onChange: (h) => a(h.target.value),
                    InputLabelProps: {
                      sx: { fontWeight: 600 }
                    }
                  }
                ),
                /* @__PURE__ */ m.jsxs(
                  rn,
                  {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: { mt: 1 },
                    children: [
                      /* @__PURE__ */ m.jsx(
                        ta,
                        {
                          control: /* @__PURE__ */ m.jsx(
                            na,
                            {
                              size: "small",
                              checked: u,
                              onChange: (h) => c(h.target.checked),
                              sx: { color: "inherit" }
                            }
                          ),
                          label: l.showPassword
                        }
                      ),
                      /* @__PURE__ */ m.jsx(
                        wi,
                        {
                          component: "button",
                          type: "button",
                          underline: "hover",
                          onClick: () => {
                          },
                          sx: { color: "primary.light" },
                          children: l.forgotPassword
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ m.jsx(
                Ne,
                {
                  type: "submit",
                  variant: "contained",
                  fullWidth: !0,
                  size: "large",
                  sx: { py: 1.5, fontWeight: 600 },
                  children: l.submit
                }
              ),
              /* @__PURE__ */ m.jsxs(
                ze,
                {
                  variant: "body2",
                  align: "center",
                  sx: { opacity: 0.8 },
                  children: [
                    l.newUserPrompt,
                    " ",
                    /* @__PURE__ */ m.jsx(
                      wi,
                      {
                        component: "button",
                        type: "button",
                        underline: "hover",
                        onClick: () => {
                        },
                        sx: { color: "primary.light" },
                        children: l.createAccount
                      }
                    )
                  ]
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}
var Or = { d: (t, e) => {
  for (var n in e) Or.o(e, n) && !Or.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
}, o: (t, e) => Object.prototype.hasOwnProperty.call(t, e), r: (t) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
} }, Rs = {};
function ya(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
Or.r(Rs), Or.d(Rs, { hasBrowserEnv: () => Ws, hasStandardBrowserEnv: () => bl, hasStandardBrowserWebWorkerEnv: () => wl, navigator: () => _s, origin: () => xl });
const { toString: el } = Object.prototype, { getPrototypeOf: Hs } = Object, { iterator: sr, toStringTag: ba } = Symbol, Er = (ts = /* @__PURE__ */ Object.create(null), (t) => {
  const e = el.call(t);
  return ts[e] || (ts[e] = e.slice(8, -1).toLowerCase());
});
var ts;
const dt = (t) => (t = t.toLowerCase(), (e) => Er(e) === t), Zr = (t) => (e) => typeof e === t, { isArray: Jt } = Array, Xt = Zr("undefined");
function _n(t) {
  return t !== null && !Xt(t) && t.constructor !== null && !Xt(t.constructor) && Fe(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Oi = dt("ArrayBuffer"), tl = Zr("string"), Fe = Zr("function"), Ei = Zr("number"), pn = (t) => t !== null && typeof t == "object", Hn = (t) => {
  if (Er(t) !== "object") return !1;
  const e = Hs(t);
  return !(e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || ba in t || sr in t);
}, nl = dt("Date"), rl = dt("File"), sl = dt("Blob"), il = dt("FileList"), ol = dt("URLSearchParams"), [al, ul, cl, ll] = ["ReadableStream", "Request", "Response", "Headers"].map(dt);
function Sn(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t == null) return;
  let r, s;
  if (typeof t != "object" && (t = [t]), Jt(t)) for (r = 0, s = t.length; r < s; r++) e.call(null, t[r], r, t);
  else {
    if (_n(t)) return;
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let a;
    for (r = 0; r < o; r++) a = i[r], e.call(null, t[a], a, t);
  }
}
function Ti(t, e) {
  if (_n(t)) return null;
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r, s = n.length;
  for (; s-- > 0; ) if (r = n[s], e === r.toLowerCase()) return r;
  return null;
}
const Ut = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ji = (t) => !Xt(t) && t !== Ut, dl = (ns = typeof Uint8Array < "u" && Hs(Uint8Array), (t) => ns && t instanceof ns);
var ns;
const fl = dt("HTMLFormElement"), Ci = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), hl = dt("RegExp"), ki = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  Sn(n, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(t, r);
}, pl = dt("AsyncFunction"), wa = (Pi = typeof setImmediate == "function", Ai = Fe(Ut.postMessage), Pi ? setImmediate : Ai ? (rs = `axios@${Math.random()}`, Wn = [], Ut.addEventListener("message", ({ source: t, data: e }) => {
  t === Ut && e === rs && Wn.length && Wn.shift()();
}, !1), (t) => {
  Wn.push(t), Ut.postMessage(rs, "*");
}) : (t) => setTimeout(t));
var Pi, Ai, rs, Wn;
const ml = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ut) : typeof process < "u" && process.nextTick || wa, y = { isArray: Jt, isArrayBuffer: Oi, isBuffer: _n, isFormData: (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Fe(t.append) && ((e = Er(t)) === "formdata" || e === "object" && Fe(t.toString) && t.toString() === "[object FormData]"));
}, isArrayBufferView: function(t) {
  let e;
  return e = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && Oi(t.buffer), e;
}, isString: tl, isNumber: Ei, isBoolean: (t) => t === !0 || t === !1, isObject: pn, isPlainObject: Hn, isEmptyObject: (t) => {
  if (!pn(t) || _n(t)) return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: al, isRequest: ul, isResponse: cl, isHeaders: ll, isUndefined: Xt, isDate: nl, isFile: rl, isBlob: sl, isRegExp: hl, isFunction: Fe, isStream: (t) => pn(t) && Fe(t.pipe), isURLSearchParams: ol, isTypedArray: dl, isFileList: il, forEach: Sn, merge: function t() {
  const { caseless: e, skipUndefined: n } = ji(this) && this || {}, r = {}, s = (i, o) => {
    const a = e && Ti(r, o) || o;
    Hn(r[a]) && Hn(i) ? r[a] = t(r[a], i) : Hn(i) ? r[a] = t({}, i) : Jt(i) ? r[a] = i.slice() : n && Xt(i) || (r[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && Sn(arguments[i], s);
  return r;
}, extend: (t, e, n, { allOwnKeys: r } = {}) => (Sn(e, (s, i) => {
  n && Fe(s) ? t[i] = ya(s, n) : t[i] = s;
}, { allOwnKeys: r }), t), trim: (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), inherits: (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", { value: e.prototype }), n && Object.assign(t.prototype, n);
}, toFlatObject: (t, e, n, r) => {
  let s, i, o;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; ) o = s[i], r && !r(o, t, e) || a[o] || (e[o] = t[o], a[o] = !0);
    t = n !== !1 && Hs(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, kindOf: Er, kindOfTest: dt, endsWith: (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, toArray: (t) => {
  if (!t) return null;
  if (Jt(t)) return t;
  let e = t.length;
  if (!Ei(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; ) n[e] = t[e];
  return n;
}, forEachEntry: (t, e) => {
  const n = (t && t[sr]).call(t);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const s = r.value;
    e.call(t, s[0], s[1]);
  }
}, matchAll: (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; ) r.push(n);
  return r;
}, isHTMLForm: fl, hasOwnProperty: Ci, hasOwnProp: Ci, reduceDescriptors: ki, freezeMethods: (t) => {
  ki(t, (e, n) => {
    if (Fe(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const r = t[n];
    Fe(r) && (e.enumerable = !1, "writable" in e ? e.writable = !1 : e.set || (e.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (t, e) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return Jt(t) ? r(t) : r(String(t).split(e)), n;
}, toCamelCase: (t) => t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, n, r) {
  return n.toUpperCase() + r;
}), noop: () => {
}, toFiniteNumber: (t, e) => t != null && Number.isFinite(t = +t) ? t : e, findKey: Ti, global: Ut, isContextDefined: ji, isSpecCompliantForm: function(t) {
  return !!(t && Fe(t.append) && t[ba] === "FormData" && t[sr]);
}, toJSONObject: (t) => {
  const e = new Array(10), n = (r, s) => {
    if (pn(r)) {
      if (e.indexOf(r) >= 0) return;
      if (_n(r)) return r;
      if (!("toJSON" in r)) {
        e[s] = r;
        const i = Jt(r) ? [] : {};
        return Sn(r, (o, a) => {
          const u = n(o, s + 1);
          !Xt(u) && (i[a] = u);
        }), e[s] = void 0, i;
      }
    }
    return r;
  };
  return n(t, 0);
}, isAsyncFn: pl, isThenable: (t) => t && (pn(t) || Fe(t)) && Fe(t.then) && Fe(t.catch), setImmediate: wa, asap: ml, isIterable: (t) => t != null && Fe(t[sr]) };
function Qt(t, e, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
y.inherits(Qt, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: y.toJSONObject(this.config), code: this.code, status: this.status };
} });
const Ii = Qt.prototype, Li = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((t) => {
  Li[t] = { value: t };
}), Object.defineProperties(Qt, Li), Object.defineProperty(Ii, "isAxiosError", { value: !0 }), Qt.from = (t, e, n, r, s, i) => {
  const o = Object.create(Ii);
  y.toFlatObject(t, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = t && t.message ? t.message : "Error", u = e == null && t ? t.code : e;
  return Qt.call(o, a, u, n, r, s), t && o.cause == null && Object.defineProperty(o, "cause", { value: t, configurable: !0 }), o.name = t && t.name || "Error", i && Object.assign(o, i), o;
};
const Y = Qt;
function ss(t) {
  return y.isPlainObject(t) || y.isArray(t);
}
function xa(t) {
  return y.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Ui(t, e, n) {
  return t ? t.concat(e).map(function(r, s) {
    return r = xa(r), !n && s ? "[" + r + "]" : r;
  }).join(n ? "." : "") : e;
}
const gl = y.toFlatObject(y, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
}), Tr = function(t, e, n) {
  if (!y.isObject(t)) throw new TypeError("target must be an object");
  e = e || new FormData();
  const r = (n = y.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(f, h) {
    return !y.isUndefined(h[f]);
  })).metaTokens, s = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && y.isSpecCompliantForm(e);
  if (!y.isFunction(s)) throw new TypeError("visitor must be a function");
  function u(f) {
    if (f === null) return "";
    if (y.isDate(f)) return f.toISOString();
    if (y.isBoolean(f)) return f.toString();
    if (!a && y.isBlob(f)) throw new Y("Blob is not supported. Use a Buffer instead.");
    return y.isArrayBuffer(f) || y.isTypedArray(f) ? a && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, h, v) {
    let p = f;
    if (f && !v && typeof f == "object") {
      if (y.endsWith(h, "{}")) h = r ? h : h.slice(0, -2), f = JSON.stringify(f);
      else if (y.isArray(f) && function(R) {
        return y.isArray(R) && !R.some(ss);
      }(f) || (y.isFileList(f) || y.endsWith(h, "[]")) && (p = y.toArray(f))) return h = xa(h), p.forEach(function(R, J) {
        !y.isUndefined(R) && R !== null && e.append(o === !0 ? Ui([h], J, i) : o === null ? h : h + "[]", u(R));
      }), !1;
    }
    return !!ss(f) || (e.append(Ui(v, h, i), u(f)), !1);
  }
  const l = [], d = Object.assign(gl, { defaultVisitor: c, convertValue: u, isVisitable: ss });
  if (!y.isObject(t)) throw new TypeError("data must be an object");
  return function f(h, v) {
    if (!y.isUndefined(h)) {
      if (l.indexOf(h) !== -1) throw Error("Circular reference detected in " + v.join("."));
      l.push(h), y.forEach(h, function(p, R) {
        (!(y.isUndefined(p) || p === null) && s.call(e, p, y.isString(R) ? R.trim() : R, v, d)) === !0 && f(p, v ? v.concat(R) : [R]);
      }), l.pop();
    }
  }(t), e;
};
function Ni(t) {
  const e = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function Sa(t, e) {
  this._pairs = [], t && Tr(t, this, e);
}
const Di = Sa.prototype;
Di.append = function(t, e) {
  this._pairs.push([t, e]);
}, Di.toString = function(t) {
  const e = t ? function(n) {
    return t.call(this, n, Ni);
  } : Ni;
  return this._pairs.map(function(n) {
    return e(n[0]) + "=" + e(n[1]);
  }, "").join("&");
};
const Ra = Sa;
function vl(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function _a(t, e, n) {
  if (!e) return t;
  const r = n && n.encode || vl;
  y.isFunction(n) && (n = { serialize: n });
  const s = n && n.serialize;
  let i;
  if (i = s ? s(e, n) : y.isURLSearchParams(e) ? e.toString() : new Ra(e, n).toString(r), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
const $i = class {
  constructor() {
    this.handlers = [];
  }
  use(e, n, r) {
    return this.handlers.push({ fulfilled: e, rejected: n, synchronous: !!r && r.synchronous, runWhen: r ? r.runWhen : null }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    y.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}, Oa = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, yl = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Ra, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, Ws = typeof window < "u" && typeof document < "u", _s = typeof navigator == "object" && navigator || void 0, bl = Ws && (!_s || ["ReactNative", "NativeScript", "NS"].indexOf(_s.product) < 0), wl = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", xl = Ws && window.location.href || "http://localhost", Ie = { ...Rs, ...yl }, Ea = function(t) {
  function e(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && y.isArray(s) ? s.length : o, u ? (y.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : (s[o] && y.isObject(s[o]) || (s[o] = []), e(n, r, s[o], i) && y.isArray(s[o]) && (s[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let f;
      const h = d.length;
      let v;
      for (f = 0; f < h; f++) v = d[f], l[v] = c[v];
      return l;
    }(s[o])), !a);
  }
  if (y.isFormData(t) && y.isFunction(t.entries)) {
    const n = {};
    return y.forEachEntry(t, (r, s) => {
      e(function(i) {
        return y.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(r), s, n, 0);
    }), n;
  }
  return null;
}, Js = { transitional: Oa, adapter: ["xhr", "http", "fetch"], transformRequest: [function(t, e) {
  const n = e.getContentType() || "", r = n.indexOf("application/json") > -1, s = y.isObject(t);
  if (s && y.isHTMLForm(t) && (t = new FormData(t)), y.isFormData(t)) return r ? JSON.stringify(Ea(t)) : t;
  if (y.isArrayBuffer(t) || y.isBuffer(t) || y.isStream(t) || y.isFile(t) || y.isBlob(t) || y.isReadableStream(t)) return t;
  if (y.isArrayBufferView(t)) return t.buffer;
  if (y.isURLSearchParams(t)) return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
  let i;
  if (s) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return Tr(o, new Ie.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return Ie.isNode && y.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(t, this.formSerializer).toString();
    if ((i = y.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return Tr(i ? { "files[]": t } : t, o && new o(), this.formSerializer);
    }
  }
  return s || r ? (e.setContentType("application/json", !1), function(o) {
    if (y.isString(o)) try {
      return (0, JSON.parse)(o), y.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(t)) : t;
}], transformResponse: [function(t) {
  const e = this.transitional || Js.transitional, n = e && e.forcedJSONParsing, r = this.responseType === "json";
  if (y.isResponse(t) || y.isReadableStream(t)) return t;
  if (t && y.isString(t) && (n && !this.responseType || r)) {
    const s = !(e && e.silentJSONParsing) && r;
    try {
      return JSON.parse(t, this.parseReviver);
    } catch (i) {
      if (s)
        throw i.name === "SyntaxError" ? Y.from(i, Y.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return t;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Ie.classes.FormData, Blob: Ie.classes.Blob }, validateStatus: function(t) {
  return t >= 200 && t < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
y.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Js.headers[t] = {};
});
const Vs = Js, Sl = y.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Fi = Symbol("internals");
function mn(t) {
  return t && String(t).trim().toLowerCase();
}
function ir(t) {
  return t === !1 || t == null ? t : y.isArray(t) ? t.map(ir) : String(t);
}
function is(t, e, n, r, s) {
  return y.isFunction(r) ? r.call(this, e, n) : (s && (e = n), y.isString(e) ? y.isString(r) ? e.indexOf(r) !== -1 : y.isRegExp(r) ? r.test(e) : void 0 : void 0);
}
let or = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const s = this;
    function i(a, u, c) {
      const l = mn(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = y.findKey(s, l);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || u] = ir(a));
    }
    const o = (a, u) => y.forEach(a, (c, l) => i(c, l, u));
    if (y.isPlainObject(e) || e instanceof this.constructor) o(e, n);
    else if (y.isString(e) && (e = e.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(f) {
        d = f.indexOf(":"), c = f.substring(0, d).trim().toLowerCase(), l = f.substring(d + 1).trim(), !c || u[c] && Sl[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(e), n);
    else if (y.isObject(e) && y.isIterable(e)) {
      let a, u, c = {};
      for (const l of e) {
        if (!y.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? y.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else e != null && i(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = mn(e)) {
      const r = y.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!n) return s;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(s);
        if (y.isFunction(n)) return n.call(this, s, r);
        if (y.isRegExp(n)) return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = mn(e)) {
      const r = y.findKey(this, e);
      return !(!r || this[r] === void 0 || n && !is(0, this[r], r, n));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = mn(o)) {
        const a = y.findKey(r, o);
        !a || n && !is(0, r[a], a, n) || (delete r[a], s = !0);
      }
    }
    return y.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      e && !is(0, this[i], i, e, !0) || (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const n = this, r = {};
    return y.forEach(this, (s, i) => {
      const o = y.findKey(r, i);
      if (o) return n[o] = ir(s), void delete n[i];
      const a = e ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = ir(s), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return y.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = e && y.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const n = (this[Fi] = this[Fi] = { accessors: {} }).accessors, r = this.prototype;
    function s(i) {
      const o = mn(i);
      n[o] || (function(a, u) {
        const c = y.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, f, h) {
            return this[l].call(this, u, d, f, h);
          }, configurable: !0 });
        });
      }(r, i), n[o] = !0);
    }
    return y.isArray(e) ? e.forEach(s) : s(e), this;
  }
};
or.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), y.reduceDescriptors(or.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return { get: () => t, set(r) {
    this[n] = r;
  } };
}), y.freezeMethods(or);
const ct = or;
function os(t, e) {
  const n = this || Vs, r = e || n, s = ct.from(r.headers);
  let i = r.data;
  return y.forEach(t, function(o) {
    i = o.call(n, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function Ta(t) {
  return !(!t || !t.__CANCEL__);
}
function ja(t, e, n) {
  Y.call(this, t ?? "canceled", Y.ERR_CANCELED, e, n), this.name = "CanceledError";
}
y.inherits(ja, Y, { __CANCEL__: !0 });
const Nn = ja;
function Ca(t, e, n) {
  const r = n.config.validateStatus;
  n.status && r && !r(n.status) ? e(new Y("Request failed with status code " + n.status, [Y.ERR_BAD_REQUEST, Y.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : t(n);
}
const jr = (t, e, n = 3) => {
  let r = 0;
  const s = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(f) {
      const h = Date.now(), v = u[d];
      c || (c = h), a[l] = f, u[l] = h;
      let p = d, R = 0;
      for (; p !== l; ) R += a[p++], p %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), h - c < o) return;
      const J = v && h - v;
      return J ? Math.round(1e3 * R / J) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (f, h = Date.now()) => {
      c = h, a = null, u && (clearTimeout(u), u = null), i(...f);
    };
    return [(...f) => {
      const h = Date.now(), v = h - c;
      v >= l ? d(f, h) : (a = f, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - v)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - r, c = s(u);
    r = o, t({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [e ? "download" : "upload"]: !0 });
  }, n);
}, Bi = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({ lengthComputable: n, total: t, loaded: r }), e[1]];
}, Mi = (t) => (...e) => y.asap(() => t(...e)), Rl = Ie.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, Ie.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(new URL(Ie.origin), Ie.navigator && /(msie|trident)/i.test(Ie.navigator.userAgent)) : () => !0, _l = Ie.hasStandardBrowserEnv ? { write(t, e, n, r, s, i, o) {
  if (typeof document > "u") return;
  const a = [`${t}=${encodeURIComponent(e)}`];
  y.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), y.isString(r) && a.push(`path=${r}`), y.isString(s) && a.push(`domain=${s}`), i === !0 && a.push("secure"), y.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(t) {
  if (typeof document > "u") return null;
  const e = document.cookie.match(new RegExp("(?:^|; )" + t + "=([^;]*)"));
  return e ? decodeURIComponent(e[1]) : null;
}, remove(t) {
  this.write(t, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function ka(t, e, n) {
  let r = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  return t && (r || n == 0) ? function(s, i) {
    return i ? s.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : s;
  }(t, e) : e;
}
const zi = (t) => t instanceof ct ? { ...t } : t;
function Bt(t, e) {
  e = e || {};
  const n = {};
  function r(c, l, d, f) {
    return y.isPlainObject(c) && y.isPlainObject(l) ? y.merge.call({ caseless: f }, c, l) : y.isPlainObject(l) ? y.merge({}, l) : y.isArray(l) ? l.slice() : l;
  }
  function s(c, l, d, f) {
    return y.isUndefined(l) ? y.isUndefined(c) ? void 0 : r(void 0, c, 0, f) : r(c, l, 0, f);
  }
  function i(c, l) {
    if (!y.isUndefined(l)) return r(void 0, l);
  }
  function o(c, l) {
    return y.isUndefined(l) ? y.isUndefined(c) ? void 0 : r(void 0, c) : r(void 0, l);
  }
  function a(c, l, d) {
    return d in e ? r(c, l) : d in t ? r(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => s(zi(c), zi(l), 0, !0) };
  return y.forEach(Object.keys({ ...t, ...e }), function(c) {
    const l = u[c] || s, d = l(t[c], e[c], c);
    y.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const Pa = (t) => {
  const e = Bt({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = e;
  if (e.headers = o = ct.from(o), e.url = _a(ka(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), y.isFormData(n)) {
    if (Ie.hasStandardBrowserEnv || Ie.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (y.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (Ie.hasStandardBrowserEnv && (r && y.isFunction(r) && (r = r(e)), r || r !== !1 && Rl(e.url))) {
    const u = s && i && _l.read(i);
    u && o.set(s, u);
  }
  return e;
}, Ol = typeof XMLHttpRequest < "u" && function(t) {
  return new Promise(function(e, n) {
    const r = Pa(t);
    let s = r.data;
    const i = ct.from(r.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: f, onDownloadProgress: h } = r;
    function v() {
      c && c(), l && l(), r.cancelToken && r.cancelToken.unsubscribe(o), r.signal && r.signal.removeEventListener("abort", o);
    }
    let p = new XMLHttpRequest();
    function R() {
      if (!p) return;
      const T = ct.from("getAllResponseHeaders" in p && p.getAllResponseHeaders());
      Ca(function(W) {
        e(W), v();
      }, function(W) {
        n(W), v();
      }, { data: d && d !== "text" && d !== "json" ? p.response : p.responseText, status: p.status, statusText: p.statusText, headers: T, config: t, request: p }), p = null;
    }
    p.open(r.method.toUpperCase(), r.url, !0), p.timeout = r.timeout, "onloadend" in p ? p.onloadend = R : p.onreadystatechange = function() {
      p && p.readyState === 4 && (p.status !== 0 || p.responseURL && p.responseURL.indexOf("file:") === 0) && setTimeout(R);
    }, p.onabort = function() {
      p && (n(new Y("Request aborted", Y.ECONNABORTED, t, p)), p = null);
    }, p.onerror = function(T) {
      const W = T && T.message ? T.message : "Network Error", M = new Y(W, Y.ERR_NETWORK, t, p);
      M.event = T || null, n(M), p = null;
    }, p.ontimeout = function() {
      let T = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const W = r.transitional || Oa;
      r.timeoutErrorMessage && (T = r.timeoutErrorMessage), n(new Y(T, W.clarifyTimeoutError ? Y.ETIMEDOUT : Y.ECONNABORTED, t, p)), p = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in p && y.forEach(i.toJSON(), function(T, W) {
      p.setRequestHeader(W, T);
    }), y.isUndefined(r.withCredentials) || (p.withCredentials = !!r.withCredentials), d && d !== "json" && (p.responseType = r.responseType), h && ([u, l] = jr(h, !0), p.addEventListener("progress", u)), f && p.upload && ([a, c] = jr(f), p.upload.addEventListener("progress", a), p.upload.addEventListener("loadend", c)), (r.cancelToken || r.signal) && (o = (T) => {
      p && (n(!T || T.type ? new Nn(null, t, p) : T), p.abort(), p = null);
    }, r.cancelToken && r.cancelToken.subscribe(o), r.signal && (r.signal.aborted ? o() : r.signal.addEventListener("abort", o)));
    const J = function(T) {
      const W = /^([-+\w]{1,25})(:?\/\/|:)/.exec(T);
      return W && W[1] || "";
    }(r.url);
    J && Ie.protocols.indexOf(J) === -1 ? n(new Y("Unsupported protocol " + J + ":", Y.ERR_BAD_REQUEST, t)) : p.send(s || null);
  });
}, El = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r, s = new AbortController();
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof Y ? l : new Nn(l instanceof Error ? l.message : l));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new Y(`timeout ${e} of ms exceeded`, Y.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = s;
    return u.unsubscribe = () => y.asap(a), u;
  }
}, Tl = function* (t, e) {
  let n = t.byteLength;
  if (n < e) return void (yield t);
  let r, s = 0;
  for (; s < n; ) r = s + e, yield t.slice(s, r), s = r;
}, qi = (t, e, n, r) => {
  const s = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const f = d.getReader();
      try {
        for (; ; ) {
          const { done: h, value: v } = await f.read();
          if (h) break;
          yield v;
        }
      } finally {
        await f.cancel();
      }
    }(u)) yield* Tl(l, c);
  }(t, e);
  let i, o = 0, a = (u) => {
    i || (i = !0, r && r(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await s.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let f = o += d;
        n(f);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), s.return()) }, { highWaterMark: 2 });
}, { isFunction: Jn } = y, jl = (({ Request: t, Response: e }) => ({ Request: t, Response: e }))(y.global), { ReadableStream: Zi, TextEncoder: Hi } = y.global, Wi = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Cl = (t) => {
  t = y.merge.call({ skipUndefined: !0 }, jl, t);
  const { fetch: e, Request: n, Response: r } = t, s = e ? Jn(e) : typeof fetch == "function", i = Jn(n), o = Jn(r);
  if (!s) return !1;
  const a = s && Jn(Zi), u = s && (typeof Hi == "function" ? (c = new Hi(), (h) => c.encode(h)) : async (h) => new Uint8Array(await new n(h).arrayBuffer()));
  var c;
  const l = i && a && Wi(() => {
    let h = !1;
    const v = new n(Ie.origin, { body: new Zi(), method: "POST", get duplex() {
      return h = !0, "half";
    } }).headers.has("Content-Type");
    return h && !v;
  }), d = o && a && Wi(() => y.isReadableStream(new r("").body)), f = { stream: d && ((h) => h.body) };
  return s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !f[h] && (f[h] = (v, p) => {
      let R = v && v[h];
      if (R) return R.call(v);
      throw new Y(`Response type '${h}' is not supported`, Y.ERR_NOT_SUPPORT, p);
    });
  }), async (h) => {
    let { url: v, method: p, data: R, signal: J, cancelToken: T, timeout: W, onDownloadProgress: M, onUploadProgress: ne, responseType: K, headers: je, withCredentials: me = "same-origin", fetchOptions: Me } = Pa(h), Qe = e || fetch;
    K = K ? (K + "").toLowerCase() : "text";
    let le = El([J, T && T.toAbortSignal()], W), Ce = null;
    const ce = le && le.unsubscribe && (() => {
      le.unsubscribe();
    });
    let se;
    try {
      if (ne && l && p !== "get" && p !== "head" && (se = await (async (he, pe) => {
        const ke = y.toFiniteNumber(he.getContentLength());
        return ke ?? (async (V) => V == null ? 0 : y.isBlob(V) ? V.size : y.isSpecCompliantForm(V) ? (await new n(Ie.origin, { method: "POST", body: V }).arrayBuffer()).byteLength : y.isArrayBufferView(V) || y.isArrayBuffer(V) ? V.byteLength : (y.isURLSearchParams(V) && (V += ""), y.isString(V) ? (await u(V)).byteLength : void 0))(pe);
      })(je, R)) !== 0) {
        let he, pe = new n(v, { method: "POST", body: R, duplex: "half" });
        if (y.isFormData(R) && (he = pe.headers.get("content-type")) && je.setContentType(he), pe.body) {
          const [ke, V] = Bi(se, jr(Mi(ne)));
          R = qi(pe.body, 65536, ke, V);
        }
      }
      y.isString(me) || (me = me ? "include" : "omit");
      const oe = i && "credentials" in n.prototype, qe = { ...Me, signal: le, method: p.toUpperCase(), headers: je.normalize().toJSON(), body: R, duplex: "half", credentials: oe ? me : void 0 };
      Ce = i && new n(v, qe);
      let ye = await (i ? Qe(Ce, Me) : Qe(v, qe));
      const ht = d && (K === "stream" || K === "response");
      if (d && (M || ht && ce)) {
        const he = {};
        ["status", "statusText", "headers"].forEach((de) => {
          he[de] = ye[de];
        });
        const pe = y.toFiniteNumber(ye.headers.get("content-length")), [ke, V] = M && Bi(pe, jr(Mi(M), !0)) || [];
        ye = new r(qi(ye.body, 65536, ke, () => {
          V && V(), ce && ce();
        }), he);
      }
      K = K || "text";
      let xt = await f[y.findKey(f, K) || "text"](ye, h);
      return !ht && ce && ce(), await new Promise((he, pe) => {
        Ca(he, pe, { data: xt, headers: ct.from(ye.headers), status: ye.status, statusText: ye.statusText, config: h, request: Ce });
      });
    } catch (oe) {
      throw ce && ce(), oe && oe.name === "TypeError" && /Load failed|fetch/i.test(oe.message) ? Object.assign(new Y("Network Error", Y.ERR_NETWORK, h, Ce), { cause: oe.cause || oe }) : Y.from(oe, oe && oe.code, h, Ce);
    }
  };
}, kl = /* @__PURE__ */ new Map(), Ji = (t) => {
  let e = t && t.env || {};
  const { fetch: n, Request: r, Response: s } = e, i = [r, s, n];
  let o, a, u = i.length, c = kl;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : Cl(e)), c = a;
  return a;
}, Aa = (Ji(), { http: null, xhr: Ol, fetch: { get: Ji } });
y.forEach(Aa, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Vi = (t) => `- ${t}`, Pl = (t) => y.isFunction(t) || t === null || t === !1, Ia = function(t, e) {
  t = y.isArray(t) ? t : [t];
  const { length: n } = t;
  let r, s;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (r = t[o], s = r, !Pl(r) && (s = Aa[(a = String(r)).toLowerCase()], s === void 0)) throw new Y(`Unknown adapter '${a}'`);
    if (s && (y.isFunction(s) || (s = s.get(e)))) break;
    i[a || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(Vi).join(`
`) : " " + Vi(o[0]) : "as no adapter specified";
    throw new Y("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return s;
};
function as(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new Nn(null, t);
}
function Gi(t) {
  return as(t), t.headers = ct.from(t.headers), t.data = os.call(t, t.transformRequest), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Ia(t.adapter || Vs.adapter, t)(t).then(function(e) {
    return as(t), e.data = os.call(t, t.transformResponse, e), e.headers = ct.from(e.headers), e;
  }, function(e) {
    return Ta(e) || (as(t), e && e.response && (e.response.data = os.call(t, t.transformResponse, e.response), e.response.headers = ct.from(e.response.headers))), Promise.reject(e);
  });
}
const La = "1.13.2", Cr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Cr[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Ki = {};
Cr.transitional = function(t, e, n) {
  function r(s, i) {
    return "[Axios v" + La + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, o) => {
    if (t === !1) throw new Y(r(i, " has been removed" + (e ? " in " + e : "")), Y.ERR_DEPRECATED);
    return e && !Ki[i] && (Ki[i] = !0, console.warn(r(i, " has been deprecated since v" + e + " and will be removed in the near future"))), !t || t(s, i, o);
  };
}, Cr.spelling = function(t) {
  return (e, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
const ar = { assertOptions: function(t, e, n) {
  if (typeof t != "object") throw new Y("options must be an object", Y.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = e[i];
    if (o) {
      const a = t[i], u = a === void 0 || o(a, i, t);
      if (u !== !0) throw new Y("option " + i + " must be " + u, Y.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new Y("Unknown option " + i, Y.ERR_BAD_OPTION);
  }
}, validators: Cr }, pt = ar.validators;
let ur = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = { request: new $i(), response: new $i() };
  }
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}).url = e : n = e || {}, n = Bt(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && ar.assertOptions(r, { silentJSONParsing: pt.transitional(pt.boolean), forcedJSONParsing: pt.transitional(pt.boolean), clarifyTimeoutError: pt.transitional(pt.boolean) }, !1), s != null && (y.isFunction(s) ? n.paramsSerializer = { serialize: s } : ar.assertOptions(s, { encode: pt.function, serialize: pt.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), ar.assertOptions(n, { baseUrl: pt.spelling("baseURL"), withXsrfToken: pt.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && y.merge(i.common, i[n.method]);
    i && y.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (v) => {
      delete i[v];
    }), n.headers = ct.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (u = u && v.synchronous, a.unshift(v.fulfilled, v.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(v) {
      c.push(v.fulfilled, v.rejected);
    });
    let d, f = 0;
    if (!u) {
      const v = [Gi.bind(this), void 0];
      for (v.unshift(...a), v.push(...c), d = v.length, l = Promise.resolve(n); f < d; ) l = l.then(v[f++], v[f++]);
      return l;
    }
    d = a.length;
    let h = n;
    for (; f < d; ) {
      const v = a[f++], p = a[f++];
      try {
        h = v(h);
      } catch (R) {
        p.call(this, R);
        break;
      }
    }
    try {
      l = Gi.call(this, h);
    } catch (v) {
      return Promise.reject(v);
    }
    for (f = 0, d = c.length; f < d; ) l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(e) {
    return _a(ka((e = Bt(this.defaults, e)).baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer);
  }
};
y.forEach(["delete", "get", "head", "options"], function(t) {
  ur.prototype[t] = function(e, n) {
    return this.request(Bt(n || {}, { method: t, url: e, data: (n || {}).data }));
  };
}), y.forEach(["post", "put", "patch"], function(t) {
  function e(n) {
    return function(r, s, i) {
      return this.request(Bt(i || {}, { method: t, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: r, data: s }));
    };
  }
  ur.prototype[t] = e(), ur.prototype[t + "Form"] = e(!0);
});
const cr = ur;
let Al = class Ua {
  constructor(e) {
    if (typeof e != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; ) r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(s, i, o) {
      r.reason || (r.reason = new Nn(s, i, o), n(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(e) {
    this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  static source() {
    let e;
    return { token: new Ua(function(n) {
      e = n;
    }), cancel: e };
  }
};
const Il = Al, Os = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(Os).forEach(([t, e]) => {
  Os[e] = t;
});
const Ll = Os, Oe = function t(e) {
  const n = new cr(e), r = ya(cr.prototype.request, n);
  return y.extend(r, cr.prototype, n, { allOwnKeys: !0 }), y.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(s) {
    return t(Bt(e, s));
  }, r;
}(Vs);
Oe.Axios = cr, Oe.CanceledError = Nn, Oe.CancelToken = Il, Oe.isCancel = Ta, Oe.VERSION = La, Oe.toFormData = Tr, Oe.AxiosError = Y, Oe.Cancel = Oe.CanceledError, Oe.all = function(t) {
  return Promise.all(t);
}, Oe.spread = function(t) {
  return function(e) {
    return t.apply(null, e);
  };
}, Oe.isAxiosError = function(t) {
  return y.isObject(t) && t.isAxiosError === !0;
}, Oe.mergeConfig = Bt, Oe.AxiosHeaders = ct, Oe.formToJSON = (t) => Ea(y.isHTMLForm(t) ? new FormData(t) : t), Oe.getAdapter = Ia, Oe.HttpStatusCode = Ll, Oe.default = Oe;
const He = Oe;
function Na(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Es(t, e, n) {
  return Es = Gs() ? Reflect.construct : function(r, s, i) {
    var o = [null];
    o.push.apply(o, s);
    var a = new (Function.bind.apply(r, o))();
    return i && kn(a, i.prototype), a;
  }, Es.apply(null, arguments);
}
function lr(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Cn(t) {
  return Cn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Cn(t);
}
function kn(t, e) {
  return kn = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, kn(t, e);
}
function Ts(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Ts = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1)) return n;
    var r;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(n)) return e.get(n);
      e.set(n, s);
    }
    function s() {
      return Es(n, arguments, Cn(this).constructor);
    }
    return s.prototype = Object.create(n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), kn(s, n);
  }, Ts(t);
}
function Gs() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Gs = function() {
    return !!t;
  })();
}
var We = "http://localhost".replace(/\/+$/, ""), Dn = function t(e) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : We, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : He;
  Na(this, t), lr(this, "basePath", void 0), lr(this, "axios", void 0), lr(this, "configuration", void 0), this.basePath = r, this.axios = s, e && (this.configuration = e, this.basePath = (n = e.basePath) !== null && n !== void 0 ? n : r);
}, Ul = function() {
  function t(e, n) {
    var r;
    return Na(this, t), lr(r = function(s, i, o) {
      return i = Cn(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(s, Gs() ? Reflect.construct(i, o || [], Cn(s).constructor) : i.apply(s, o));
    }(this, t, [n]), "field", void 0), r.field = e, r.name = "RequiredError", r;
  }
  return function(e, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), n && kn(e, n);
  }(t, Ts(Error)), t;
}(), st = {};
function Yi(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function Nl(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var it = "https://example.com", sn = function(t, e, n) {
  if (n == null) throw new Ul(e, "Required parameter ".concat(e, " was null or undefined when calling ").concat(t, "."));
}, Nt = function(t, e) {
  return (n = function() {
    var r, s;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = f(0), d.throw = f(1), d.return = f(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function f(h) {
        return function(v) {
          return function(p) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, p[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & p[0] ? u.return : p[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, p[1])).done) return c;
              switch (u = 0, c && (p = [2 & p[0], c.value]), p[0]) {
                case 0:
                case 1:
                  c = p;
                  break;
                case 4:
                  return l.label++, { value: p[1], done: !1 };
                case 5:
                  l.label++, u = p[1], p = [0];
                  continue;
                case 7:
                  p = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || p[0] !== 6 && p[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (p[0] === 3 && (!c || p[1] > c[0] && p[1] < c[3])) {
                    l.label = p[1];
                    break;
                  }
                  if (p[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = p;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(p);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              p = o.call(i, l);
            } catch (R) {
              p = [6, R], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & p[0]) throw p[1];
            return { value: p[0] ? p[1] : void 0, done: !0 };
          }([h, v]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return e && e.accessToken ? typeof e.accessToken != "function" ? [3, 2] : [4, e.accessToken()] : [3, 5];
        case 1:
          return s = i.sent(), [3, 4];
        case 2:
          return [4, e.accessToken];
        case 3:
          s = i.sent(), i.label = 4;
        case 4:
          r = s, t.Authorization = "Bearer " + r, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var r = this, s = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(r, s);
      function u(l) {
        Yi(a, i, o, u, c, "next", l);
      }
      function c(l) {
        Yi(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function js(t, e) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  e != null && ((e === void 0 ? "undefined" : (n = e) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(e) ? e.forEach(function(s) {
    return js(t, s, r);
  }) : Object.keys(e).forEach(function(s) {
    return js(t, e[s], "".concat(r).concat(r !== "" ? "." : "").concat(s));
  }) : t.has(r) ? t.append(r, e) : t.set(r, e));
}
var ot = function(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
  var s = new URLSearchParams(t.search);
  js(s, n), t.search = s.toString();
}, Ks = function(t, e, n) {
  var r = typeof t != "string";
  return (r && n && n.isJsonMime ? n.isJsonMime(e.headers["Content-Type"]) : r) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, at = function(t) {
  return t.pathname + t.search + t.hash;
}, ut = function(t, e, n, r) {
  return function() {
    var s, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d] != null ? arguments[d] : {}, h = Object.keys(f);
        typeof Object.getOwnPropertySymbols == "function" && (h = h.concat(Object.getOwnPropertySymbols(f).filter(function(v) {
          return Object.getOwnPropertyDescriptor(f, v).enumerable;
        }))), h.forEach(function(v) {
          Nl(l, v, f[v]);
        });
      }
      return l;
    }({}, t.options), o = (o = { url: (a.defaults.baseURL ? "" : (s = r == null ? void 0 : r.basePath) !== null && s !== void 0 ? s : u) + t.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(l);
        d.push.apply(d, f);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function Xi(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function we(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, s) {
      var i = t.apply(e, n);
      function o(u) {
        Xi(i, r, s, o, a, "next", u);
      }
      function a(u) {
        Xi(i, r, s, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function $n(t, e, n) {
  return e = kr(e), function(r, s) {
    return !s || ((i = s) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof s != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(r) : s;
    var i;
  }(t, Da() ? Reflect.construct(e, n || [], kr(t).constructor) : e.apply(t, n));
}
function Fn(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Dl(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Bn(t, e, n) {
  return e && Dl(t.prototype, e), t;
}
function $l(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function kr(t) {
  return kr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, kr(t);
}
function Mn(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Cs(t, e);
}
function be(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      $l(t, s, n[s]);
    });
  }
  return t;
}
function Cs(t, e) {
  return Cs = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Cs(t, e);
}
function Da() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Da = function() {
    return !!t;
  })();
}
function xe(t, e) {
  var n, r, s, i = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, r && (s = 2 & l[0] ? r.return : l[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, l[1])).done) return s;
          switch (r = 0, s && (l = [2 & l[0], s.value]), l[0]) {
            case 0:
            case 1:
              s = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, r = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((s = (s = i.trys).length > 0 && s[s.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < s[1]) {
                i.label = s[1], s = l;
                break;
              }
              if (s && i.label < s[2]) {
                i.label = s[2], i.ops.push(l);
                break;
              }
              s[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = e.call(t, i);
        } catch (d) {
          l = [6, d], r = 0;
        } finally {
          n = s = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var Fl = function(t) {
  return { publicScoreSheetsConfigGet: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return we(function() {
      var n, r, s, i, o;
      return xe(this, function(a) {
        return n = new URL("/public/score-sheets/config", it), t && (r = t.baseOptions), s = be({ method: "GET" }, r, e), i = {}, ot(n, {}), o = r && r.headers ? r.headers : {}, s.headers = be({}, i, o, e.headers), [2, { url: at(n), options: s }];
      });
    })();
  }, publicScoreSheetsRequestPost: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return we(function() {
      var r, s, i, o, a, u;
      return xe(this, function(c) {
        return sn("publicScoreSheetsRequestPost", "publicScoreSheetsRequestPostRequest", e), r = new URL("/public/score-sheets/request", it), t && (s = t.baseOptions), i = be({ method: "POST" }, s, n), a = {}, (o = {})["Content-Type"] = "application/json", ot(r, a), u = s && s.headers ? s.headers : {}, i.headers = be({}, o, u, n.headers), i.data = Ks(e, i, t), [2, { url: at(r), options: i }];
      });
    })();
  }, publicScoreSheetsTokenGet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return we(function() {
      var r, s, i, o, a, u;
      return xe(this, function(c) {
        return sn("publicScoreSheetsTokenGet", "token", e), r = "/public/score-sheets/{token}".replace("{token}", encodeURIComponent(String(e))), s = new URL(r, it), t && (i = t.baseOptions), o = be({ method: "GET" }, i, n), a = {}, ot(s, {}), u = i && i.headers ? i.headers : {}, o.headers = be({}, a, u, n.headers), [2, { url: at(s), options: o }];
      });
    })();
  } };
}, us = function(t) {
  var e = Fl(t);
  return { publicScoreSheetsConfigGet: function(n) {
    return we(function() {
      var r, s, i, o, a, u;
      return xe(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.publicScoreSheetsConfigGet(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = st["DefaultApi.publicScoreSheetsConfigGet"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return ut(i, He, We, t)(l, u || d);
            }];
        }
      });
    })();
  }, publicScoreSheetsRequestPost: function(n, r) {
    return we(function() {
      var s, i, o, a, u, c;
      return xe(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.publicScoreSheetsRequestPost(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = st["DefaultApi.publicScoreSheetsRequestPost"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return ut(o, He, We, t)(d, c || f);
            }];
        }
      });
    })();
  }, publicScoreSheetsTokenGet: function(n, r) {
    return we(function() {
      var s, i, o, a, u, c;
      return xe(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.publicScoreSheetsTokenGet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = st["DefaultApi.publicScoreSheetsTokenGet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return ut(o, He, We, t)(d, c || f);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Fn(this, e), $n(this, e, arguments);
  }
  return Mn(e, t), Bn(e, [{ key: "publicScoreSheetsConfigGet", value: function(n) {
    var r = this;
    return us(this.configuration).publicScoreSheetsConfigGet(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }, { key: "publicScoreSheetsRequestPost", value: function(n, r) {
    var s = this;
    return us(this.configuration).publicScoreSheetsRequestPost(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "publicScoreSheetsTokenGet", value: function(n, r) {
    var s = this;
    return us(this.configuration).publicScoreSheetsTokenGet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
})(Dn);
var Bl = function(t) {
  return { getHealth: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return we(function() {
      var n, r, s, i, o;
      return xe(this, function(a) {
        return n = new URL("/health", it), t && (r = t.baseOptions), s = be({ method: "GET" }, r, e), i = {}, ot(n, {}), o = r && r.headers ? r.headers : {}, s.headers = be({}, i, o, e.headers), [2, { url: at(n), options: s }];
      });
    })();
  } };
}, Ml = function(t) {
  var e = Bl(t);
  return { getHealth: function(n) {
    return we(function() {
      var r, s, i, o, a, u;
      return xe(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = st["HealthApi.getHealth"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return ut(i, He, We, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Fn(this, e), $n(this, e, arguments);
  }
  return Mn(e, t), Bn(e, [{ key: "getHealth", value: function(n) {
    var r = this;
    return Ml(this.configuration).getHealth(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(Dn);
var zl = function(t) {
  return { createReportRun: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return we(function() {
      var s, i, o, a, u, c, l;
      return xe(this, function(d) {
        switch (d.label) {
          case 0:
            return sn("createReportRun", "id", e), s = "/reports/{id}/runs".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, it), t && (o = t.baseOptions), a = be({ method: "POST" }, o, r), c = {}, [4, Nt(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ot(i, c), l = o && o.headers ? o.headers : {}, a.headers = be({}, u, l, r.headers), a.data = Ks(n, a, t), [2, { url: at(i), options: a }];
        }
      });
    })();
  }, listReports: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return we(function() {
      var r, s, i, o, a, u;
      return xe(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/reports", it), t && (s = t.baseOptions), i = be({ method: "GET" }, s, n), a = {}, [4, Nt(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.domain = e), ot(r, a), u = s && s.headers ? s.headers : {}, i.headers = be({}, o, u, n.headers), [2, { url: at(r), options: i }];
        }
      });
    })();
  } };
}, Qi = function(t) {
  var e = zl(t);
  return { createReportRun: function(n, r, s) {
    return we(function() {
      var i, o, a, u, c, l;
      return xe(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.createReportRun(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = st["ReportsApi.createReportRun"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return ut(a, He, We, t)(f, l || h);
            }];
        }
      });
    })();
  }, listReports: function(n, r) {
    return we(function() {
      var s, i, o, a, u, c;
      return xe(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listReports(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = st["ReportsApi.listReports"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return ut(o, He, We, t)(d, c || f);
            }];
        }
      });
    })();
  } };
}, ql = function(t) {
  function e() {
    return Fn(this, e), $n(this, e, arguments);
  }
  return Mn(e, t), Bn(e, [{ key: "createReportRun", value: function(n, r, s) {
    var i = this;
    return Qi(this.configuration).createReportRun(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listReports", value: function(n, r) {
    var s = this;
    return Qi(this.configuration).listReports(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
}(Dn), Zl = function(t) {
  return { resendScoreSheet: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return we(function() {
      var s, i, o, a, u, c, l;
      return xe(this, function(d) {
        switch (d.label) {
          case 0:
            return sn("resendScoreSheet", "rideId", e), s = "/score-sheets/rides/{rideId}/resend".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, it), t && (o = t.baseOptions), a = be({ method: "POST" }, o, r), c = {}, [4, Nt(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ot(i, c), l = o && o.headers ? o.headers : {}, a.headers = be({}, u, l, r.headers), a.data = Ks(n, a, t), [2, { url: at(i), options: a }];
        }
      });
    })();
  } };
}, Hl = function(t) {
  var e = Zl(t);
  return { resendScoreSheet: function(n, r, s) {
    return we(function() {
      var i, o, a, u, c, l;
      return xe(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.resendScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = st["RiderSheetsApi.resendScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return ut(a, He, We, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Fn(this, e), $n(this, e, arguments);
  }
  return Mn(e, t), Bn(e, [{ key: "resendScoreSheet", value: function(n, r, s) {
    var i = this;
    return Hl(this.configuration).resendScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(Dn);
var Wl = function(t) {
  return { clearRuns: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return we(function() {
      var r, s, i, o, a, u;
      return xe(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/runs", it), t && (s = t.baseOptions), i = be({ method: "DELETE" }, s, n), a = {}, [4, Nt(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.reportId = e), ot(r, a), u = s && s.headers ? s.headers : {}, i.headers = be({}, o, u, n.headers), [2, { url: at(r), options: i }];
        }
      });
    })();
  }, deleteRun: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return we(function() {
      var r, s, i, o, a, u, c;
      return xe(this, function(l) {
        switch (l.label) {
          case 0:
            return sn("deleteRun", "id", e), r = "/runs/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, it), t && (i = t.baseOptions), o = be({ method: "DELETE" }, i, n), u = {}, [4, Nt(a = {}, t)];
          case 1:
            return l.sent(), ot(s, u), c = i && i.headers ? i.headers : {}, o.headers = be({}, a, c, n.headers), [2, { url: at(s), options: o }];
        }
      });
    })();
  }, getRun: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return we(function() {
      var r, s, i, o, a, u, c;
      return xe(this, function(l) {
        switch (l.label) {
          case 0:
            return sn("getRun", "id", e), r = "/runs/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, it), t && (i = t.baseOptions), o = be({ method: "GET" }, i, n), u = {}, [4, Nt(a = {}, t)];
          case 1:
            return l.sent(), ot(s, u), c = i && i.headers ? i.headers : {}, o.headers = be({}, a, c, n.headers), [2, { url: at(s), options: o }];
        }
      });
    })();
  }, listRuns: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return we(function() {
      var r, s, i, o, a, u;
      return xe(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/runs", it), t && (s = t.baseOptions), i = be({ method: "GET" }, s, n), a = {}, [4, Nt(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.reportId = e), ot(r, a), u = s && s.headers ? s.headers : {}, i.headers = be({}, o, u, n.headers), [2, { url: at(r), options: i }];
        }
      });
    })();
  } };
}, Vn = function(t) {
  var e = Wl(t);
  return { clearRuns: function(n, r) {
    return we(function() {
      var s, i, o, a, u, c;
      return xe(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.clearRuns(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = st["RunsApi.clearRuns"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return ut(o, He, We, t)(d, c || f);
            }];
        }
      });
    })();
  }, deleteRun: function(n, r) {
    return we(function() {
      var s, i, o, a, u, c;
      return xe(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deleteRun(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = st["RunsApi.deleteRun"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return ut(o, He, We, t)(d, c || f);
            }];
        }
      });
    })();
  }, getRun: function(n, r) {
    return we(function() {
      var s, i, o, a, u, c;
      return xe(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRun(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = st["RunsApi.getRun"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return ut(o, He, We, t)(d, c || f);
            }];
        }
      });
    })();
  }, listRuns: function(n, r) {
    return we(function() {
      var s, i, o, a, u, c;
      return xe(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listRuns(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = st["RunsApi.listRuns"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return ut(o, He, We, t)(d, c || f);
            }];
        }
      });
    })();
  } };
}, Jl = function(t) {
  function e() {
    return Fn(this, e), $n(this, e, arguments);
  }
  return Mn(e, t), Bn(e, [{ key: "clearRuns", value: function(n, r) {
    var s = this;
    return Vn(this.configuration).clearRuns(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deleteRun", value: function(n, r) {
    var s = this;
    return Vn(this.configuration).deleteRun(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRun", value: function(n, r) {
    var s = this;
    return Vn(this.configuration).getRun(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRuns", value: function(n, r) {
    var s = this;
    return Vn(this.configuration).listRuns(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
}(Dn);
function Vl(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function _t(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function eo(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      _t(t, s, n[s]);
    });
  }
  return t;
}
var Gl = function() {
  function t() {
    var r, s, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), _t(this, "apiKey", void 0), _t(this, "username", void 0), _t(this, "password", void 0), _t(this, "accessToken", void 0), _t(this, "basePath", void 0), _t(this, "serverIndex", void 0), _t(this, "baseOptions", void 0), _t(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (s = eo({}, o.baseOptions), i = (i = { headers: eo({}, (r = o.baseOptions) === null || r === void 0 ? void 0 : r.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(s, a, Object.getOwnPropertyDescriptor(i, a));
    }), s), this.formDataCtor = o.formDataCtor;
  }
  var e, n;
  return e = t, (n = [{ key: "isJsonMime", value: function(r) {
    var s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (s.test(r) || r.toLowerCase() === "application/json-patch+json");
  } }]) && Vl(e.prototype, n), t;
}();
function Kl() {
  var r;
  const t = qt(), { activeOrgId: e } = fa(), n = (r = t.user) == null ? void 0 : r.access_token;
  return $t(
    (s) => ({
      basePath: s,
      accessToken: n,
      baseOptions: e ? { headers: { "X-Org-Id": e } } : void 0
    }),
    [n, e]
  );
}
function Yl(t) {
  const e = Kl();
  return En(() => {
    const n = new Gl(e(t));
    return {
      reports: new ql(n),
      runs: new Jl(n)
    };
  }, [e, t]);
}
function en(t) {
  var n;
  const e = t == null ? void 0 : t.data;
  if (!e || e.status !== "success") {
    const r = ((n = e == null ? void 0 : e.data) == null ? void 0 : n.message) || (e == null ? void 0 : e.code) || "Request failed";
    throw new Error(r);
  }
  return e.data;
}
const Xl = {
  empty: "No reports available.",
  error: "Failed to load reports"
}, Ql = (t) => (t == null ? void 0 : t.name) ?? "";
function ed({
  api: t,
  domain: e,
  onSelect: n,
  selectedId: r,
  // #579 — when set, auto-select this def once (deep-link from another page).
  autoSelectId: s,
  labels: i = {},
  resolveReportName: o = Ql
}) {
  const a = { ...Xl, ...i }, [u, c] = z([]), [l, d] = z(!0), [f, h] = z(null), v = Ft(!1);
  return Se(() => {
    if (v.current || !s || u.length === 0) return;
    const p = u.find((R) => R.id === s);
    p && (v.current = !0, n == null || n(p));
  }, [u, s, n]), Se(() => {
    let p = !1;
    return d(!0), h(null), t.reports.listReports(e).then((R) => {
      p || c(en(R) || []);
    }).catch((R) => {
      p || h(R.message || a.error);
    }).finally(() => {
      p || d(!1);
    }), () => {
      p = !0;
    };
  }, [t, e, a.error]), l ? /* @__PURE__ */ m.jsx(ue, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(Un, { "data-testid": "report-list-loading" }) }) : f ? /* @__PURE__ */ m.jsx(jn, { severity: "error", children: f }) : u.length === 0 ? /* @__PURE__ */ m.jsx(ze, { color: "text.secondary", sx: { p: 2 }, children: a.empty }) : /* @__PURE__ */ m.jsx(Zu, { "data-testid": "report-list", children: u.map((p) => /* @__PURE__ */ m.jsx(
    Hu,
    {
      selected: p.id === r,
      onClick: () => n == null ? void 0 : n(p),
      children: /* @__PURE__ */ m.jsx(
        Wu,
        {
          primary: o(p),
          primaryTypographyProps: { color: "text.primary" }
        }
      )
    },
    p.id
  )) });
}
function td(t) {
  return t.default !== void 0 ? t.default : t.type === "boolean" ? !1 : "";
}
const gn = (t) => t !== "" && t !== void 0 && t !== null, nd = {
  submit: "Run report",
  required: "Required"
}, rd = (t, e, n) => (n == null ? void 0 : n.title) || e;
function sd({
  def: t,
  onSubmit: e,
  submitting: n = !1,
  labels: r = {},
  // #551 — `context` supplies values for fields the surface knows (e.g. showId
  // from the active show); those fields are auto-filled + hidden, not typed.
  // `fieldRenderers` overrides how a specific field renders (e.g. day/ring as
  // dropdowns, classId/rideId as a lookup) — keyed by the param name; each gets
  // { value, onChange, label, required, error, disabled }.
  context: s = {},
  fieldRenderers: i = {},
  resolveParamLabel: o = rd
}) {
  var T, W;
  const a = { ...nd, ...r }, u = ((T = t == null ? void 0 : t.paramsSchema) == null ? void 0 : T.properties) || {}, c = ((W = t == null ? void 0 : t.paramsSchema) == null ? void 0 : W.required) || [], l = Object.entries(u).filter(([M]) => !gn(s[M])), [d, f] = z(() => {
    const M = {};
    for (const [ne, K] of Object.entries(u))
      gn(s[ne]) || (M[ne] = td(K));
    return M;
  }), [h, v] = z(!1), p = (M, ne) => f((K) => ({ ...K, [M]: ne })), R = c.filter((M) => gn(s[M]) ? !1 : !gn(d[M])), J = (M) => {
    if (M.preventDefault(), v(!0), R.length > 0) return;
    const ne = {};
    for (const [K, je] of Object.entries(u)) {
      if (gn(s[K])) {
        ne[K] = s[K];
        continue;
      }
      const me = d[K];
      me === "" && !c.includes(K) || (ne[K] = je.type === "number" || je.type === "integer" ? Number(me) : me);
    }
    e(ne);
  };
  return /* @__PURE__ */ m.jsx(ue, { component: "form", onSubmit: J, noValidate: !0, children: /* @__PURE__ */ m.jsxs(rn, { spacing: 2, children: [
    l.map(([M, ne]) => {
      const K = o(t, M, ne), je = c.includes(M), me = h && je && R.includes(M), Me = i[M];
      if (Me)
        return /* @__PURE__ */ m.jsx(Lu, { children: Me({
          value: d[M],
          onChange: (le) => p(M, le),
          label: K,
          required: je,
          error: me,
          disabled: n
        }) }, M);
      if (ne.type === "boolean")
        return /* @__PURE__ */ m.jsx(
          ta,
          {
            control: /* @__PURE__ */ m.jsx(
              na,
              {
                color: "default",
                checked: !!d[M],
                onChange: (le) => p(M, le.target.checked)
              }
            ),
            label: K
          },
          M
        );
      if (Array.isArray(ne.enum))
        return /* @__PURE__ */ m.jsx(
          Tn,
          {
            select: !0,
            label: K,
            required: je,
            error: me,
            helperText: me ? a.required : ne.description,
            value: d[M] ?? "",
            onChange: (le) => p(M, le.target.value),
            fullWidth: !0,
            children: ne.enum.map((le) => /* @__PURE__ */ m.jsx(Ju, { value: le, children: String(le) }, String(le)))
          },
          M
        );
      const Qe = ne.type === "number" || ne.type === "integer";
      return /* @__PURE__ */ m.jsx(
        Tn,
        {
          label: K,
          type: Qe ? "number" : "text",
          required: je,
          error: me,
          helperText: me ? a.required : ne.description,
          value: d[M] ?? "",
          onChange: (le) => p(M, le.target.value),
          fullWidth: !0
        },
        M
      );
    }),
    /* @__PURE__ */ m.jsx(ue, { children: /* @__PURE__ */ m.jsx(Ne, { type: "submit", variant: "contained", loading: n, children: a.submit }) })
  ] }) });
}
const id = /* @__PURE__ */ new Set(["PENDING", "RUNNING"]), od = {
  COMPLETE: "success",
  FAILED: "error",
  RUNNING: "info",
  PENDING: "warning"
};
function ad(t) {
  if (!t) return "";
  const e = new Date(t);
  return isNaN(e.getTime()) ? t : e.toLocaleString();
}
const ud = {
  empty: "No runs yet.",
  error: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  delete: "Delete"
}, cd = (t) => t;
function ld({
  api: t,
  onView: e,
  onDelete: n,
  refreshKey: r = 0,
  labels: s = {},
  resolveReportName: i = cd
}) {
  const o = { ...ud, ...s }, [a, u] = z([]), [c, l] = z(!0), [d, f] = z(null), h = Ft(null), v = $t(async () => {
    try {
      const p = await t.runs.listRuns();
      u(en(p) || []), f(null);
    } catch (p) {
      f(p.message || o.error);
    } finally {
      l(!1);
    }
  }, [t, o.error]);
  return Se(() => {
    v();
  }, [v, r]), Se(() => {
    if (!a.some((R) => id.has(R.status))) {
      h.current && clearInterval(h.current), h.current = null;
      return;
    }
    return h.current || (h.current = setInterval(v, 4e3)), () => {
      h.current && (clearInterval(h.current), h.current = null);
    };
  }, [a, v]), c ? /* @__PURE__ */ m.jsx(ue, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(Un, { "data-testid": "run-history-loading" }) }) : d ? /* @__PURE__ */ m.jsx(jn, { severity: "error", children: d }) : a.length === 0 ? /* @__PURE__ */ m.jsx(ze, { color: "text.secondary", sx: { p: 2 }, children: o.empty }) : /* @__PURE__ */ m.jsxs(Vu, { size: "small", "data-testid": "run-history", children: [
    /* @__PURE__ */ m.jsx(Gu, { children: /* @__PURE__ */ m.jsxs(xi, { children: [
      /* @__PURE__ */ m.jsx(jt, { children: o.colReport }),
      /* @__PURE__ */ m.jsx(jt, { children: o.colRequested }),
      /* @__PURE__ */ m.jsx(jt, { children: o.colStatus }),
      /* @__PURE__ */ m.jsx(jt, { align: "right", children: o.colActions })
    ] }) }),
    /* @__PURE__ */ m.jsx(Ku, { children: a.map((p) => /* @__PURE__ */ m.jsxs(xi, { "data-testid": `run-row-${p.id}`, children: [
      /* @__PURE__ */ m.jsx(jt, { sx: { color: "text.primary" }, children: i(p.reportId) }),
      /* @__PURE__ */ m.jsx(jt, { sx: { color: "text.primary" }, children: ad(p.createdAt) }),
      /* @__PURE__ */ m.jsx(jt, { children: /* @__PURE__ */ m.jsx(
        ea,
        {
          size: "small",
          label: p.status,
          color: od[p.status] || "default"
        }
      ) }),
      /* @__PURE__ */ m.jsxs(jt, { align: "right", children: [
        /* @__PURE__ */ m.jsx(
          Ne,
          {
            size: "small",
            variant: "outlined",
            color: "inherit",
            disabled: p.status !== "COMPLETE",
            onClick: () => e == null ? void 0 : e(p),
            children: o.view
          }
        ),
        n && /* @__PURE__ */ m.jsx(
          xr,
          {
            size: "small",
            color: "inherit",
            "aria-label": o.delete,
            title: o.delete,
            sx: { ml: 1 },
            onClick: () => n(p),
            children: /* @__PURE__ */ m.jsx(gc, { fontSize: "small" })
          }
        )
      ] })
    ] }, p.id)) })
  ] });
}
const dd = {
  failed: "This run failed to render.",
  notReady: "Report is not ready yet.",
  error: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  preview: "Report preview"
};
function fd({ api: t, runId: e, height: n = 600, labels: r = {} }) {
  const s = { ...dd, ...r }, [i, o] = z(null), [a, u] = z(!0), [c, l] = z(null);
  return Se(() => {
    if (!e) return;
    let d = !1;
    return u(!0), l(null), t.runs.getRun(e).then((f) => {
      if (d) return;
      const h = en(f);
      if (h.status !== "COMPLETE" || !h.artifactUrls) {
        l(h.status === "FAILED" ? s.failed : s.notReady);
        return;
      }
      o(h.artifactUrls);
    }).catch((f) => {
      d || l(f.message || s.error);
    }).finally(() => {
      d || u(!1);
    }), () => {
      d = !0;
    };
  }, [t, e, s.error, s.failed, s.notReady]), e ? a ? /* @__PURE__ */ m.jsx(ue, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(Un, { "data-testid": "report-viewer-loading" }) }) : c ? /* @__PURE__ */ m.jsx(jn, { severity: "error", children: c }) : i ? /* @__PURE__ */ m.jsxs(rn, { spacing: 1, "data-testid": "report-viewer", children: [
    /* @__PURE__ */ m.jsxs(rn, { direction: "row", spacing: 1, children: [
      i.pdf && /* @__PURE__ */ m.jsx(Ne, { variant: "outlined", href: i.pdf, target: "_blank", rel: "noopener", children: s.openPdf }),
      i.html && /* @__PURE__ */ m.jsx(Ne, { variant: "text", href: i.html, target: "_blank", rel: "noopener", children: s.openHtml })
    ] }),
    i.html && /* @__PURE__ */ m.jsx(
      ue,
      {
        component: "iframe",
        "data-testid": "report-viewer-frame",
        title: s.preview,
        src: i.html,
        sx: { width: "100%", height: n, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "#fff" }
      }
    )
  ] }) : null : null;
}
const hd = {
  title: "Reports",
  availableReports: "Available reports",
  runHistory: "Run history",
  reportDialogTitle: "Report",
  reportStarted: "Report started — open Run history to view it when ready.",
  failedToStart: "Failed to start report",
  // #609 — run-progress modal
  runningTitle: "Running report…",
  runningMessage: "Your report is being generated. It will download automatically when it's ready — or close this and find it in Run history.",
  runningDoneTitle: "Report ready",
  runningDoneMessage: "Your report has downloaded. It's also in Run history.",
  runningFailedTitle: "Report failed",
  download: "Download",
  close: "Close",
  // #606 — clear old runs
  clearHistory: "Clear history",
  clearConfirm: "Delete all report runs for this organization? This removes the generated files too and can't be undone.",
  delete: "Delete",
  // ReportList
  noReports: "No reports available.",
  failedToLoadReports: "Failed to load reports",
  // ReportParamsForm
  runReport: "Run report",
  required: "Required",
  // RunHistory
  noRuns: "No runs yet.",
  failedToLoadRuns: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  // ReportViewer
  runFailed: "This run failed to render.",
  runNotReady: "Report is not ready yet.",
  failedToLoadReport: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  reportPreview: "Report preview"
}, pd = (t) => (t == null ? void 0 : t.name) ?? (t == null ? void 0 : t.id) ?? "", md = (t, e, n) => (n == null ? void 0 : n.title) || e;
function to(t) {
  const e = document.createElement("a");
  e.href = t, e.target = "_blank", e.rel = "noopener", e.download = "", document.body.appendChild(e), e.click(), e.remove();
}
function dp({
  basePath: t,
  domain: e,
  // Back-compat: an explicit `title` still wins; otherwise labels.title is used.
  title: n,
  // #602 — translated chrome strings from the mounting app (see DEFAULT_LABELS).
  labels: r = {},
  // #551 — a surface can supply context values (e.g. showId from the active
  // show) and custom field renderers (day/ring dropdowns, class/ride lookups)
  // forwarded to the params form. `paramsFieldRenderers` may be a plain map or
  // a function of the selected def (so renderers can depend on the def).
  paramsContext: s = {},
  paramsFieldRenderers: i = {},
  // #579 — a surface can deep-link to a specific report (e.g. from a ride page);
  // the matching def is auto-selected once the list loads.
  initialSelectedId: o,
  // #649 — see defaultResolveReportName/defaultResolveParamLabel above.
  resolveReportName: a = pd,
  resolveParamLabel: u = md
}) {
  var ke, V;
  const c = { ...hd, ...r }, l = Yl(t), [d, f] = z(null), [h, v] = z(!1), [p, R] = z(null), [J, T] = z(0), [W, M] = z(""), [ne, K] = z(null), [je, me] = z({});
  Se(() => {
    let de = !1;
    return l.reports.listReports(e).then((Pe) => {
      if (de) return;
      const et = {};
      for (const St of en(Pe) || []) et[St.id] = St;
      me(et);
    }).catch(() => {
    }), () => {
      de = !0;
    };
  }, [l, e]);
  const Me = (de) => {
    var Pe;
    return a({ id: de, name: (Pe = je[de]) == null ? void 0 : Pe.name });
  }, [Qe, le] = z(!1), [Ce, ce] = z(null), [se, oe] = z(null), qe = Ft(!1), ye = async (de) => {
    if (d) {
      v(!0), R(null);
      try {
        const Pe = en(await l.reports.createReportRun(d.id, { params: de }));
        T((et) => et + 1), f(null), qe.current = !1, oe(Pe), ce(Pe.id);
      } catch (Pe) {
        R(Pe.message || c.failedToStart);
      } finally {
        v(!1);
      }
    }
  };
  Se(() => {
    if (!Ce) return;
    let de = !1, Pe;
    const et = async () => {
      var St, It;
      try {
        const tt = en(await l.runs.getRun(Ce));
        if (de) return;
        if (oe(tt), tt.status === "COMPLETE") {
          T((Wr) => Wr + 1);
          const Rt = ((St = tt.artifactUrls) == null ? void 0 : St.pdf) || ((It = tt.artifactUrls) == null ? void 0 : It.html);
          Rt && !qe.current && (qe.current = !0, to(Rt));
          return;
        }
        if (tt.status === "FAILED") {
          T((Rt) => Rt + 1);
          return;
        }
        Pe = setTimeout(et, 3e3);
      } catch {
        de || oe((tt) => ({ ...tt || {}, status: "FAILED" }));
      }
    };
    return Pe = setTimeout(et, 1200), () => {
      de = !0, clearTimeout(Pe);
    };
  }, [Ce, l]);
  const [ht, xt] = z(!1), he = async () => {
    if (!(typeof window < "u" && !window.confirm(c.clearConfirm))) {
      xt(!0);
      try {
        await l.runs.clearRuns(), T((de) => de + 1);
      } finally {
        xt(!1);
      }
    }
  }, pe = async (de) => {
    await l.runs.deleteRun(de.id), T((Pe) => Pe + 1);
  };
  return /* @__PURE__ */ m.jsxs(ue, { children: [
    /* @__PURE__ */ m.jsx(ze, { variant: "h5", sx: { mb: 2, color: "text.primary" }, children: n ?? c.title }),
    /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, alignItems: "flex-start" }, children: [
      /* @__PURE__ */ m.jsx(ue, { sx: { width: { xs: "100%", md: 340 }, flexShrink: 0 }, children: /* @__PURE__ */ m.jsx(br, { variant: "outlined", children: /* @__PURE__ */ m.jsxs(wr, { children: [
        /* @__PURE__ */ m.jsx(ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: c.availableReports }),
        /* @__PURE__ */ m.jsx(
          ed,
          {
            api: l,
            domain: e,
            selectedId: d == null ? void 0 : d.id,
            autoSelectId: o,
            onSelect: f,
            labels: { empty: c.noReports, error: c.failedToLoadReports },
            resolveReportName: a
          }
        ),
        /* @__PURE__ */ m.jsx(
          Ne,
          {
            fullWidth: !0,
            variant: "text",
            sx: { mt: 1, justifyContent: "flex-start" },
            onClick: () => le(!0),
            children: c.runHistory
          }
        )
      ] }) }) }),
      /* @__PURE__ */ m.jsx(ue, { sx: { flex: 1, minWidth: 0, width: "100%" }, children: d && /* @__PURE__ */ m.jsx(br, { variant: "outlined", sx: { mb: 2 }, children: /* @__PURE__ */ m.jsxs(wr, { children: [
        /* @__PURE__ */ m.jsx(ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: a(d) }),
        /* @__PURE__ */ m.jsx(Yu, { sx: { my: 1 } }),
        p && /* @__PURE__ */ m.jsx(jn, { severity: "error", sx: { mb: 2 }, children: p }),
        /* @__PURE__ */ m.jsx(
          sd,
          {
            def: d,
            onSubmit: ye,
            submitting: h,
            labels: { submit: c.runReport, required: c.required },
            context: s,
            fieldRenderers: typeof i == "function" ? i(d) : i,
            resolveParamLabel: u
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ m.jsxs(tr, { open: Qe, onClose: () => le(!1), maxWidth: "md", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(Qr, { children: c.runHistory }),
      /* @__PURE__ */ m.jsx(nr, { children: /* @__PURE__ */ m.jsx(
        ld,
        {
          api: l,
          refreshKey: J,
          onView: (de) => K(de.id),
          onDelete: pe,
          labels: {
            empty: c.noRuns,
            error: c.failedToLoadRuns,
            colReport: c.colReport,
            colRequested: c.colRequested,
            colStatus: c.colStatus,
            colActions: c.colActions,
            view: c.view,
            delete: c.delete
          },
          resolveReportName: Me
        }
      ) }),
      /* @__PURE__ */ m.jsxs(bs, { children: [
        /* @__PURE__ */ m.jsx(Ne, { color: "error", onClick: he, disabled: ht, children: c.clearHistory }),
        /* @__PURE__ */ m.jsx(Ne, { color: "inherit", onClick: () => le(!1), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ m.jsxs(tr, { open: !!ne, onClose: () => K(null), maxWidth: "lg", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(Qr, { children: c.reportDialogTitle }),
      /* @__PURE__ */ m.jsx(nr, { children: /* @__PURE__ */ m.jsx(
        fd,
        {
          api: l,
          runId: ne,
          labels: {
            failed: c.runFailed,
            notReady: c.runNotReady,
            error: c.failedToLoadReport,
            openPdf: c.openPdf,
            openHtml: c.openHtml,
            preview: c.reportPreview
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ m.jsxs(tr, { open: !!Ce, onClose: () => ce(null), maxWidth: "xs", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(Qr, { children: (se == null ? void 0 : se.status) === "COMPLETE" ? c.runningDoneTitle : (se == null ? void 0 : se.status) === "FAILED" ? c.runningFailedTitle : c.runningTitle }),
      /* @__PURE__ */ m.jsx(nr, { children: (se == null ? void 0 : se.status) === "FAILED" ? /* @__PURE__ */ m.jsx(jn, { severity: "error", children: c.runFailed }) : (se == null ? void 0 : se.status) === "COMPLETE" ? /* @__PURE__ */ m.jsx(ze, { sx: { color: "text.primary" }, children: c.runningDoneMessage }) : /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", alignItems: "center", gap: 2, py: 1 }, children: [
        /* @__PURE__ */ m.jsx(Un, { size: 26, color: "inherit" }),
        /* @__PURE__ */ m.jsx(ze, { sx: { color: "text.primary" }, children: c.runningMessage })
      ] }) }),
      /* @__PURE__ */ m.jsxs(bs, { children: [
        (se == null ? void 0 : se.status) === "COMPLETE" && (((ke = se.artifactUrls) == null ? void 0 : ke.pdf) || ((V = se.artifactUrls) == null ? void 0 : V.html)) && // #609 — brand primary is darkGrey (invisible as a text button on
        // dark); a contained button + inherit-colored Close stay legible
        // in both light and dark.
        /* @__PURE__ */ m.jsx(
          Ne,
          {
            variant: "contained",
            onClick: () => to(se.artifactUrls.pdf || se.artifactUrls.html),
            children: c.download
          }
        ),
        /* @__PURE__ */ m.jsx(Ne, { color: "inherit", onClick: () => ce(null), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ m.jsx(
      Xu,
      {
        open: !!W,
        autoHideDuration: 5e3,
        onClose: () => M(""),
        message: W
      }
    )
  ] });
}
var Pr = { d: (t, e) => {
  for (var n in e) Pr.o(e, n) && !Pr.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
}, o: (t, e) => Object.prototype.hasOwnProperty.call(t, e), r: (t) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
} }, ks = {};
Pr.r(ks), Pr.d(ks, { hasBrowserEnv: () => ei, hasStandardBrowserEnv: () => df, hasStandardBrowserWebWorkerEnv: () => ff, navigator: () => $s, origin: () => hf });
var $a = ["C", "E", "M", "B", "H"], Gn = { PENDING: "PENDING", IN_PROGRESS: "IN_PROGRESS", COMPLETED: "COMPLETED", SCRATCHED: "SCRATCHED" }, Fa = { BLOOD: "BLOOD", LAMENESS: "LAMENESS" }, no = { POINTS: "POINTS", PERCENT_SENIOR: "PERCENT_SENIOR", PERCENT_YOUTH: "PERCENT_YOUTH" }, gd = 10, Wt = { PENDING: Gn.PENDING, IN_PROGRESS: Gn.IN_PROGRESS, CONFIRMED: "CONFIRMED", COMPLETED: Gn.COMPLETED, FINAL: "FINAL", SCRATCHED: Gn.SCRATCHED }, ie, ro;
(function(t) {
  t.assertEqual = (e) => {
  }, t.assertIs = function(e) {
  }, t.assertNever = function(e) {
    throw new Error();
  }, t.arrayToEnum = (e) => {
    const n = {};
    for (const r of e) n[r] = r;
    return n;
  }, t.getValidEnumValues = (e) => {
    const n = t.objectKeys(e).filter((s) => typeof e[e[s]] != "number"), r = {};
    for (const s of n) r[s] = e[s];
    return t.objectValues(r);
  }, t.objectValues = (e) => t.objectKeys(e).map(function(n) {
    return e[n];
  }), t.objectKeys = typeof Object.keys == "function" ? (e) => Object.keys(e) : (e) => {
    const n = [];
    for (const r in e) Object.prototype.hasOwnProperty.call(e, r) && n.push(r);
    return n;
  }, t.find = (e, n) => {
    for (const r of e) if (n(r)) return r;
  }, t.isInteger = typeof Number.isInteger == "function" ? (e) => Number.isInteger(e) : (e) => typeof e == "number" && Number.isFinite(e) && Math.floor(e) === e, t.joinValues = function(e, n = " | ") {
    return e.map((r) => typeof r == "string" ? `'${r}'` : r).join(n);
  }, t.jsonStringifyReplacer = (e, n) => typeof n == "bigint" ? n.toString() : n;
})(ie || (ie = {})), function(t) {
  t.mergeShapes = (e, n) => ({ ...e, ...n });
}(ro || (ro = {}));
const k = ie.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), kt = (t) => {
  switch (typeof t) {
    case "undefined":
      return k.undefined;
    case "string":
      return k.string;
    case "number":
      return Number.isNaN(t) ? k.nan : k.number;
    case "boolean":
      return k.boolean;
    case "function":
      return k.function;
    case "bigint":
      return k.bigint;
    case "symbol":
      return k.symbol;
    case "object":
      return Array.isArray(t) ? k.array : t === null ? k.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? k.promise : typeof Map < "u" && t instanceof Map ? k.map : typeof Set < "u" && t instanceof Set ? k.set : typeof Date < "u" && t instanceof Date ? k.date : k.object;
    default:
      return k.unknown;
  }
}, E = ie.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);
class Tt extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const n = e || function(i) {
      return i.message;
    }, r = { _errors: [] }, s = (i) => {
      for (const o of i.issues) if (o.code === "invalid_union") o.unionErrors.map(s);
      else if (o.code === "invalid_return_type") s(o.returnTypeError);
      else if (o.code === "invalid_arguments") s(o.argumentsError);
      else if (o.path.length === 0) r._errors.push(n(o));
      else {
        let a = r, u = 0;
        for (; u < o.path.length; ) {
          const c = o.path[u];
          u === o.path.length - 1 ? (a[c] = a[c] || { _errors: [] }, a[c]._errors.push(n(o))) : a[c] = a[c] || { _errors: [] }, a = a[c], u++;
        }
      }
    };
    return s(this), r;
  }
  static assert(e) {
    if (!(e instanceof Tt)) throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ie.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const s of this.issues) if (s.path.length > 0) {
      const i = s.path[0];
      n[i] = n[i] || [], n[i].push(e(s));
    } else r.push(e(s));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Tt.create = (t) => new Tt(t);
const Ps = (t, e) => {
  let n;
  switch (t.code) {
    case E.invalid_type:
      n = t.received === k.undefined ? "Required" : `Expected ${t.expected}, received ${t.received}`;
      break;
    case E.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, ie.jsonStringifyReplacer)}`;
      break;
    case E.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${ie.joinValues(t.keys, ", ")}`;
      break;
    case E.invalid_union:
      n = "Invalid input";
      break;
    case E.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${ie.joinValues(t.options)}`;
      break;
    case E.invalid_enum_value:
      n = `Invalid enum value. Expected ${ie.joinValues(t.options)}, received '${t.received}'`;
      break;
    case E.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case E.invalid_return_type:
      n = "Invalid function return type";
      break;
    case E.invalid_date:
      n = "Invalid date";
      break;
    case E.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : ie.assertNever(t.validation) : n = t.validation !== "regex" ? `Invalid ${t.validation}` : "Invalid";
      break;
    case E.too_small:
      n = t.type === "array" ? `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" || t.type === "bigint" ? `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : "Invalid input";
      break;
    case E.too_big:
      n = t.type === "array" ? `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : "Invalid input";
      break;
    case E.custom:
      n = "Invalid input";
      break;
    case E.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case E.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case E.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, ie.assertNever(t);
  }
  return { message: n };
};
let vd = Ps;
var P;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(P || (P = {}));
function j(t, e) {
  const n = vd, r = ((s) => {
    const { data: i, path: o, errorMaps: a, issueData: u } = s, c = [...o, ...u.path || []], l = { ...u, path: c };
    if (u.message !== void 0) return { ...u, path: c, message: u.message };
    let d = "";
    const f = a.filter((h) => !!h).slice().reverse();
    for (const h of f) d = h(l, { data: i, defaultError: d }).message;
    return { ...u, path: c, message: d };
  })({ issueData: e, data: t.data, path: t.path, errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, n, n === Ps ? void 0 : Ps].filter((s) => !!s) });
  t.common.issues.push(r);
}
class De {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const s of n) {
      if (s.status === "aborted") return H;
      s.status === "dirty" && e.dirty(), r.push(s.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const s of n) {
      const i = await s.key, o = await s.value;
      r.push({ key: i, value: o });
    }
    return De.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const s of n) {
      const { key: i, value: o } = s;
      if (i.status === "aborted" || o.status === "aborted") return H;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value === "__proto__" || o.value === void 0 && !s.alwaysSet || (r[i.value] = o.value);
    }
    return { status: e.value, value: r };
  }
}
const H = Object.freeze({ status: "aborted" }), As = (t) => ({ status: "dirty", value: t }), Je = (t) => ({ status: "valid", value: t }), so = (t) => t.status === "aborted", io = (t) => t.status === "dirty", on = (t) => t.status === "valid", Ar = (t) => typeof Promise < "u" && t instanceof Promise;
class wt {
  constructor(e, n, r, s) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const oo = (t, e) => {
  if (on(e)) return { success: !0, data: e.value };
  if (!t.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return { success: !1, get error() {
    if (this._error) return this._error;
    const n = new Tt(t.common.issues);
    return this._error = n, this._error;
  } };
};
function G(t) {
  if (!t) return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: s } = t;
  if (e && (n || r)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => {
    const { message: a } = t;
    return i.code === "invalid_enum_value" ? { message: a ?? o.defaultError } : o.data === void 0 ? { message: a ?? r ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: a ?? n ?? o.defaultError };
  }, description: s };
}
class te {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return kt(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || { common: e.parent.common, data: e.data, parsedType: kt(e.data), schemaErrorMap: this._def.errorMap, path: e.path, parent: e.parent };
  }
  _processInputParams(e) {
    return { status: new De(), ctx: { common: e.parent.common, data: e.data, parsedType: kt(e.data), schemaErrorMap: this._def.errorMap, path: e.path, parent: e.parent } };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (Ar(n)) throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success) return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    const r = { common: { issues: [], async: (n == null ? void 0 : n.async) ?? !1, contextualErrorMap: n == null ? void 0 : n.errorMap }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: e, parsedType: kt(e) }, s = this._parseSync({ data: e, path: r.path, parent: r });
    return oo(r, s);
  }
  "~validate"(e) {
    var r, s;
    const n = { common: { issues: [], async: !!this["~standard"].async }, path: [], schemaErrorMap: this._def.errorMap, parent: null, data: e, parsedType: kt(e) };
    if (!this["~standard"].async) try {
      const i = this._parseSync({ data: e, path: [], parent: n });
      return on(i) ? { value: i.value } : { issues: n.common.issues };
    } catch (i) {
      (s = (r = i == null ? void 0 : i.message) == null ? void 0 : r.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), n.common = { issues: [], async: !0 };
    }
    return this._parseAsync({ data: e, path: [], parent: n }).then((i) => on(i) ? { value: i.value } : { issues: n.common.issues });
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success) return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = { common: { issues: [], contextualErrorMap: n == null ? void 0 : n.errorMap, async: !0 }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: e, parsedType: kt(e) }, s = this._parse({ data: e, path: r.path, parent: r }), i = await (Ar(s) ? s : Promise.resolve(s));
    return oo(r, i);
  }
  refine(e, n) {
    const r = (s) => typeof n == "string" || n === void 0 ? { message: n } : typeof n == "function" ? n(s) : n;
    return this._refinement((s, i) => {
      const o = e(s), a = () => i.addIssue({ code: E.custom, ...r(s) });
      return typeof Promise < "u" && o instanceof Promise ? o.then((u) => !!u || (a(), !1)) : !!o || (a(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, s) => !!e(r) || (s.addIssue(typeof n == "function" ? n(r, s) : n), !1));
  }
  _refinement(e) {
    return new Kt({ schema: this, typeName: Z.ZodEffects, effect: { type: "refinement", refinement: e } });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = { version: 1, vendor: "zod", validate: (n) => this["~validate"](n) };
  }
  optional() {
    return At.create(this, this._def);
  }
  nullable() {
    return cn.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return vt.create(this);
  }
  promise() {
    return Nr.create(this, this._def);
  }
  or(e) {
    return Lr.create([this, e], this._def);
  }
  and(e) {
    return Ur.create(this, e, this._def);
  }
  transform(e) {
    return new Kt({ ...G(this._def), schema: this, typeName: Z.ZodEffects, effect: { type: "transform", transform: e } });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Us({ ...G(this._def), innerType: this, defaultValue: n, typeName: Z.ZodDefault });
  }
  brand() {
    return new Dd({ typeName: Z.ZodBranded, type: this, ...G(this._def) });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Ns({ ...G(this._def), innerType: this, catchValue: n, typeName: Z.ZodCatch });
  }
  describe(e) {
    return new this.constructor({ ...this._def, description: e });
  }
  pipe(e) {
    return Xs.create(this, e);
  }
  readonly() {
    return Ds.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const yd = /^c[^\s-]{8,}$/i, bd = /^[0-9a-z]+$/, wd = /^[0-9A-HJKMNP-TV-Z]{26}$/i, xd = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Sd = /^[a-z0-9_-]{21}$/i, Rd = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, _d = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Od = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
let cs;
const Ed = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Td = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, jd = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Cd = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, kd = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Pd = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ba = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ad = new RegExp(`^${Ba}$`);
function Ma(t) {
  let e = "[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t.precision ? "+" : "?"}`;
}
function Id(t) {
  let e = `${Ba}T${Ma(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function Ld(t, e) {
  if (!Rd.test(t)) return !1;
  try {
    const [n] = t.split(".");
    if (!n) return !1;
    const r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), s = JSON.parse(atob(r));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function Ud(t, e) {
  return !(e !== "v4" && e || !Td.test(t)) || !(e !== "v6" && e || !Cd.test(t));
}
class Et extends te {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== k.string) {
      const o = this._getOrReturnCtx(e);
      return j(o, { code: E.invalid_type, expected: k.string, received: o.parsedType }), H;
    }
    const n = new De();
    let r;
    for (const o of this._def.checks) if (o.kind === "min") e.data.length < o.value && (r = this._getOrReturnCtx(e, r), j(r, { code: E.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "max") e.data.length > o.value && (r = this._getOrReturnCtx(e, r), j(r, { code: E.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "length") {
      const a = e.data.length > o.value, u = e.data.length < o.value;
      (a || u) && (r = this._getOrReturnCtx(e, r), a ? j(r, { code: E.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }) : u && j(r, { code: E.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }), n.dirty());
    } else if (o.kind === "email") Od.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "email", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "emoji") cs || (cs = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")), cs.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "emoji", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "uuid") xd.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "uuid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "nanoid") Sd.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "nanoid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid") yd.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "cuid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid2") bd.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "cuid2", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "ulid") wd.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "ulid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "url") try {
      new URL(e.data);
    } catch {
      r = this._getOrReturnCtx(e, r), j(r, { validation: "url", code: E.invalid_string, message: o.message }), n.dirty();
    }
    else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "regex", code: E.invalid_string, message: o.message }), n.dirty())) : o.kind === "trim" ? e.data = e.data.trim() : o.kind === "includes" ? e.data.includes(o.value, o.position) || (r = this._getOrReturnCtx(e, r), j(r, { code: E.invalid_string, validation: { includes: o.value, position: o.position }, message: o.message }), n.dirty()) : o.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : o.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : o.kind === "startsWith" ? e.data.startsWith(o.value) || (r = this._getOrReturnCtx(e, r), j(r, { code: E.invalid_string, validation: { startsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "endsWith" ? e.data.endsWith(o.value) || (r = this._getOrReturnCtx(e, r), j(r, { code: E.invalid_string, validation: { endsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "datetime" ? Id(o).test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { code: E.invalid_string, validation: "datetime", message: o.message }), n.dirty()) : o.kind === "date" ? Ad.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { code: E.invalid_string, validation: "date", message: o.message }), n.dirty()) : o.kind === "time" ? new RegExp(`^${Ma(o)}$`).test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { code: E.invalid_string, validation: "time", message: o.message }), n.dirty()) : o.kind === "duration" ? _d.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "duration", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "ip" ? (s = e.data, ((i = o.version) !== "v4" && i || !Ed.test(s)) && (i !== "v6" && i || !jd.test(s)) && (r = this._getOrReturnCtx(e, r), j(r, { validation: "ip", code: E.invalid_string, message: o.message }), n.dirty())) : o.kind === "jwt" ? Ld(e.data, o.alg) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "jwt", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "cidr" ? Ud(e.data, o.version) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "cidr", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64" ? kd.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "base64", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64url" ? Pd.test(e.data) || (r = this._getOrReturnCtx(e, r), j(r, { validation: "base64url", code: E.invalid_string, message: o.message }), n.dirty()) : ie.assertNever(o);
    var s, i;
    return { status: n.value, value: e.data };
  }
  _regex(e, n, r) {
    return this.refinement((s) => e.test(s), { validation: n, code: E.invalid_string, ...P.errToObj(r) });
  }
  _addCheck(e) {
    return new Et({ ...this._def, checks: [...this._def.checks, e] });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...P.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...P.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...P.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...P.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...P.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...P.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...P.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...P.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...P.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({ kind: "base64url", ...P.errToObj(e) });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...P.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...P.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...P.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({ kind: "datetime", precision: null, offset: !1, local: !1, message: e }) : this._addCheck({ kind: "datetime", precision: (e == null ? void 0 : e.precision) === void 0 ? null : e == null ? void 0 : e.precision, offset: (e == null ? void 0 : e.offset) ?? !1, local: (e == null ? void 0 : e.local) ?? !1, ...P.errToObj(e == null ? void 0 : e.message) });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({ kind: "time", precision: null, message: e }) : this._addCheck({ kind: "time", precision: (e == null ? void 0 : e.precision) === void 0 ? null : e == null ? void 0 : e.precision, ...P.errToObj(e == null ? void 0 : e.message) });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...P.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({ kind: "regex", regex: e, ...P.errToObj(n) });
  }
  includes(e, n) {
    return this._addCheck({ kind: "includes", value: e, position: n == null ? void 0 : n.position, ...P.errToObj(n == null ? void 0 : n.message) });
  }
  startsWith(e, n) {
    return this._addCheck({ kind: "startsWith", value: e, ...P.errToObj(n) });
  }
  endsWith(e, n) {
    return this._addCheck({ kind: "endsWith", value: e, ...P.errToObj(n) });
  }
  min(e, n) {
    return this._addCheck({ kind: "min", value: e, ...P.errToObj(n) });
  }
  max(e, n) {
    return this._addCheck({ kind: "max", value: e, ...P.errToObj(n) });
  }
  length(e, n) {
    return this._addCheck({ kind: "length", value: e, ...P.errToObj(n) });
  }
  nonempty(e) {
    return this.min(1, P.errToObj(e));
  }
  trim() {
    return new Et({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
  }
  toLowerCase() {
    return new Et({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
  }
  toUpperCase() {
    return new Et({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
function Nd(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = n > r ? n : r;
  return Number.parseInt(t.toFixed(s).replace(".", "")) % Number.parseInt(e.toFixed(s).replace(".", "")) / 10 ** s;
}
Et.create = (t) => new Et({ checks: [], typeName: Z.ZodString, coerce: (t == null ? void 0 : t.coerce) ?? !1, ...G(t) });
class an extends te {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== k.number) {
      const s = this._getOrReturnCtx(e);
      return j(s, { code: E.invalid_type, expected: k.number, received: s.parsedType }), H;
    }
    let n;
    const r = new De();
    for (const s of this._def.checks) s.kind === "int" ? ie.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), j(n, { code: E.invalid_type, expected: "integer", received: "float", message: s.message }), r.dirty()) : s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), j(n, { code: E.too_small, minimum: s.value, type: "number", inclusive: s.inclusive, exact: !1, message: s.message }), r.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), j(n, { code: E.too_big, maximum: s.value, type: "number", inclusive: s.inclusive, exact: !1, message: s.message }), r.dirty()) : s.kind === "multipleOf" ? Nd(e.data, s.value) !== 0 && (n = this._getOrReturnCtx(e, n), j(n, { code: E.not_multiple_of, multipleOf: s.value, message: s.message }), r.dirty()) : s.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), j(n, { code: E.not_finite, message: s.message }), r.dirty()) : ie.assertNever(s);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, P.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, P.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, P.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, P.toString(n));
  }
  setLimit(e, n, r, s) {
    return new an({ ...this._def, checks: [...this._def.checks, { kind: e, value: n, inclusive: r, message: P.toString(s) }] });
  }
  _addCheck(e) {
    return new an({ ...this._def, checks: [...this._def.checks, e] });
  }
  int(e) {
    return this._addCheck({ kind: "int", message: P.toString(e) });
  }
  positive(e) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !1, message: P.toString(e) });
  }
  negative(e) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !1, message: P.toString(e) });
  }
  nonpositive(e) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !0, message: P.toString(e) });
  }
  nonnegative(e) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !0, message: P.toString(e) });
  }
  multipleOf(e, n) {
    return this._addCheck({ kind: "multipleOf", value: e, message: P.toString(n) });
  }
  finite(e) {
    return this._addCheck({ kind: "finite", message: P.toString(e) });
  }
  safe(e) {
    return this._addCheck({ kind: "min", inclusive: !0, value: Number.MIN_SAFE_INTEGER, message: P.toString(e) })._addCheck({ kind: "max", inclusive: !0, value: Number.MAX_SAFE_INTEGER, message: P.toString(e) });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && ie.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf") return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
an.create = (t) => new an({ checks: [], typeName: Z.ZodNumber, coerce: (t == null ? void 0 : t.coerce) || !1, ...G(t) });
class Pn extends te {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce) try {
      e.data = BigInt(e.data);
    } catch {
      return this._getInvalidInput(e);
    }
    if (this._getType(e) !== k.bigint) return this._getInvalidInput(e);
    let n;
    const r = new De();
    for (const s of this._def.checks) s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), j(n, { code: E.too_small, type: "bigint", minimum: s.value, inclusive: s.inclusive, message: s.message }), r.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), j(n, { code: E.too_big, type: "bigint", maximum: s.value, inclusive: s.inclusive, message: s.message }), r.dirty()) : s.kind === "multipleOf" ? e.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), j(n, { code: E.not_multiple_of, multipleOf: s.value, message: s.message }), r.dirty()) : ie.assertNever(s);
    return { status: r.value, value: e.data };
  }
  _getInvalidInput(e) {
    const n = this._getOrReturnCtx(e);
    return j(n, { code: E.invalid_type, expected: k.bigint, received: n.parsedType }), H;
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, P.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, P.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, P.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, P.toString(n));
  }
  setLimit(e, n, r, s) {
    return new Pn({ ...this._def, checks: [...this._def.checks, { kind: e, value: n, inclusive: r, message: P.toString(s) }] });
  }
  _addCheck(e) {
    return new Pn({ ...this._def, checks: [...this._def.checks, e] });
  }
  positive(e) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !1, message: P.toString(e) });
  }
  negative(e) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !1, message: P.toString(e) });
  }
  nonpositive(e) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !0, message: P.toString(e) });
  }
  nonnegative(e) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !0, message: P.toString(e) });
  }
  multipleOf(e, n) {
    return this._addCheck({ kind: "multipleOf", value: e, message: P.toString(n) });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
Pn.create = (t) => new Pn({ checks: [], typeName: Z.ZodBigInt, coerce: (t == null ? void 0 : t.coerce) ?? !1, ...G(t) });
class Is extends te {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== k.boolean) {
      const n = this._getOrReturnCtx(e);
      return j(n, { code: E.invalid_type, expected: k.boolean, received: n.parsedType }), H;
    }
    return Je(e.data);
  }
}
Is.create = (t) => new Is({ typeName: Z.ZodBoolean, coerce: (t == null ? void 0 : t.coerce) || !1, ...G(t) });
class Ir extends te {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== k.date) {
      const s = this._getOrReturnCtx(e);
      return j(s, { code: E.invalid_type, expected: k.date, received: s.parsedType }), H;
    }
    if (Number.isNaN(e.data.getTime())) return j(this._getOrReturnCtx(e), { code: E.invalid_date }), H;
    const n = new De();
    let r;
    for (const s of this._def.checks) s.kind === "min" ? e.data.getTime() < s.value && (r = this._getOrReturnCtx(e, r), j(r, { code: E.too_small, message: s.message, inclusive: !0, exact: !1, minimum: s.value, type: "date" }), n.dirty()) : s.kind === "max" ? e.data.getTime() > s.value && (r = this._getOrReturnCtx(e, r), j(r, { code: E.too_big, message: s.message, inclusive: !0, exact: !1, maximum: s.value, type: "date" }), n.dirty()) : ie.assertNever(s);
    return { status: n.value, value: new Date(e.data.getTime()) };
  }
  _addCheck(e) {
    return new Ir({ ...this._def, checks: [...this._def.checks, e] });
  }
  min(e, n) {
    return this._addCheck({ kind: "min", value: e.getTime(), message: P.toString(n) });
  }
  max(e, n) {
    return this._addCheck({ kind: "max", value: e.getTime(), message: P.toString(n) });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
Ir.create = (t) => new Ir({ checks: [], coerce: (t == null ? void 0 : t.coerce) || !1, typeName: Z.ZodDate, ...G(t) });
class ao extends te {
  _parse(e) {
    if (this._getType(e) !== k.symbol) {
      const n = this._getOrReturnCtx(e);
      return j(n, { code: E.invalid_type, expected: k.symbol, received: n.parsedType }), H;
    }
    return Je(e.data);
  }
}
ao.create = (t) => new ao({ typeName: Z.ZodSymbol, ...G(t) });
class uo extends te {
  _parse(e) {
    if (this._getType(e) !== k.undefined) {
      const n = this._getOrReturnCtx(e);
      return j(n, { code: E.invalid_type, expected: k.undefined, received: n.parsedType }), H;
    }
    return Je(e.data);
  }
}
uo.create = (t) => new uo({ typeName: Z.ZodUndefined, ...G(t) });
class co extends te {
  _parse(e) {
    if (this._getType(e) !== k.null) {
      const n = this._getOrReturnCtx(e);
      return j(n, { code: E.invalid_type, expected: k.null, received: n.parsedType }), H;
    }
    return Je(e.data);
  }
}
co.create = (t) => new co({ typeName: Z.ZodNull, ...G(t) });
class lo extends te {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Je(e.data);
  }
}
lo.create = (t) => new lo({ typeName: Z.ZodAny, ...G(t) });
class fo extends te {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Je(e.data);
  }
}
fo.create = (t) => new fo({ typeName: Z.ZodUnknown, ...G(t) });
class Pt extends te {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return j(n, { code: E.invalid_type, expected: k.never, received: n.parsedType }), H;
  }
}
Pt.create = (t) => new Pt({ typeName: Z.ZodNever, ...G(t) });
class ho extends te {
  _parse(e) {
    if (this._getType(e) !== k.undefined) {
      const n = this._getOrReturnCtx(e);
      return j(n, { code: E.invalid_type, expected: k.void, received: n.parsedType }), H;
    }
    return Je(e.data);
  }
}
ho.create = (t) => new ho({ typeName: Z.ZodVoid, ...G(t) });
class vt extends te {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), s = this._def;
    if (n.parsedType !== k.array) return j(n, { code: E.invalid_type, expected: k.array, received: n.parsedType }), H;
    if (s.exactLength !== null) {
      const o = n.data.length > s.exactLength.value, a = n.data.length < s.exactLength.value;
      (o || a) && (j(n, { code: o ? E.too_big : E.too_small, minimum: a ? s.exactLength.value : void 0, maximum: o ? s.exactLength.value : void 0, type: "array", inclusive: !0, exact: !0, message: s.exactLength.message }), r.dirty());
    }
    if (s.minLength !== null && n.data.length < s.minLength.value && (j(n, { code: E.too_small, minimum: s.minLength.value, type: "array", inclusive: !0, exact: !1, message: s.minLength.message }), r.dirty()), s.maxLength !== null && n.data.length > s.maxLength.value && (j(n, { code: E.too_big, maximum: s.maxLength.value, type: "array", inclusive: !0, exact: !1, message: s.maxLength.message }), r.dirty()), n.common.async) return Promise.all([...n.data].map((o, a) => s.type._parseAsync(new wt(n, o, n.path, a)))).then((o) => De.mergeArray(r, o));
    const i = [...n.data].map((o, a) => s.type._parseSync(new wt(n, o, n.path, a)));
    return De.mergeArray(r, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new vt({ ...this._def, minLength: { value: e, message: P.toString(n) } });
  }
  max(e, n) {
    return new vt({ ...this._def, maxLength: { value: e, message: P.toString(n) } });
  }
  length(e, n) {
    return new vt({ ...this._def, exactLength: { value: e, message: P.toString(n) } });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
function Vt(t) {
  if (t instanceof Te) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = At.create(Vt(r));
    }
    return new Te({ ...t._def, shape: () => e });
  }
  return t instanceof vt ? new vt({ ...t._def, type: Vt(t.element) }) : t instanceof At ? At.create(Vt(t.unwrap())) : t instanceof cn ? cn.create(Vt(t.unwrap())) : t instanceof Mt ? Mt.create(t.items.map((e) => Vt(e))) : t;
}
vt.create = (t, e) => new vt({ type: t, minLength: null, maxLength: null, exactLength: null, typeName: Z.ZodArray, ...G(e) });
class Te extends te {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const e = this._def.shape(), n = ie.objectKeys(e);
    return this._cached = { shape: e, keys: n }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== k.object) {
      const u = this._getOrReturnCtx(e);
      return j(u, { code: E.invalid_type, expected: k.object, received: u.parsedType }), H;
    }
    const { status: n, ctx: r } = this._processInputParams(e), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Pt && this._def.unknownKeys === "strip")) for (const u in r.data) i.includes(u) || o.push(u);
    const a = [];
    for (const u of i) {
      const c = s[u], l = r.data[u];
      a.push({ key: { status: "valid", value: u }, value: c._parse(new wt(r, l, r.path, u)), alwaysSet: u in r.data });
    }
    if (this._def.catchall instanceof Pt) {
      const u = this._def.unknownKeys;
      if (u === "passthrough") for (const c of o) a.push({ key: { status: "valid", value: c }, value: { status: "valid", value: r.data[c] } });
      else if (u === "strict") o.length > 0 && (j(r, { code: E.unrecognized_keys, keys: o }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of o) {
        const l = r.data[c];
        a.push({ key: { status: "valid", value: c }, value: u._parse(new wt(r, l, r.path, c)), alwaysSet: c in r.data });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const c of a) {
        const l = await c.key, d = await c.value;
        u.push({ key: l, value: d, alwaysSet: c.alwaysSet });
      }
      return u;
    }).then((u) => De.mergeObjectSync(n, u)) : De.mergeObjectSync(n, a);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return P.errToObj, new Te({ ...this._def, unknownKeys: "strict", ...e !== void 0 ? { errorMap: (n, r) => {
      var i, o;
      const s = ((o = (i = this._def).errorMap) == null ? void 0 : o.call(i, n, r).message) ?? r.defaultError;
      return n.code === "unrecognized_keys" ? { message: P.errToObj(e).message ?? s } : { message: s };
    } } : {} });
  }
  strip() {
    return new Te({ ...this._def, unknownKeys: "strip" });
  }
  passthrough() {
    return new Te({ ...this._def, unknownKeys: "passthrough" });
  }
  extend(e) {
    return new Te({ ...this._def, shape: () => ({ ...this._def.shape(), ...e }) });
  }
  merge(e) {
    return new Te({ unknownKeys: e._def.unknownKeys, catchall: e._def.catchall, shape: () => ({ ...this._def.shape(), ...e._def.shape() }), typeName: Z.ZodObject });
  }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  catchall(e) {
    return new Te({ ...this._def, catchall: e });
  }
  pick(e) {
    const n = {};
    for (const r of ie.objectKeys(e)) e[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new Te({ ...this._def, shape: () => n });
  }
  omit(e) {
    const n = {};
    for (const r of ie.objectKeys(this.shape)) e[r] || (n[r] = this.shape[r]);
    return new Te({ ...this._def, shape: () => n });
  }
  deepPartial() {
    return Vt(this);
  }
  partial(e) {
    const n = {};
    for (const r of ie.objectKeys(this.shape)) {
      const s = this.shape[r];
      e && !e[r] ? n[r] = s : n[r] = s.optional();
    }
    return new Te({ ...this._def, shape: () => n });
  }
  required(e) {
    const n = {};
    for (const r of ie.objectKeys(this.shape)) if (e && !e[r]) n[r] = this.shape[r];
    else {
      let s = this.shape[r];
      for (; s instanceof At; ) s = s._def.innerType;
      n[r] = s;
    }
    return new Te({ ...this._def, shape: () => n });
  }
  keyof() {
    return za(ie.objectKeys(this.shape));
  }
}
Te.create = (t, e) => new Te({ shape: () => t, unknownKeys: "strip", catchall: Pt.create(), typeName: Z.ZodObject, ...G(e) }), Te.strictCreate = (t, e) => new Te({ shape: () => t, unknownKeys: "strict", catchall: Pt.create(), typeName: Z.ZodObject, ...G(e) }), Te.lazycreate = (t, e) => new Te({ shape: t, unknownKeys: "strip", catchall: Pt.create(), typeName: Z.ZodObject, ...G(e) });
class Lr extends te {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    if (n.common.async) return Promise.all(r.map(async (s) => {
      const i = { ...n, common: { ...n.common, issues: [] }, parent: null };
      return { result: await s._parseAsync({ data: n.data, path: n.path, parent: i }), ctx: i };
    })).then(function(s) {
      for (const o of s) if (o.result.status === "valid") return o.result;
      for (const o of s) if (o.result.status === "dirty") return n.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new Tt(o.ctx.common.issues));
      return j(n, { code: E.invalid_union, unionErrors: i }), H;
    });
    {
      let s;
      const i = [];
      for (const a of r) {
        const u = { ...n, common: { ...n.common, issues: [] }, parent: null }, c = a._parseSync({ data: n.data, path: n.path, parent: u });
        if (c.status === "valid") return c;
        c.status !== "dirty" || s || (s = { result: c, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (s) return n.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((a) => new Tt(a));
      return j(n, { code: E.invalid_union, unionErrors: o }), H;
    }
  }
  get options() {
    return this._def.options;
  }
}
function Ls(t, e) {
  const n = kt(t), r = kt(e);
  if (t === e) return { valid: !0, data: t };
  if (n === k.object && r === k.object) {
    const s = ie.objectKeys(e), i = ie.objectKeys(t).filter((a) => s.indexOf(a) !== -1), o = { ...t, ...e };
    for (const a of i) {
      const u = Ls(t[a], e[a]);
      if (!u.valid) return { valid: !1 };
      o[a] = u.data;
    }
    return { valid: !0, data: o };
  }
  if (n === k.array && r === k.array) {
    if (t.length !== e.length) return { valid: !1 };
    const s = [];
    for (let i = 0; i < t.length; i++) {
      const o = Ls(t[i], e[i]);
      if (!o.valid) return { valid: !1 };
      s.push(o.data);
    }
    return { valid: !0, data: s };
  }
  return n === k.date && r === k.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
Lr.create = (t, e) => new Lr({ options: t, typeName: Z.ZodUnion, ...G(e) });
class Ur extends te {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = (i, o) => {
      if (so(i) || so(o)) return H;
      const a = Ls(i.value, o.value);
      return a.valid ? ((io(i) || io(o)) && n.dirty(), { status: n.value, value: a.data }) : (j(r, { code: E.invalid_intersection_types }), H);
    };
    return r.common.async ? Promise.all([this._def.left._parseAsync({ data: r.data, path: r.path, parent: r }), this._def.right._parseAsync({ data: r.data, path: r.path, parent: r })]).then(([i, o]) => s(i, o)) : s(this._def.left._parseSync({ data: r.data, path: r.path, parent: r }), this._def.right._parseSync({ data: r.data, path: r.path, parent: r }));
  }
}
Ur.create = (t, e, n) => new Ur({ left: t, right: e, typeName: Z.ZodIntersection, ...G(n) });
class Mt extends te {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.array) return j(r, { code: E.invalid_type, expected: k.array, received: r.parsedType }), H;
    if (r.data.length < this._def.items.length) return j(r, { code: E.too_small, minimum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), H;
    !this._def.rest && r.data.length > this._def.items.length && (j(r, { code: E.too_big, maximum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), n.dirty());
    const s = [...r.data].map((i, o) => {
      const a = this._def.items[o] || this._def.rest;
      return a ? a._parse(new wt(r, i, r.path, o)) : null;
    }).filter((i) => !!i);
    return r.common.async ? Promise.all(s).then((i) => De.mergeArray(n, i)) : De.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Mt({ ...this._def, rest: e });
  }
}
Mt.create = (t, e) => {
  if (!Array.isArray(t)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Mt({ items: t, typeName: Z.ZodTuple, rest: null, ...G(e) });
};
class Ys extends te {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.object) return j(r, { code: E.invalid_type, expected: k.object, received: r.parsedType }), H;
    const s = [], i = this._def.keyType, o = this._def.valueType;
    for (const a in r.data) s.push({ key: i._parse(new wt(r, a, r.path, a)), value: o._parse(new wt(r, r.data[a], r.path, a)), alwaysSet: a in r.data });
    return r.common.async ? De.mergeObjectAsync(n, s) : De.mergeObjectSync(n, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return new Ys(n instanceof te ? { keyType: e, valueType: n, typeName: Z.ZodRecord, ...G(r) } : { keyType: Et.create(), valueType: e, typeName: Z.ZodRecord, ...G(n) });
  }
}
class po extends te {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.map) return j(r, { code: E.invalid_type, expected: k.map, received: r.parsedType }), H;
    const s = this._def.keyType, i = this._def.valueType, o = [...r.data.entries()].map(([a, u], c) => ({ key: s._parse(new wt(r, a, r.path, [c, "key"])), value: i._parse(new wt(r, u, r.path, [c, "value"])) }));
    if (r.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of o) {
          const c = await u.key, l = await u.value;
          if (c.status === "aborted" || l.status === "aborted") return H;
          c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
        }
        return { status: n.value, value: a };
      });
    }
    {
      const a = /* @__PURE__ */ new Map();
      for (const u of o) {
        const c = u.key, l = u.value;
        if (c.status === "aborted" || l.status === "aborted") return H;
        c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
      }
      return { status: n.value, value: a };
    }
  }
}
po.create = (t, e, n) => new po({ valueType: e, keyType: t, typeName: Z.ZodMap, ...G(n) });
class An extends te {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.set) return j(r, { code: E.invalid_type, expected: k.set, received: r.parsedType }), H;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (j(r, { code: E.too_small, minimum: s.minSize.value, type: "set", inclusive: !0, exact: !1, message: s.minSize.message }), n.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (j(r, { code: E.too_big, maximum: s.maxSize.value, type: "set", inclusive: !0, exact: !1, message: s.maxSize.message }), n.dirty());
    const i = this._def.valueType;
    function o(u) {
      const c = /* @__PURE__ */ new Set();
      for (const l of u) {
        if (l.status === "aborted") return H;
        l.status === "dirty" && n.dirty(), c.add(l.value);
      }
      return { status: n.value, value: c };
    }
    const a = [...r.data.values()].map((u, c) => i._parse(new wt(r, u, r.path, c)));
    return r.common.async ? Promise.all(a).then((u) => o(u)) : o(a);
  }
  min(e, n) {
    return new An({ ...this._def, minSize: { value: e, message: P.toString(n) } });
  }
  max(e, n) {
    return new An({ ...this._def, maxSize: { value: e, message: P.toString(n) } });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
An.create = (t, e) => new An({ valueType: t, minSize: null, maxSize: null, typeName: Z.ZodSet, ...G(e) });
class mo extends te {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
mo.create = (t, e) => new mo({ getter: t, typeName: Z.ZodLazy, ...G(e) });
class go extends te {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return j(n, { received: n.data, code: E.invalid_literal, expected: this._def.value }), H;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
function za(t, e) {
  return new un({ values: t, typeName: Z.ZodEnum, ...G(e) });
}
go.create = (t, e) => new go({ value: t, typeName: Z.ZodLiteral, ...G(e) });
class un extends te {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return j(n, { expected: ie.joinValues(r), received: n.parsedType, code: E.invalid_type }), H;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return j(n, { received: n.data, code: E.invalid_enum_value, options: r }), H;
    }
    return Je(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values) e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values) e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values) e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return un.create(e, { ...this._def, ...n });
  }
  exclude(e, n = this._def) {
    return un.create(this.options.filter((r) => !e.includes(r)), { ...this._def, ...n });
  }
}
un.create = za;
class vo extends te {
  _parse(e) {
    const n = ie.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== k.string && r.parsedType !== k.number) {
      const s = ie.objectValues(n);
      return j(r, { expected: ie.joinValues(s), received: r.parsedType, code: E.invalid_type }), H;
    }
    if (this._cache || (this._cache = new Set(ie.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const s = ie.objectValues(n);
      return j(r, { received: r.data, code: E.invalid_enum_value, options: s }), H;
    }
    return Je(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
vo.create = (t, e) => new vo({ values: t, typeName: Z.ZodNativeEnum, ...G(e) });
class Nr extends te {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== k.promise && n.common.async === !1) return j(n, { code: E.invalid_type, expected: k.promise, received: n.parsedType }), H;
    const r = n.parsedType === k.promise ? n.data : Promise.resolve(n.data);
    return Je(r.then((s) => this._def.type.parseAsync(s, { path: n.path, errorMap: n.common.contextualErrorMap })));
  }
}
Nr.create = (t, e) => new Nr({ type: t, typeName: Z.ZodPromise, ...G(e) });
class Kt extends te {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Z.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = this._def.effect || null, i = { addIssue: (o) => {
      j(r, o), o.fatal ? n.abort() : n.dirty();
    }, get path() {
      return r.path;
    } };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const o = s.transform(r.data, i);
      if (r.common.async) return Promise.resolve(o).then(async (a) => {
        if (n.value === "aborted") return H;
        const u = await this._def.schema._parseAsync({ data: a, path: r.path, parent: r });
        return u.status === "aborted" ? H : u.status === "dirty" || n.value === "dirty" ? As(u.value) : u;
      });
      {
        if (n.value === "aborted") return H;
        const a = this._def.schema._parseSync({ data: o, path: r.path, parent: r });
        return a.status === "aborted" ? H : a.status === "dirty" || n.value === "dirty" ? As(a.value) : a;
      }
    }
    if (s.type === "refinement") {
      const o = (a) => {
        const u = s.refinement(a, i);
        if (r.common.async) return Promise.resolve(u);
        if (u instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        return a.status === "aborted" ? H : (a.status === "dirty" && n.dirty(), o(a.value), { status: n.value, value: a.value });
      }
      return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => a.status === "aborted" ? H : (a.status === "dirty" && n.dirty(), o(a.value).then(() => ({ status: n.value, value: a.value }))));
    }
    if (s.type === "transform") {
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        if (!on(o)) return H;
        const a = s.transform(o.value, i);
        if (a instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: a };
      }
      return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => on(o) ? Promise.resolve(s.transform(o.value, i)).then((a) => ({ status: n.value, value: a })) : H);
    }
    ie.assertNever(s);
  }
}
Kt.create = (t, e, n) => new Kt({ schema: t, typeName: Z.ZodEffects, effect: e, ...G(n) }), Kt.createWithPreprocess = (t, e, n) => new Kt({ schema: e, effect: { type: "preprocess", transform: t }, typeName: Z.ZodEffects, ...G(n) });
class At extends te {
  _parse(e) {
    return this._getType(e) === k.undefined ? Je(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
At.create = (t, e) => new At({ innerType: t, typeName: Z.ZodOptional, ...G(e) });
class cn extends te {
  _parse(e) {
    return this._getType(e) === k.null ? Je(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
cn.create = (t, e) => new cn({ innerType: t, typeName: Z.ZodNullable, ...G(e) });
class Us extends te {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === k.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({ data: r, path: n.path, parent: n });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Us.create = (t, e) => new Us({ innerType: t, typeName: Z.ZodDefault, defaultValue: typeof e.default == "function" ? e.default : () => e.default, ...G(e) });
class Ns extends te {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = { ...n, common: { ...n.common, issues: [] } }, s = this._def.innerType._parse({ data: r.data, path: r.path, parent: { ...r } });
    return Ar(s) ? s.then((i) => ({ status: "valid", value: i.status === "valid" ? i.value : this._def.catchValue({ get error() {
      return new Tt(r.common.issues);
    }, input: r.data }) })) : { status: "valid", value: s.status === "valid" ? s.value : this._def.catchValue({ get error() {
      return new Tt(r.common.issues);
    }, input: r.data }) };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ns.create = (t, e) => new Ns({ innerType: t, typeName: Z.ZodCatch, catchValue: typeof e.catch == "function" ? e.catch : () => e.catch, ...G(e) });
class yo extends te {
  _parse(e) {
    if (this._getType(e) !== k.nan) {
      const n = this._getOrReturnCtx(e);
      return j(n, { code: E.invalid_type, expected: k.nan, received: n.parsedType }), H;
    }
    return { status: "valid", value: e.data };
  }
}
yo.create = (t) => new yo({ typeName: Z.ZodNaN, ...G(t) });
class Dd extends te {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({ data: r, path: n.path, parent: n });
  }
  unwrap() {
    return this._def.type;
  }
}
class Xs extends te {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async) return (async () => {
      const s = await this._def.in._parseAsync({ data: r.data, path: r.path, parent: r });
      return s.status === "aborted" ? H : s.status === "dirty" ? (n.dirty(), As(s.value)) : this._def.out._parseAsync({ data: s.value, path: r.path, parent: r });
    })();
    {
      const s = this._def.in._parseSync({ data: r.data, path: r.path, parent: r });
      return s.status === "aborted" ? H : s.status === "dirty" ? (n.dirty(), { status: "dirty", value: s.value }) : this._def.out._parseSync({ data: s.value, path: r.path, parent: r });
    }
  }
  static create(e, n) {
    return new Xs({ in: e, out: n, typeName: Z.ZodPipeline });
  }
}
class Ds extends te {
  _parse(e) {
    const n = this._def.innerType._parse(e), r = (s) => (on(s) && (s.value = Object.freeze(s.value)), s);
    return Ar(n) ? n.then((s) => r(s)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
var Z;
Ds.create = (t, e) => new Ds({ innerType: t, typeName: Z.ZodReadonly, ...G(e) }), function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
}(Z || (Z = {}));
const O = Et.create, ee = an.create, ln = Is.create, yt = (Pt.create, vt.create), ve = Te.create, Kn = Lr.create, $d = (Ur.create, Mt.create, Ys.create), bt = un.create;
Nr.create, At.create, cn.create;
var qa = ee().min(0).max(gd).refine(function(t) {
  return Math.abs(Math.round(10 * t) - 10 * t) < 1e-6;
}, { message: "score must be a multiple of 0.1" }), Za = bt(["N", "C"]), Fd = ve({ id: O().optional(), type: Za.default("N"), movementNumber: ee().int().positive(), description: O(), directive: O().optional(), location: O().optional(), coefficient: ee().int().min(1).max(10), section: bt(["technical", "artistic", "quality"]).optional() }), Bd = ve({ id: O().optional(), type: Za.default("C"), movementNumber: ee().int().positive(), name: O(), directive: O().optional(), coefficient: ee().int().min(1).max(2) });
ve({ id: O(), fvdId: Kn([ee(), O()]).nullable().optional(), source: bt(["catalog", "custom"]).optional(), testCode: O(), organization: O().optional(), level: O().optional(), testNumber: ee().int().optional(), movements: yt(Fd), collectives: yt(Bd), purpose: O().optional(), introduce: O().optional(), errorRule: ve({ first: Kn([ee(), O()]).nullable().optional(), second: Kn([ee(), O()]).nullable().optional(), third: Kn([ee(), O()]).nullable().optional() }).nullable().optional(), collectivesLabel: O().default("Collective Marks") });
var Md = ve({ movementNumber: ee().int().positive(), score: qa.optional().nullable(), remarks: O().max(500).optional(), flagged: ln().default(!1), annotatedDirective: O().optional(), annotatedDescription: O().optional(), deductions: yt(ve({ id: O(), reason: O(), points: ee().positive() })).optional() }), zd = ve({ score: qa.optional(), remarks: O().max(500).optional(), flagged: ln().optional(), annotatedName: O().optional(), annotatedDirective: O().optional() }), qd = $d(O().regex(/^\d+$/), zd);
ve({ id: O().optional(), rideId: O(), judgeId: O(), testId: O(), movementScores: yt(Md).default([]), collectives: qd.default({}), annotatedPurpose: O().optional(), annotatedIntroduce: O().optional(), generalRemarks: O().max(2e3).optional(), entryTimeSeconds: ee().nonnegative().optional(), totalPoints: ee().optional(), maxPoints: ee().optional(), percentage: ee().optional(), technicalPoints: ee().optional(), technicalMaxPoints: ee().optional(), artisticPoints: ee().optional(), artisticMaxPoints: ee().optional(), qualityPoints: ee().optional(), qualityMaxPoints: ee().optional(), judgeSignature: O().optional(), signature: ve({ judgeId: O(), signatureHash: O(), signedAt: O() }).optional(), eliminations: yt(ve({ id: O(), reason: O(), movementNumber: ee().int().positive().nullable().optional(), fromError: ln().optional() })).optional(), errors: yt(ve({ id: O(), label: O(), points: ee().nonnegative().optional(), percent: ee().nonnegative().optional(), movementNumber: ee().int().positive().nullable().optional() })).optional(), marksConfirmedAt: O().optional(), marksConfirmedBy: O().optional(), timeFault: ve({ exceeded: ln(), elapsedSeconds: ee(), limitSeconds: ee(), recordedAt: O() }).optional(), completedAt: O().optional() });
bt($a);
var bo = ve(Object.fromEntries($a.map(function(t) {
  return [t, yt(O()).optional()];
})));
ve({ id: O(), showId: O(), testId: O().optional(), className: O(), scheduledTime: O(), ring: O().optional(), judgeAssignments: bo.optional(), judgeIds: yt(O()).optional(), scribeAssignments: bo.optional(), qualityJudging: ve({ topology: bt(["two-judge", "technical-only"]), qualityPosition: bt(["E", "B"]).nullable().optional(), qualityJudge: O().nullable().optional() }).optional(), faultTimeLimitSeconds: ee().int().positive().default(45), errorDeductionScheme: bt(Object.values(no)).default(no.POINTS), sectionJudgeAssignments: ve({ technical: O().nullable().optional(), quality: O().nullable().optional() }).optional(), status: O().optional(), order: ee().optional() });
var Zd = ve({ id: O(), type: bt(Object.values(Fa)), raisedByScribeId: O().nullable(), raisedAt: O(), acknowledged: ve({ byScribeId: O().nullable(), at: O() }).nullable().optional() });
ve({ type: bt(Object.values(Fa)) });
ve({ id: O(), classId: O(), testId: O().optional(), horseId: O(), riderId: O(), rideNumber: ee().int().positive(), scheduledTime: O().optional(), status: O().optional(), percentage: ee().optional(), allSheetsCompletedAt: O().nullable().optional(), adminConfirmedAt: O().nullable().optional(), adminConfirmedBy: O().nullable().optional(), compositePercentage: ee().nullable().optional(), placing: ee().int().positive().nullable().optional(), isManual: ln().optional(), needsReview: ln().optional(), judgeIds: yt(O()).optional(), competitorNumber: O().optional(), horseName: O().optional(), riderName: O().optional(), resolvedIntoRideId: O().nullable().optional(), utilityEvents: yt(Zd).optional() });
ve({ classId: O(), testId: O().optional(), competitorNumber: O().optional(), horseName: O().optional(), riderName: O().optional() });
ve({ id: O(), personType: bt(["RIDER", "JUDGE", "SCRIBE"]), firstName: O(), lastName: O(), usefId: O().optional(), email: O().optional(), unlockCode: O().regex(/^\d{4,6}$/, "unlockCode must be 4–6 digits").optional(), userId: O().optional() });
ve({ id: O(), name: O(), breed: O().optional(), foalYear: ee().int().optional(), usefId: O().optional() });
function Ha(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: Hd } = Object.prototype, { getPrototypeOf: Qs } = Object, { iterator: dr, toStringTag: Wa } = Symbol, Dr = (ls = /* @__PURE__ */ Object.create(null), (t) => {
  const e = Hd.call(t);
  return ls[e] || (ls[e] = e.slice(8, -1).toLowerCase());
});
var ls;
const ft = (t) => (t = t.toLowerCase(), (e) => Dr(e) === t), Hr = (t) => (e) => typeof e === t, { isArray: Gt } = Array, tn = Hr("undefined");
function On(t) {
  return t !== null && !tn(t) && t.constructor !== null && !tn(t.constructor) && Be(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const wo = ft("ArrayBuffer"), Wd = Hr("string"), Be = Hr("function"), xo = Hr("number"), vn = (t) => t !== null && typeof t == "object", Yn = (t) => {
  if (Dr(t) !== "object") return !1;
  const e = Qs(t);
  return !(e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || Wa in t || dr in t);
}, Jd = ft("Date"), Vd = ft("File"), Gd = ft("Blob"), Kd = ft("FileList"), Yd = ft("URLSearchParams"), [Xd, Qd, ef, tf] = ["ReadableStream", "Request", "Response", "Headers"].map(ft);
function Rn(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t == null) return;
  let r, s;
  if (typeof t != "object" && (t = [t]), Gt(t)) for (r = 0, s = t.length; r < s; r++) e.call(null, t[r], r, t);
  else {
    if (On(t)) return;
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let a;
    for (r = 0; r < o; r++) a = i[r], e.call(null, t[a], a, t);
  }
}
function So(t, e) {
  if (On(t)) return null;
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r, s = n.length;
  for (; s-- > 0; ) if (r = n[s], e === r.toLowerCase()) return r;
  return null;
}
const Dt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ro = (t) => !tn(t) && t !== Dt, nf = (ds = typeof Uint8Array < "u" && Qs(Uint8Array), (t) => ds && t instanceof ds);
var ds;
const rf = ft("HTMLFormElement"), _o = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), sf = ft("RegExp"), Oo = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  Rn(n, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(t, r);
}, of = ft("AsyncFunction"), Ja = (Eo = typeof setImmediate == "function", To = Be(Dt.postMessage), Eo ? setImmediate : To ? (fs = `axios@${Math.random()}`, Xn = [], Dt.addEventListener("message", ({ source: t, data: e }) => {
  t === Dt && e === fs && Xn.length && Xn.shift()();
}, !1), (t) => {
  Xn.push(t), Dt.postMessage(fs, "*");
}) : (t) => setTimeout(t));
var Eo, To, fs, Xn;
const af = typeof queueMicrotask < "u" ? queueMicrotask.bind(Dt) : typeof process < "u" && process.nextTick || Ja, b = { isArray: Gt, isArrayBuffer: wo, isBuffer: On, isFormData: (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Be(t.append) && ((e = Dr(t)) === "formdata" || e === "object" && Be(t.toString) && t.toString() === "[object FormData]"));
}, isArrayBufferView: function(t) {
  let e;
  return e = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && wo(t.buffer), e;
}, isString: Wd, isNumber: xo, isBoolean: (t) => t === !0 || t === !1, isObject: vn, isPlainObject: Yn, isEmptyObject: (t) => {
  if (!vn(t) || On(t)) return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: Xd, isRequest: Qd, isResponse: ef, isHeaders: tf, isUndefined: tn, isDate: Jd, isFile: Vd, isBlob: Gd, isRegExp: sf, isFunction: Be, isStream: (t) => vn(t) && Be(t.pipe), isURLSearchParams: Yd, isTypedArray: nf, isFileList: Kd, forEach: Rn, merge: function t() {
  const { caseless: e, skipUndefined: n } = Ro(this) && this || {}, r = {}, s = (i, o) => {
    const a = e && So(r, o) || o;
    Yn(r[a]) && Yn(i) ? r[a] = t(r[a], i) : Yn(i) ? r[a] = t({}, i) : Gt(i) ? r[a] = i.slice() : n && tn(i) || (r[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && Rn(arguments[i], s);
  return r;
}, extend: (t, e, n, { allOwnKeys: r } = {}) => (Rn(e, (s, i) => {
  n && Be(s) ? t[i] = Ha(s, n) : t[i] = s;
}, { allOwnKeys: r }), t), trim: (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), inherits: (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", { value: e.prototype }), n && Object.assign(t.prototype, n);
}, toFlatObject: (t, e, n, r) => {
  let s, i, o;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; ) o = s[i], r && !r(o, t, e) || a[o] || (e[o] = t[o], a[o] = !0);
    t = n !== !1 && Qs(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, kindOf: Dr, kindOfTest: ft, endsWith: (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, toArray: (t) => {
  if (!t) return null;
  if (Gt(t)) return t;
  let e = t.length;
  if (!xo(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; ) n[e] = t[e];
  return n;
}, forEachEntry: (t, e) => {
  const n = (t && t[dr]).call(t);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const s = r.value;
    e.call(t, s[0], s[1]);
  }
}, matchAll: (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; ) r.push(n);
  return r;
}, isHTMLForm: rf, hasOwnProperty: _o, hasOwnProp: _o, reduceDescriptors: Oo, freezeMethods: (t) => {
  Oo(t, (e, n) => {
    if (Be(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const r = t[n];
    Be(r) && (e.enumerable = !1, "writable" in e ? e.writable = !1 : e.set || (e.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (t, e) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return Gt(t) ? r(t) : r(String(t).split(e)), n;
}, toCamelCase: (t) => t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, n, r) {
  return n.toUpperCase() + r;
}), noop: () => {
}, toFiniteNumber: (t, e) => t != null && Number.isFinite(t = +t) ? t : e, findKey: So, global: Dt, isContextDefined: Ro, isSpecCompliantForm: function(t) {
  return !!(t && Be(t.append) && t[Wa] === "FormData" && t[dr]);
}, toJSONObject: (t) => {
  const e = new Array(10), n = (r, s) => {
    if (vn(r)) {
      if (e.indexOf(r) >= 0) return;
      if (On(r)) return r;
      if (!("toJSON" in r)) {
        e[s] = r;
        const i = Gt(r) ? [] : {};
        return Rn(r, (o, a) => {
          const u = n(o, s + 1);
          !tn(u) && (i[a] = u);
        }), e[s] = void 0, i;
      }
    }
    return r;
  };
  return n(t, 0);
}, isAsyncFn: of, isThenable: (t) => t && (vn(t) || Be(t)) && Be(t.then) && Be(t.catch), setImmediate: Ja, asap: af, isIterable: (t) => t != null && Be(t[dr]) };
function nn(t, e, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
b.inherits(nn, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: b.toJSONObject(this.config), code: this.code, status: this.status };
} });
const jo = nn.prototype, Co = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((t) => {
  Co[t] = { value: t };
}), Object.defineProperties(nn, Co), Object.defineProperty(jo, "isAxiosError", { value: !0 }), nn.from = (t, e, n, r, s, i) => {
  const o = Object.create(jo);
  b.toFlatObject(t, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = t && t.message ? t.message : "Error", u = e == null && t ? t.code : e;
  return nn.call(o, a, u, n, r, s), t && o.cause == null && Object.defineProperty(o, "cause", { value: t, configurable: !0 }), o.name = t && t.name || "Error", i && Object.assign(o, i), o;
};
const X = nn;
function hs(t) {
  return b.isPlainObject(t) || b.isArray(t);
}
function Va(t) {
  return b.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function ko(t, e, n) {
  return t ? t.concat(e).map(function(r, s) {
    return r = Va(r), !n && s ? "[" + r + "]" : r;
  }).join(n ? "." : "") : e;
}
const uf = b.toFlatObject(b, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
}), $r = function(t, e, n) {
  if (!b.isObject(t)) throw new TypeError("target must be an object");
  e = e || new FormData();
  const r = (n = b.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(f, h) {
    return !b.isUndefined(h[f]);
  })).metaTokens, s = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && b.isSpecCompliantForm(e);
  if (!b.isFunction(s)) throw new TypeError("visitor must be a function");
  function u(f) {
    if (f === null) return "";
    if (b.isDate(f)) return f.toISOString();
    if (b.isBoolean(f)) return f.toString();
    if (!a && b.isBlob(f)) throw new X("Blob is not supported. Use a Buffer instead.");
    return b.isArrayBuffer(f) || b.isTypedArray(f) ? a && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, h, v) {
    let p = f;
    if (f && !v && typeof f == "object") {
      if (b.endsWith(h, "{}")) h = r ? h : h.slice(0, -2), f = JSON.stringify(f);
      else if (b.isArray(f) && function(R) {
        return b.isArray(R) && !R.some(hs);
      }(f) || (b.isFileList(f) || b.endsWith(h, "[]")) && (p = b.toArray(f))) return h = Va(h), p.forEach(function(R, J) {
        !b.isUndefined(R) && R !== null && e.append(o === !0 ? ko([h], J, i) : o === null ? h : h + "[]", u(R));
      }), !1;
    }
    return !!hs(f) || (e.append(ko(v, h, i), u(f)), !1);
  }
  const l = [], d = Object.assign(uf, { defaultVisitor: c, convertValue: u, isVisitable: hs });
  if (!b.isObject(t)) throw new TypeError("data must be an object");
  return function f(h, v) {
    if (!b.isUndefined(h)) {
      if (l.indexOf(h) !== -1) throw Error("Circular reference detected in " + v.join("."));
      l.push(h), b.forEach(h, function(p, R) {
        (!(b.isUndefined(p) || p === null) && s.call(e, p, b.isString(R) ? R.trim() : R, v, d)) === !0 && f(p, v ? v.concat(R) : [R]);
      }), l.pop();
    }
  }(t), e;
};
function Po(t) {
  const e = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function Ga(t, e) {
  this._pairs = [], t && $r(t, this, e);
}
const Ao = Ga.prototype;
Ao.append = function(t, e) {
  this._pairs.push([t, e]);
}, Ao.toString = function(t) {
  const e = t ? function(n) {
    return t.call(this, n, Po);
  } : Po;
  return this._pairs.map(function(n) {
    return e(n[0]) + "=" + e(n[1]);
  }, "").join("&");
};
const Ka = Ga;
function cf(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Ya(t, e, n) {
  if (!e) return t;
  const r = n && n.encode || cf;
  b.isFunction(n) && (n = { serialize: n });
  const s = n && n.serialize;
  let i;
  if (i = s ? s(e, n) : b.isURLSearchParams(e) ? e.toString() : new Ka(e, n).toString(r), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
const Io = class {
  constructor() {
    this.handlers = [];
  }
  use(t, e, n) {
    return this.handlers.push({ fulfilled: t, rejected: e, synchronous: !!n && n.synchronous, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
  }
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(t) {
    b.forEach(this.handlers, function(e) {
      e !== null && t(e);
    });
  }
}, Xa = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, lf = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Ka, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, ei = typeof window < "u" && typeof document < "u", $s = typeof navigator == "object" && navigator || void 0, df = ei && (!$s || ["ReactNative", "NativeScript", "NS"].indexOf($s.product) < 0), ff = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", hf = ei && window.location.href || "http://localhost", Le = { ...ks, ...lf }, Qa = function(t) {
  function e(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && b.isArray(s) ? s.length : o, u ? (b.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : (s[o] && b.isObject(s[o]) || (s[o] = []), e(n, r, s[o], i) && b.isArray(s[o]) && (s[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let f;
      const h = d.length;
      let v;
      for (f = 0; f < h; f++) v = d[f], l[v] = c[v];
      return l;
    }(s[o])), !a);
  }
  if (b.isFormData(t) && b.isFunction(t.entries)) {
    const n = {};
    return b.forEachEntry(t, (r, s) => {
      e(function(i) {
        return b.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(r), s, n, 0);
    }), n;
  }
  return null;
}, ti = { transitional: Xa, adapter: ["xhr", "http", "fetch"], transformRequest: [function(t, e) {
  const n = e.getContentType() || "", r = n.indexOf("application/json") > -1, s = b.isObject(t);
  if (s && b.isHTMLForm(t) && (t = new FormData(t)), b.isFormData(t)) return r ? JSON.stringify(Qa(t)) : t;
  if (b.isArrayBuffer(t) || b.isBuffer(t) || b.isStream(t) || b.isFile(t) || b.isBlob(t) || b.isReadableStream(t)) return t;
  if (b.isArrayBufferView(t)) return t.buffer;
  if (b.isURLSearchParams(t)) return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
  let i;
  if (s) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return $r(o, new Le.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return Le.isNode && b.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(t, this.formSerializer).toString();
    if ((i = b.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return $r(i ? { "files[]": t } : t, o && new o(), this.formSerializer);
    }
  }
  return s || r ? (e.setContentType("application/json", !1), function(o) {
    if (b.isString(o)) try {
      return (0, JSON.parse)(o), b.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(t)) : t;
}], transformResponse: [function(t) {
  const e = this.transitional || ti.transitional, n = e && e.forcedJSONParsing, r = this.responseType === "json";
  if (b.isResponse(t) || b.isReadableStream(t)) return t;
  if (t && b.isString(t) && (n && !this.responseType || r)) {
    const s = !(e && e.silentJSONParsing) && r;
    try {
      return JSON.parse(t, this.parseReviver);
    } catch (i) {
      if (s)
        throw i.name === "SyntaxError" ? X.from(i, X.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return t;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Le.classes.FormData, Blob: Le.classes.Blob }, validateStatus: function(t) {
  return t >= 200 && t < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
b.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  ti.headers[t] = {};
});
const ni = ti, pf = b.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Lo = Symbol("internals");
function yn(t) {
  return t && String(t).trim().toLowerCase();
}
function fr(t) {
  return t === !1 || t == null ? t : b.isArray(t) ? t.map(fr) : String(t);
}
function ps(t, e, n, r, s) {
  return b.isFunction(r) ? r.call(this, e, n) : (s && (e = n), b.isString(e) ? b.isString(r) ? e.indexOf(r) !== -1 : b.isRegExp(r) ? r.test(e) : void 0 : void 0);
}
class hr {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const s = this;
    function i(a, u, c) {
      const l = yn(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = b.findKey(s, l);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || u] = fr(a));
    }
    const o = (a, u) => b.forEach(a, (c, l) => i(c, l, u));
    if (b.isPlainObject(e) || e instanceof this.constructor) o(e, n);
    else if (b.isString(e) && (e = e.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(f) {
        d = f.indexOf(":"), c = f.substring(0, d).trim().toLowerCase(), l = f.substring(d + 1).trim(), !c || u[c] && pf[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(e), n);
    else if (b.isObject(e) && b.isIterable(e)) {
      let a, u, c = {};
      for (const l of e) {
        if (!b.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? b.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else e != null && i(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = yn(e)) {
      const r = b.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!n) return s;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(s);
        if (b.isFunction(n)) return n.call(this, s, r);
        if (b.isRegExp(n)) return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = yn(e)) {
      const r = b.findKey(this, e);
      return !(!r || this[r] === void 0 || n && !ps(0, this[r], r, n));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = yn(o)) {
        const a = b.findKey(r, o);
        !a || n && !ps(0, r[a], a, n) || (delete r[a], s = !0);
      }
    }
    return b.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      e && !ps(0, this[i], i, e, !0) || (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const n = this, r = {};
    return b.forEach(this, (s, i) => {
      const o = b.findKey(r, i);
      if (o) return n[o] = fr(s), void delete n[i];
      const a = e ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = fr(s), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return b.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = e && b.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const n = (this[Lo] = this[Lo] = { accessors: {} }).accessors, r = this.prototype;
    function s(i) {
      const o = yn(i);
      n[o] || (function(a, u) {
        const c = b.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, f, h) {
            return this[l].call(this, u, d, f, h);
          }, configurable: !0 });
        });
      }(r, i), n[o] = !0);
    }
    return b.isArray(e) ? e.forEach(s) : s(e), this;
  }
}
hr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), b.reduceDescriptors(hr.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return { get: () => t, set(r) {
    this[n] = r;
  } };
}), b.freezeMethods(hr);
const lt = hr;
function ms(t, e) {
  const n = this || ni, r = e || n, s = lt.from(r.headers);
  let i = r.data;
  return b.forEach(t, function(o) {
    i = o.call(n, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function eu(t) {
  return !(!t || !t.__CANCEL__);
}
function tu(t, e, n) {
  X.call(this, t ?? "canceled", X.ERR_CANCELED, e, n), this.name = "CanceledError";
}
b.inherits(tu, X, { __CANCEL__: !0 });
const zn = tu;
function nu(t, e, n) {
  const r = n.config.validateStatus;
  n.status && r && !r(n.status) ? e(new X("Request failed with status code " + n.status, [X.ERR_BAD_REQUEST, X.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : t(n);
}
const Fr = (t, e, n = 3) => {
  let r = 0;
  const s = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(f) {
      const h = Date.now(), v = u[d];
      c || (c = h), a[l] = f, u[l] = h;
      let p = d, R = 0;
      for (; p !== l; ) R += a[p++], p %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), h - c < o) return;
      const J = v && h - v;
      return J ? Math.round(1e3 * R / J) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (f, h = Date.now()) => {
      c = h, a = null, u && (clearTimeout(u), u = null), i(...f);
    };
    return [(...f) => {
      const h = Date.now(), v = h - c;
      v >= l ? d(f, h) : (a = f, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - v)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - r, c = s(u);
    r = o, t({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [e ? "download" : "upload"]: !0 });
  }, n);
}, Uo = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({ lengthComputable: n, total: t, loaded: r }), e[1]];
}, No = (t) => (...e) => b.asap(() => t(...e)), mf = Le.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, Le.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(new URL(Le.origin), Le.navigator && /(msie|trident)/i.test(Le.navigator.userAgent)) : () => !0, gf = Le.hasStandardBrowserEnv ? { write(t, e, n, r, s, i, o) {
  if (typeof document > "u") return;
  const a = [`${t}=${encodeURIComponent(e)}`];
  b.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), b.isString(r) && a.push(`path=${r}`), b.isString(s) && a.push(`domain=${s}`), i === !0 && a.push("secure"), b.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(t) {
  if (typeof document > "u") return null;
  const e = document.cookie.match(new RegExp("(?:^|; )" + t + "=([^;]*)"));
  return e ? decodeURIComponent(e[1]) : null;
}, remove(t) {
  this.write(t, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function ru(t, e, n) {
  let r = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  return t && (r || n == 0) ? function(s, i) {
    return i ? s.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : s;
  }(t, e) : e;
}
const Do = (t) => t instanceof lt ? { ...t } : t;
function zt(t, e) {
  e = e || {};
  const n = {};
  function r(c, l, d, f) {
    return b.isPlainObject(c) && b.isPlainObject(l) ? b.merge.call({ caseless: f }, c, l) : b.isPlainObject(l) ? b.merge({}, l) : b.isArray(l) ? l.slice() : l;
  }
  function s(c, l, d, f) {
    return b.isUndefined(l) ? b.isUndefined(c) ? void 0 : r(void 0, c, 0, f) : r(c, l, 0, f);
  }
  function i(c, l) {
    if (!b.isUndefined(l)) return r(void 0, l);
  }
  function o(c, l) {
    return b.isUndefined(l) ? b.isUndefined(c) ? void 0 : r(void 0, c) : r(void 0, l);
  }
  function a(c, l, d) {
    return d in e ? r(c, l) : d in t ? r(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => s(Do(c), Do(l), 0, !0) };
  return b.forEach(Object.keys({ ...t, ...e }), function(c) {
    const l = u[c] || s, d = l(t[c], e[c], c);
    b.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const su = (t) => {
  const e = zt({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = e;
  if (e.headers = o = lt.from(o), e.url = Ya(ru(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), b.isFormData(n)) {
    if (Le.hasStandardBrowserEnv || Le.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (b.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (Le.hasStandardBrowserEnv && (r && b.isFunction(r) && (r = r(e)), r || r !== !1 && mf(e.url))) {
    const u = s && i && gf.read(i);
    u && o.set(s, u);
  }
  return e;
}, vf = typeof XMLHttpRequest < "u" && function(t) {
  return new Promise(function(e, n) {
    const r = su(t);
    let s = r.data;
    const i = lt.from(r.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: f, onDownloadProgress: h } = r;
    function v() {
      c && c(), l && l(), r.cancelToken && r.cancelToken.unsubscribe(o), r.signal && r.signal.removeEventListener("abort", o);
    }
    let p = new XMLHttpRequest();
    function R() {
      if (!p) return;
      const T = lt.from("getAllResponseHeaders" in p && p.getAllResponseHeaders());
      nu(function(W) {
        e(W), v();
      }, function(W) {
        n(W), v();
      }, { data: d && d !== "text" && d !== "json" ? p.response : p.responseText, status: p.status, statusText: p.statusText, headers: T, config: t, request: p }), p = null;
    }
    p.open(r.method.toUpperCase(), r.url, !0), p.timeout = r.timeout, "onloadend" in p ? p.onloadend = R : p.onreadystatechange = function() {
      p && p.readyState === 4 && (p.status !== 0 || p.responseURL && p.responseURL.indexOf("file:") === 0) && setTimeout(R);
    }, p.onabort = function() {
      p && (n(new X("Request aborted", X.ECONNABORTED, t, p)), p = null);
    }, p.onerror = function(T) {
      const W = T && T.message ? T.message : "Network Error", M = new X(W, X.ERR_NETWORK, t, p);
      M.event = T || null, n(M), p = null;
    }, p.ontimeout = function() {
      let T = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const W = r.transitional || Xa;
      r.timeoutErrorMessage && (T = r.timeoutErrorMessage), n(new X(T, W.clarifyTimeoutError ? X.ETIMEDOUT : X.ECONNABORTED, t, p)), p = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in p && b.forEach(i.toJSON(), function(T, W) {
      p.setRequestHeader(W, T);
    }), b.isUndefined(r.withCredentials) || (p.withCredentials = !!r.withCredentials), d && d !== "json" && (p.responseType = r.responseType), h && ([u, l] = Fr(h, !0), p.addEventListener("progress", u)), f && p.upload && ([a, c] = Fr(f), p.upload.addEventListener("progress", a), p.upload.addEventListener("loadend", c)), (r.cancelToken || r.signal) && (o = (T) => {
      p && (n(!T || T.type ? new zn(null, t, p) : T), p.abort(), p = null);
    }, r.cancelToken && r.cancelToken.subscribe(o), r.signal && (r.signal.aborted ? o() : r.signal.addEventListener("abort", o)));
    const J = function(T) {
      const W = /^([-+\w]{1,25})(:?\/\/|:)/.exec(T);
      return W && W[1] || "";
    }(r.url);
    J && Le.protocols.indexOf(J) === -1 ? n(new X("Unsupported protocol " + J + ":", X.ERR_BAD_REQUEST, t)) : p.send(s || null);
  });
}, yf = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r, s = new AbortController();
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof X ? l : new zn(l instanceof Error ? l.message : l));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new X(`timeout ${e} of ms exceeded`, X.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = s;
    return u.unsubscribe = () => b.asap(a), u;
  }
}, bf = function* (t, e) {
  let n = t.byteLength;
  if (n < e) return void (yield t);
  let r, s = 0;
  for (; s < n; ) r = s + e, yield t.slice(s, r), s = r;
}, $o = (t, e, n, r) => {
  const s = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const f = d.getReader();
      try {
        for (; ; ) {
          const { done: h, value: v } = await f.read();
          if (h) break;
          yield v;
        }
      } finally {
        await f.cancel();
      }
    }(u)) yield* bf(l, c);
  }(t, e);
  let i, o = 0, a = (u) => {
    i || (i = !0, r && r(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await s.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let f = o += d;
        n(f);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), s.return()) }, { highWaterMark: 2 });
}, { isFunction: Qn } = b, wf = (({ Request: t, Response: e }) => ({ Request: t, Response: e }))(b.global), { ReadableStream: Fo, TextEncoder: Bo } = b.global, Mo = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, xf = (t) => {
  t = b.merge.call({ skipUndefined: !0 }, wf, t);
  const { fetch: e, Request: n, Response: r } = t, s = e ? Qn(e) : typeof fetch == "function", i = Qn(n), o = Qn(r);
  if (!s) return !1;
  const a = s && Qn(Fo), u = s && (typeof Bo == "function" ? (c = new Bo(), (h) => c.encode(h)) : async (h) => new Uint8Array(await new n(h).arrayBuffer()));
  var c;
  const l = i && a && Mo(() => {
    let h = !1;
    const v = new n(Le.origin, { body: new Fo(), method: "POST", get duplex() {
      return h = !0, "half";
    } }).headers.has("Content-Type");
    return h && !v;
  }), d = o && a && Mo(() => b.isReadableStream(new r("").body)), f = { stream: d && ((h) => h.body) };
  return s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !f[h] && (f[h] = (v, p) => {
      let R = v && v[h];
      if (R) return R.call(v);
      throw new X(`Response type '${h}' is not supported`, X.ERR_NOT_SUPPORT, p);
    });
  }), async (h) => {
    let { url: v, method: p, data: R, signal: J, cancelToken: T, timeout: W, onDownloadProgress: M, onUploadProgress: ne, responseType: K, headers: je, withCredentials: me = "same-origin", fetchOptions: Me } = su(h), Qe = e || fetch;
    K = K ? (K + "").toLowerCase() : "text";
    let le = yf([J, T && T.toAbortSignal()], W), Ce = null;
    const ce = le && le.unsubscribe && (() => {
      le.unsubscribe();
    });
    let se;
    try {
      if (ne && l && p !== "get" && p !== "head" && (se = await (async (he, pe) => {
        const ke = b.toFiniteNumber(he.getContentLength());
        return ke ?? (async (V) => V == null ? 0 : b.isBlob(V) ? V.size : b.isSpecCompliantForm(V) ? (await new n(Le.origin, { method: "POST", body: V }).arrayBuffer()).byteLength : b.isArrayBufferView(V) || b.isArrayBuffer(V) ? V.byteLength : (b.isURLSearchParams(V) && (V += ""), b.isString(V) ? (await u(V)).byteLength : void 0))(pe);
      })(je, R)) !== 0) {
        let he, pe = new n(v, { method: "POST", body: R, duplex: "half" });
        if (b.isFormData(R) && (he = pe.headers.get("content-type")) && je.setContentType(he), pe.body) {
          const [ke, V] = Uo(se, Fr(No(ne)));
          R = $o(pe.body, 65536, ke, V);
        }
      }
      b.isString(me) || (me = me ? "include" : "omit");
      const oe = i && "credentials" in n.prototype, qe = { ...Me, signal: le, method: p.toUpperCase(), headers: je.normalize().toJSON(), body: R, duplex: "half", credentials: oe ? me : void 0 };
      Ce = i && new n(v, qe);
      let ye = await (i ? Qe(Ce, Me) : Qe(v, qe));
      const ht = d && (K === "stream" || K === "response");
      if (d && (M || ht && ce)) {
        const he = {};
        ["status", "statusText", "headers"].forEach((de) => {
          he[de] = ye[de];
        });
        const pe = b.toFiniteNumber(ye.headers.get("content-length")), [ke, V] = M && Uo(pe, Fr(No(M), !0)) || [];
        ye = new r($o(ye.body, 65536, ke, () => {
          V && V(), ce && ce();
        }), he);
      }
      K = K || "text";
      let xt = await f[b.findKey(f, K) || "text"](ye, h);
      return !ht && ce && ce(), await new Promise((he, pe) => {
        nu(he, pe, { data: xt, headers: lt.from(ye.headers), status: ye.status, statusText: ye.statusText, config: h, request: Ce });
      });
    } catch (oe) {
      throw ce && ce(), oe && oe.name === "TypeError" && /Load failed|fetch/i.test(oe.message) ? Object.assign(new X("Network Error", X.ERR_NETWORK, h, Ce), { cause: oe.cause || oe }) : X.from(oe, oe && oe.code, h, Ce);
    }
  };
}, Sf = /* @__PURE__ */ new Map(), zo = (t) => {
  let e = t && t.env || {};
  const { fetch: n, Request: r, Response: s } = e, i = [r, s, n];
  let o, a, u = i.length, c = Sf;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : xf(e)), c = a;
  return a;
}, iu = (zo(), { http: null, xhr: vf, fetch: { get: zo } });
b.forEach(iu, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const qo = (t) => `- ${t}`, Rf = (t) => b.isFunction(t) || t === null || t === !1, ou = function(t, e) {
  t = b.isArray(t) ? t : [t];
  const { length: n } = t;
  let r, s;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (r = t[o], s = r, !Rf(r) && (s = iu[(a = String(r)).toLowerCase()], s === void 0)) throw new X(`Unknown adapter '${a}'`);
    if (s && (b.isFunction(s) || (s = s.get(e)))) break;
    i[a || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(qo).join(`
`) : " " + qo(o[0]) : "as no adapter specified";
    throw new X("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return s;
};
function gs(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new zn(null, t);
}
function Zo(t) {
  return gs(t), t.headers = lt.from(t.headers), t.data = ms.call(t, t.transformRequest), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), ou(t.adapter || ni.adapter, t)(t).then(function(e) {
    return gs(t), e.data = ms.call(t, t.transformResponse, e), e.headers = lt.from(e.headers), e;
  }, function(e) {
    return eu(e) || (gs(t), e && e.response && (e.response.data = ms.call(t, t.transformResponse, e.response), e.response.headers = lt.from(e.response.headers))), Promise.reject(e);
  });
}
const au = "1.13.2", Br = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Br[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Ho = {};
Br.transitional = function(t, e, n) {
  function r(s, i) {
    return "[Axios v" + au + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, o) => {
    if (t === !1) throw new X(r(i, " has been removed" + (e ? " in " + e : "")), X.ERR_DEPRECATED);
    return e && !Ho[i] && (Ho[i] = !0, console.warn(r(i, " has been deprecated since v" + e + " and will be removed in the near future"))), !t || t(s, i, o);
  };
}, Br.spelling = function(t) {
  return (e, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
const pr = { assertOptions: function(t, e, n) {
  if (typeof t != "object") throw new X("options must be an object", X.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = e[i];
    if (o) {
      const a = t[i], u = a === void 0 || o(a, i, t);
      if (u !== !0) throw new X("option " + i + " must be " + u, X.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new X("Unknown option " + i, X.ERR_BAD_OPTION);
  }
}, validators: Br }, mt = pr.validators;
class mr {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = { request: new Io(), response: new Io() };
  }
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}).url = e : n = e || {}, n = zt(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && pr.assertOptions(r, { silentJSONParsing: mt.transitional(mt.boolean), forcedJSONParsing: mt.transitional(mt.boolean), clarifyTimeoutError: mt.transitional(mt.boolean) }, !1), s != null && (b.isFunction(s) ? n.paramsSerializer = { serialize: s } : pr.assertOptions(s, { encode: mt.function, serialize: mt.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), pr.assertOptions(n, { baseUrl: mt.spelling("baseURL"), withXsrfToken: mt.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && b.merge(i.common, i[n.method]);
    i && b.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (v) => {
      delete i[v];
    }), n.headers = lt.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (u = u && v.synchronous, a.unshift(v.fulfilled, v.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(v) {
      c.push(v.fulfilled, v.rejected);
    });
    let d, f = 0;
    if (!u) {
      const v = [Zo.bind(this), void 0];
      for (v.unshift(...a), v.push(...c), d = v.length, l = Promise.resolve(n); f < d; ) l = l.then(v[f++], v[f++]);
      return l;
    }
    d = a.length;
    let h = n;
    for (; f < d; ) {
      const v = a[f++], p = a[f++];
      try {
        h = v(h);
      } catch (R) {
        p.call(this, R);
        break;
      }
    }
    try {
      l = Zo.call(this, h);
    } catch (v) {
      return Promise.reject(v);
    }
    for (f = 0, d = c.length; f < d; ) l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(e) {
    return Ya(ru((e = zt(this.defaults, e)).baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer);
  }
}
b.forEach(["delete", "get", "head", "options"], function(t) {
  mr.prototype[t] = function(e, n) {
    return this.request(zt(n || {}, { method: t, url: e, data: (n || {}).data }));
  };
}), b.forEach(["post", "put", "patch"], function(t) {
  function e(n) {
    return function(r, s, i) {
      return this.request(zt(i || {}, { method: t, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: r, data: s }));
    };
  }
  mr.prototype[t] = e(), mr.prototype[t + "Form"] = e(!0);
});
const gr = mr;
class ri {
  constructor(e) {
    if (typeof e != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; ) r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(s, i, o) {
      r.reason || (r.reason = new zn(s, i, o), n(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(e) {
    this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  static source() {
    let e;
    return { token: new ri(function(n) {
      e = n;
    }), cancel: e };
  }
}
const _f = ri, Fs = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(Fs).forEach(([t, e]) => {
  Fs[e] = t;
});
const Of = Fs, Ee = function t(e) {
  const n = new gr(e), r = Ha(gr.prototype.request, n);
  return b.extend(r, gr.prototype, n, { allOwnKeys: !0 }), b.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(s) {
    return t(zt(e, s));
  }, r;
}(ni);
Ee.Axios = gr, Ee.CanceledError = zn, Ee.CancelToken = _f, Ee.isCancel = eu, Ee.VERSION = au, Ee.toFormData = $r, Ee.AxiosError = X, Ee.Cancel = Ee.CanceledError, Ee.all = function(t) {
  return Promise.all(t);
}, Ee.spread = function(t) {
  return function(e) {
    return t.apply(null, e);
  };
}, Ee.isAxiosError = function(t) {
  return b.isObject(t) && t.isAxiosError === !0;
}, Ee.mergeConfig = zt, Ee.AxiosHeaders = lt, Ee.formToJSON = (t) => Qa(b.isHTMLForm(t) ? new FormData(t) : t), Ee.getAdapter = ou, Ee.HttpStatusCode = Of, Ee.default = Ee;
const I = Ee;
function uu(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Bs(t, e, n) {
  return Bs = si() ? Reflect.construct : function(r, s, i) {
    var o = [null];
    o.push.apply(o, s);
    var a = new (Function.bind.apply(r, o))();
    return i && Ln(a, i.prototype), a;
  }, Bs.apply(null, arguments);
}
function vr(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function In(t) {
  return In = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, In(t);
}
function Ln(t, e) {
  return Ln = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Ln(t, e);
}
function Ms(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Ms = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1)) return n;
    var r;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(n)) return e.get(n);
      e.set(n, s);
    }
    function s() {
      return Bs(n, arguments, In(this).constructor);
    }
    return s.prototype = Object.create(n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), Ln(s, n);
  }, Ms(t);
}
function si() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (si = function() {
    return !!t;
  })();
}
var L = "http://localhost".replace(/\/+$/, ""), Ve = function t(e) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : L, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : I;
  uu(this, t), vr(this, "basePath", void 0), vr(this, "axios", void 0), vr(this, "configuration", void 0), this.basePath = r, this.axios = s, e && (this.configuration = e, this.basePath = (n = e.basePath) !== null && n !== void 0 ? n : r);
}, Ef = function() {
  function t(e, n) {
    var r;
    return uu(this, t), vr(r = function(s, i, o) {
      return i = In(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(s, si() ? Reflect.construct(i, o || [], In(s).constructor) : i.apply(s, o));
    }(this, t, [n]), "field", void 0), r.field = e, r.name = "RequiredError", r;
  }
  return function(e, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), n && Ln(e, n);
  }(t, Ms(Error)), t;
}(), U = {};
function Wo(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function Tf(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var N = "https://example.com", A = function(t, e, n) {
  if (n == null) throw new Ef(e, "Required parameter ".concat(e, " was null or undefined when calling ").concat(t, "."));
}, B = function(t, e) {
  return (n = function() {
    var r, s;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = f(0), d.throw = f(1), d.return = f(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function f(h) {
        return function(v) {
          return function(p) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, p[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & p[0] ? u.return : p[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, p[1])).done) return c;
              switch (u = 0, c && (p = [2 & p[0], c.value]), p[0]) {
                case 0:
                case 1:
                  c = p;
                  break;
                case 4:
                  return l.label++, { value: p[1], done: !1 };
                case 5:
                  l.label++, u = p[1], p = [0];
                  continue;
                case 7:
                  p = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || p[0] !== 6 && p[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (p[0] === 3 && (!c || p[1] > c[0] && p[1] < c[3])) {
                    l.label = p[1];
                    break;
                  }
                  if (p[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = p;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(p);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              p = o.call(i, l);
            } catch (R) {
              p = [6, R], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & p[0]) throw p[1];
            return { value: p[0] ? p[1] : void 0, done: !0 };
          }([h, v]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return e && e.accessToken ? typeof e.accessToken != "function" ? [3, 2] : [4, e.accessToken()] : [3, 5];
        case 1:
          return s = i.sent(), [3, 4];
        case 2:
          return [4, e.accessToken];
        case 3:
          s = i.sent(), i.label = 4;
        case 4:
          r = s, t.Authorization = "Bearer " + r, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var r = this, s = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(r, s);
      function u(l) {
        Wo(a, i, o, u, c, "next", l);
      }
      function c(l) {
        Wo(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function zs(t, e) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  e != null && ((e === void 0 ? "undefined" : (n = e) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(e) ? e.forEach(function(s) {
    return zs(t, s, r);
  }) : Object.keys(e).forEach(function(s) {
    return zs(t, e[s], "".concat(r).concat(r !== "" ? "." : "").concat(s));
  }) : t.has(r) ? t.append(r, e) : t.set(r, e));
}
var D = function(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
  var s = new URLSearchParams(t.search);
  zs(s, n), t.search = s.toString();
}, ge = function(t, e, n) {
  var r = typeof t != "string";
  return (r && n && n.isJsonMime ? n.isJsonMime(e.headers["Content-Type"]) : r) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, $ = function(t) {
  return t.pathname + t.search + t.hash;
}, F = function(t, e, n, r) {
  return function() {
    var s, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d] != null ? arguments[d] : {}, h = Object.keys(f);
        typeof Object.getOwnPropertySymbols == "function" && (h = h.concat(Object.getOwnPropertySymbols(f).filter(function(v) {
          return Object.getOwnPropertyDescriptor(f, v).enumerable;
        }))), h.forEach(function(v) {
          Tf(l, v, f[v]);
        });
      }
      return l;
    }({}, t.options), o = (o = { url: (a.defaults.baseURL ? "" : (s = r == null ? void 0 : r.basePath) !== null && s !== void 0 ? s : u) + t.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(l);
        d.push.apply(d, f);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function Jo(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function x(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, s) {
      var i = t.apply(e, n);
      function o(u) {
        Jo(i, r, s, o, a, "next", u);
      }
      function a(u) {
        Jo(i, r, s, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function Ge(t, e, n) {
  return e = Mr(e), function(r, s) {
    return !s || ((i = s) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof s != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(r) : s;
    var i;
  }(t, cu() ? Reflect.construct(e, n || [], Mr(t).constructor) : e.apply(t, n));
}
function Ke(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function jf(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Ye(t, e, n) {
  return e && jf(t.prototype, e), t;
}
function Cf(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Mr(t) {
  return Mr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Mr(t);
}
function Xe(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && qs(t, e);
}
function w(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      Cf(t, s, n[s]);
    });
  }
  return t;
}
function qs(t, e) {
  return qs = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, qs(t, e);
}
function cu() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (cu = function() {
    return !!t;
  })();
}
function S(t, e) {
  var n, r, s, i = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, r && (s = 2 & l[0] ? r.return : l[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, l[1])).done) return s;
          switch (r = 0, s && (l = [2 & l[0], s.value]), l[0]) {
            case 0:
            case 1:
              s = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, r = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((s = (s = i.trys).length > 0 && s[s.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < s[1]) {
                i.label = s[1], s = l;
                break;
              }
              if (s && i.label < s[2]) {
                i.label = s[2], i.ops.push(l);
                break;
              }
              s[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = e.call(t, i);
        } catch (d) {
          l = [6, d], r = 0;
        } finally {
          n = s = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var kf = function(t) {
  return { listBreaks: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("listBreaks", "showId", e), s = new URL("/break", N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.showId = e), n !== void 0 && (u.ring = n), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  } };
}, Pf = function(t) {
  var e = kf(t);
  return { listBreaks: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.listBreaks(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["BreaksApi.listBreaks"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "listBreaks", value: function(n, r, s) {
    var i = this;
    return Pf(this.configuration).listBreaks(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(Ve);
var Af = function(t) {
  return { getClass: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getClass", "classId", e), r = "/class/{classId}".replace("{classId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, listClasses: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("listClasses", "showId", e), s = new URL("/class", N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.showId = e), n !== void 0 && (u.mine = n), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("setClassErrorDeductionScheme", "classId", e), A("setClassErrorDeductionScheme", "setClassErrorDeductionSchemeRequest", n), s = "/class/{classId}/error-deduction-scheme".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("setClassFaultTimeLimit", "classId", e), A("setClassFaultTimeLimit", "setClassFaultTimeLimitRequest", n), s = "/class/{classId}/fault-time-limit".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, setClassQualityJudging: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("setClassQualityJudging", "classId", e), A("setClassQualityJudging", "setClassQualityJudgingRequest", n), s = "/class/{classId}/quality-judging".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, setClassScribeAssignment: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("setClassScribeAssignment", "classId", e), A("setClassScribeAssignment", "setClassScribeAssignmentRequest", n), s = "/class/{classId}/scribe-assignments".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("setClassSectionJudgeAssignments", "classId", e), s = "/class/{classId}/section-judge-assignments".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, setRingScribeAssignments: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("setRingScribeAssignments", "ring", e), A("setRingScribeAssignments", "setRingScribeAssignmentsRequest", n), s = "/ring/{ring}/scribe-assignments".replace("{ring}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  } };
}, Ct = function(t) {
  var e = Af(t);
  return { getClass: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getClass(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ClassesApi.getClass"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, listClasses: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.listClasses(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ClassesApi.listClasses"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassErrorDeductionScheme(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ClassesApi.setClassErrorDeductionScheme"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassFaultTimeLimit(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ClassesApi.setClassFaultTimeLimit"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassQualityJudging: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassQualityJudging(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ClassesApi.setClassQualityJudging"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassScribeAssignment: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassScribeAssignment(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ClassesApi.setClassScribeAssignment"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassSectionJudgeAssignments(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ClassesApi.setClassSectionJudgeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, setRingScribeAssignments: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setRingScribeAssignments(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ClassesApi.setRingScribeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "getClass", value: function(n, r) {
    var s = this;
    return Ct(this.configuration).getClass(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listClasses", value: function(n, r, s) {
    var i = this;
    return Ct(this.configuration).listClasses(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassErrorDeductionScheme", value: function(n, r, s) {
    var i = this;
    return Ct(this.configuration).setClassErrorDeductionScheme(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassFaultTimeLimit", value: function(n, r, s) {
    var i = this;
    return Ct(this.configuration).setClassFaultTimeLimit(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassQualityJudging", value: function(n, r, s) {
    var i = this;
    return Ct(this.configuration).setClassQualityJudging(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassScribeAssignment", value: function(n, r, s) {
    var i = this;
    return Ct(this.configuration).setClassScribeAssignment(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassSectionJudgeAssignments", value: function(n, r, s) {
    var i = this;
    return Ct(this.configuration).setClassSectionJudgeAssignments(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRingScribeAssignments", value: function(n, r, s) {
    var i = this;
    return Ct(this.configuration).setRingScribeAssignments(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(Ve);
var If = function(t) {
  return { getDaysheetReconcileStatus: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getDaysheetReconcileStatus", "showId", e), r = "/daysheet/{showId}/status".replace("{showId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, reconcileDaysheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("reconcileDaysheet", "showId", e), r = "/daysheet/{showId}/reconcile".replace("{showId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  } };
}, Vo = function(t) {
  var e = If(t);
  return { getDaysheetReconcileStatus: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getDaysheetReconcileStatus(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["DaySheetApi.getDaysheetReconcileStatus"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, reconcileDaysheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.reconcileDaysheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["DaySheetApi.reconcileDaysheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "getDaysheetReconcileStatus", value: function(n, r) {
    var s = this;
    return Vo(this.configuration).getDaysheetReconcileStatus(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "reconcileDaysheet", value: function(n, r) {
    var s = this;
    return Vo(this.configuration).reconcileDaysheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
})(Ve);
var Lf = function(t) {
  return { getHealth: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return x(function() {
      var n, r, s, i, o;
      return S(this, function(a) {
        return n = new URL("/health", N), t && (r = t.baseOptions), s = w({ method: "GET" }, r, e), i = {}, D(n, {}), o = r && r.headers ? r.headers : {}, s.headers = w({}, i, o, e.headers), [2, { url: $(n), options: s }];
      });
    })();
  } };
}, Uf = function(t) {
  var e = Lf(t);
  return { getHealth: function(n) {
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = U["HealthApi.getHealth"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return F(i, I, L, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "getHealth", value: function(n) {
    var r = this;
    return Uf(this.configuration).getHealth(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(Ve);
var Nf = function(t) {
  return { getHorse: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getHorse", "id", e), r = "/horse/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, listHorses: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return x(function() {
      var n, r, s, i, o, a;
      return S(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/horse", N), t && (r = t.baseOptions), s = w({ method: "GET" }, r, e), o = {}, [4, B(i = {}, t)];
          case 1:
            return u.sent(), D(n, o), a = r && r.headers ? r.headers : {}, s.headers = w({}, i, a, e.headers), [2, { url: $(n), options: s }];
        }
      });
    })();
  } };
}, Go = function(t) {
  var e = Nf(t);
  return { getHorse: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getHorse(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["HorsesApi.getHorse"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, listHorses: function(n) {
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.listHorses(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = U["HorsesApi.listHorses"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return F(i, I, L, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "getHorse", value: function(n, r) {
    var s = this;
    return Go(this.configuration).getHorse(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listHorses", value: function(n) {
    var r = this;
    return Go(this.configuration).listHorses(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(Ve);
var Df = function(t) {
  return { deleteJudgeSignature: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("deleteJudgeSignature", "id", e), r = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, listJudges: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return A("listJudges", "showId", e), r = new URL("/judge", N), t && (s = t.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.showId = e), D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: $(r), options: i }];
        }
      });
    })();
  }, putJudgeSignature: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("putJudgeSignature", "id", e), A("putJudgeSignature", "putJudgeSignatureRequest", n), s = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  } };
}, vs = function(t) {
  var e = Df(t);
  return { deleteJudgeSignature: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deleteJudgeSignature(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["JudgesApi.deleteJudgeSignature"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, listJudges: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listJudges(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["JudgesApi.listJudges"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, putJudgeSignature: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.putJudgeSignature(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["JudgesApi.putJudgeSignature"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "deleteJudgeSignature", value: function(n, r) {
    var s = this;
    return vs(this.configuration).deleteJudgeSignature(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listJudges", value: function(n, r) {
    var s = this;
    return vs(this.configuration).listJudges(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "putJudgeSignature", value: function(n, r, s) {
    var i = this;
    return vs(this.configuration).putJudgeSignature(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(Ve);
var $f = function(t) {
  return { createPerson: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/people", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = ge(e, i, t), [2, { url: $(r), options: i }];
        }
      });
    })();
  }, deletePerson: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("deletePerson", "id", e), r = "/people/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, getPerson: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getPerson", "id", e), r = "/people/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, listPeople: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/people", N), t && (s = t.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.personType = e), D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: $(r), options: i }];
        }
      });
    })();
  }, updatePerson: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("updatePerson", "id", e), s = "/people/{id}".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  } };
}, bn = function(t) {
  var e = $f(t);
  return { createPerson: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createPerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["PeopleApi.createPerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, deletePerson: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deletePerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["PeopleApi.deletePerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, getPerson: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getPerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["PeopleApi.getPerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, listPeople: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listPeople(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["PeopleApi.listPeople"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, updatePerson: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.updatePerson(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["PeopleApi.updatePerson"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "createPerson", value: function(n, r) {
    var s = this;
    return bn(this.configuration).createPerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deletePerson", value: function(n, r) {
    var s = this;
    return bn(this.configuration).deletePerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getPerson", value: function(n, r) {
    var s = this;
    return bn(this.configuration).getPerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listPeople", value: function(n, r) {
    var s = this;
    return bn(this.configuration).listPeople(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "updatePerson", value: function(n, r, s) {
    var i = this;
    return bn(this.configuration).updatePerson(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(Ve);
var Ff = function(t) {
  return { getClassResults: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getClassResults", "classId", e), r = "/class/{classId}/results".replace("{classId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, getRideResult: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getRideResult", "rideId", e), r = "/ride/{rideId}/results".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, setClassPlacings: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("setClassPlacings", "classId", e), A("setClassPlacings", "setClassPlacingsRequest", n), s = "/class/{classId}/placings".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, setRidePlacing: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("setRidePlacing", "rideId", e), s = "/ride/{rideId}/placing".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  } };
}, er = function(t) {
  var e = Ff(t);
  return { getClassResults: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getClassResults(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ResultsApi.getClassResults"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, getRideResult: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRideResult(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ResultsApi.getRideResult"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, setClassPlacings: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassPlacings(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ResultsApi.setClassPlacings"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, setRidePlacing: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setRidePlacing(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ResultsApi.setRidePlacing"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "getClassResults", value: function(n, r) {
    var s = this;
    return er(this.configuration).getClassResults(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRideResult", value: function(n, r) {
    var s = this;
    return er(this.configuration).getRideResult(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "setClassPlacings", value: function(n, r, s) {
    var i = this;
    return er(this.configuration).setClassPlacings(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRidePlacing", value: function(n, r, s) {
    var i = this;
    return er(this.configuration).setRidePlacing(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(Ve);
var Bf = function(t) {
  return { batchRideStatus: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return A("batchRideStatus", "batchRideStatusRequest", e), r = new URL("/rides/status", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = ge(e, i, t), [2, { url: $(r), options: i }];
        }
      });
    })();
  }, createRide: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/ride", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = ge(e, i, t), [2, { url: $(r), options: i }];
        }
      });
    })();
  }, createRideUtilityEvent: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("createRideUtilityEvent", "rideId", e), A("createRideUtilityEvent", "createRideUtilityEventRequest", n), s = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("deleteRideUtilityEvent", "rideId", e), A("deleteRideUtilityEvent", "eventId", n), s = "/ride/{rideId}/utility-events/{eventId}".replace("{rideId}", encodeURIComponent(String(e))).replace("{eventId}", encodeURIComponent(String(n))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "DELETE" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, finalizeRide: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("finalizeRide", "rideId", e), s = "/ride/{rideId}/finalize".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, getRide: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getRide", "rideId", e), r = "/ride/{rideId}".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, listRideUtilityEvents: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("listRideUtilityEvents", "rideId", e), r = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, listRides: function(e, n, r, s, i, o, a) {
    var u = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {};
    return x(function() {
      var c, l, d, f, h, v;
      return S(this, function(p) {
        switch (p.label) {
          case 0:
            return c = new URL("/ride", N), t && (l = t.baseOptions), d = w({ method: "GET" }, l, u), h = {}, [4, B(f = {}, t)];
          case 1:
            return p.sent(), e !== void 0 && (h.classId = e), n !== void 0 && (h.showId = n), r !== void 0 && (h.day = r), s !== void 0 && (h.ring = s), i !== void 0 && (h.needsReview = i), o !== void 0 && (h.riderId = o), a !== void 0 && (h.horseId = a), D(c, h), v = l && l.headers ? l.headers : {}, d.headers = w({}, f, v, u.headers), [2, { url: $(c), options: d }];
        }
      });
    })();
  }, repointRide: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("repointRide", "rideId", e), A("repointRide", "repointRideRequest", n), s = "/ride/{rideId}/repoint".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, resolveManualRide: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("resolveManualRide", "rideId", e), A("resolveManualRide", "resolveManualRideRequest", n), s = "/ride/{rideId}/resolve".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, setRideStatus: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("setRideStatus", "rideId", e), A("setRideStatus", "setRideStatusRequest", n), s = "/ride/{rideId}/status".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  } };
}, rt = function(t) {
  var e = Bf(t);
  return { batchRideStatus: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.batchRideStatus(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["RidesApi.batchRideStatus"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, createRide: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createRide(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["RidesApi.createRide"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, createRideUtilityEvent: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.createRideUtilityEvent(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["RidesApi.createRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.deleteRideUtilityEvent(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["RidesApi.deleteRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, finalizeRide: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.finalizeRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["RidesApi.finalizeRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, getRide: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRide(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["RidesApi.getRide"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, listRideUtilityEvents: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listRideUtilityEvents(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["RidesApi.listRideUtilityEvents"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, listRides: function(n, r, s, i, o, a, u, c) {
    return x(function() {
      var l, d, f, h, v, p;
      return S(this, function(R) {
        switch (R.label) {
          case 0:
            return [4, e.listRides(n, r, s, i, o, a, u, c)];
          case 1:
            return f = R.sent(), v = (h = t == null ? void 0 : t.serverIndex) !== null && h !== void 0 ? h : 0, p = (d = U["RidesApi.listRides"]) === null || d === void 0 || (l = d[v]) === null || l === void 0 ? void 0 : l.url, [2, function(J, T) {
              return F(f, I, L, t)(J, p || T);
            }];
        }
      });
    })();
  }, repointRide: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.repointRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["RidesApi.repointRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, resolveManualRide: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.resolveManualRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["RidesApi.resolveManualRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, setRideStatus: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setRideStatus(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["RidesApi.setRideStatus"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "batchRideStatus", value: function(n, r) {
    var s = this;
    return rt(this.configuration).batchRideStatus(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createRide", value: function(n, r) {
    var s = this;
    return rt(this.configuration).createRide(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createRideUtilityEvent", value: function(n, r, s) {
    var i = this;
    return rt(this.configuration).createRideUtilityEvent(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "deleteRideUtilityEvent", value: function(n, r, s) {
    var i = this;
    return rt(this.configuration).deleteRideUtilityEvent(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "finalizeRide", value: function(n, r, s) {
    var i = this;
    return rt(this.configuration).finalizeRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getRide", value: function(n, r) {
    var s = this;
    return rt(this.configuration).getRide(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRideUtilityEvents", value: function(n, r) {
    var s = this;
    return rt(this.configuration).listRideUtilityEvents(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRides", value: function(n, r, s, i, o, a, u, c) {
    var l = this;
    return rt(this.configuration).listRides(n, r, s, i, o, a, u, c).then(function(d) {
      return d(l.axios, l.basePath);
    });
  } }, { key: "repointRide", value: function(n, r, s) {
    var i = this;
    return rt(this.configuration).repointRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "resolveManualRide", value: function(n, r, s) {
    var i = this;
    return rt(this.configuration).resolveManualRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRideStatus", value: function(n, r, s) {
    var i = this;
    return rt(this.configuration).setRideStatus(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(Ve);
var Mf = function(t) {
  return { completeScoreSheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("completeScoreSheet", "id", e), r = "/scoresheet/{id}/complete".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("confirmScoreSheetMarks", "id", e), r = "/scoresheet/{id}/confirm-marks".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, createScoreSheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/scoresheet", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = ge(e, i, t), [2, { url: $(r), options: i }];
        }
      });
    })();
  }, getRideAuditTrail: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getRideAuditTrail", "rideId", e), r = "/ride/{rideId}/audit".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, getScoreSheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getScoreSheet", "id", e), r = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getScoreSheetAuditTrail", "id", e), r = "/scoresheet/{id}/audit".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, getScoreSheetSignature: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getScoreSheetSignature", "id", e), r = "/scoresheet/{id}/signature".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, listScoreSheets: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/scoresheet", N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.rideId = e), n !== void 0 && (u.judgeId = n), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, reopenScoreSheet: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("reopenScoreSheet", "id", e), A("reopenScoreSheet", "reopenScoreSheetRequest", n), s = "/scoresheet/{id}/reopen".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  }, updateScoreSheet: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("updateScoreSheet", "id", e), s = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  } };
}, gt = function(t) {
  var e = Mf(t);
  return { completeScoreSheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.completeScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ScoreSheetsApi.completeScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.confirmScoreSheetMarks(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ScoreSheetsApi.confirmScoreSheetMarks"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, createScoreSheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ScoreSheetsApi.createScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, getRideAuditTrail: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRideAuditTrail(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ScoreSheetsApi.getRideAuditTrail"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ScoreSheetsApi.getScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getScoreSheetAuditTrail(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ScoreSheetsApi.getScoreSheetAuditTrail"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheetSignature: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getScoreSheetSignature(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ScoreSheetsApi.getScoreSheetSignature"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, listScoreSheets: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.listScoreSheets(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ScoreSheetsApi.listScoreSheets"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, reopenScoreSheet: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.reopenScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ScoreSheetsApi.reopenScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  }, updateScoreSheet: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.updateScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["ScoreSheetsApi.updateScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "completeScoreSheet", value: function(n, r) {
    var s = this;
    return gt(this.configuration).completeScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "confirmScoreSheetMarks", value: function(n, r) {
    var s = this;
    return gt(this.configuration).confirmScoreSheetMarks(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createScoreSheet", value: function(n, r) {
    var s = this;
    return gt(this.configuration).createScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRideAuditTrail", value: function(n, r) {
    var s = this;
    return gt(this.configuration).getRideAuditTrail(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheet", value: function(n, r) {
    var s = this;
    return gt(this.configuration).getScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheetAuditTrail", value: function(n, r) {
    var s = this;
    return gt(this.configuration).getScoreSheetAuditTrail(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheetSignature", value: function(n, r) {
    var s = this;
    return gt(this.configuration).getScoreSheetSignature(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listScoreSheets", value: function(n, r, s) {
    var i = this;
    return gt(this.configuration).listScoreSheets(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "reopenScoreSheet", value: function(n, r, s) {
    var i = this;
    return gt(this.configuration).reopenScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "updateScoreSheet", value: function(n, r, s) {
    var i = this;
    return gt(this.configuration).updateScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(Ve);
var zf = function(t) {
  return { getShow: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getShow", "id", e), r = "/show/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, listShows: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return x(function() {
      var n, r, s, i, o, a;
      return S(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/show", N), t && (r = t.baseOptions), s = w({ method: "GET" }, r, e), o = {}, [4, B(i = {}, t)];
          case 1:
            return u.sent(), D(n, o), a = r && r.headers ? r.headers : {}, s.headers = w({}, i, a, e.headers), [2, { url: $(n), options: s }];
        }
      });
    })();
  } };
}, Ko = function(t) {
  var e = zf(t);
  return { getShow: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getShow(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["ShowsApi.getShow"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, listShows: function(n) {
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.listShows(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = U["ShowsApi.listShows"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return F(i, I, L, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "getShow", value: function(n, r) {
    var s = this;
    return Ko(this.configuration).getShow(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listShows", value: function(n) {
    var r = this;
    return Ko(this.configuration).listShows(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(Ve);
var qf = function(t) {
  return { createTest: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/test", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = ge(e, i, t), [2, { url: $(r), options: i }];
        }
      });
    })();
  }, deleteTest: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("deleteTest", "id", e), r = "/test/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, getTest: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return A("getTest", "id", e), r = "/test/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: $(s), options: o }];
        }
      });
    })();
  }, listTests: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/test", N), t && (s = t.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.showId = e), D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: $(r), options: i }];
        }
      });
    })();
  }, updateTest: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return A("updateTest", "id", e), s = "/test/{id}".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = ge(n, a, t), [2, { url: $(i), options: a }];
        }
      });
    })();
  } };
}, wn = function(t) {
  var e = qf(t);
  return { createTest: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["TestsApi.createTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, deleteTest: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deleteTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["TestsApi.deleteTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, getTest: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["TestsApi.getTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, listTests: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listTests(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = U["TestsApi.listTests"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return F(o, I, L, t)(d, c || f);
            }];
        }
      });
    })();
  }, updateTest: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.updateTest(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = U["TestsApi.updateTest"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return F(a, I, L, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ke(this, e), Ge(this, e, arguments);
  }
  return Xe(e, t), Ye(e, [{ key: "createTest", value: function(n, r) {
    var s = this;
    return wn(this.configuration).createTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deleteTest", value: function(n, r) {
    var s = this;
    return wn(this.configuration).deleteTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getTest", value: function(n, r) {
    var s = this;
    return wn(this.configuration).getTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listTests", value: function(n, r) {
    var s = this;
    return wn(this.configuration).listTests(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "updateTest", value: function(n, r, s) {
    var i = this;
    return wn(this.configuration).updateTest(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(Ve);
function Zf(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Ot(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Yo(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      Ot(t, s, n[s]);
    });
  }
  return t;
}
(function() {
  function t() {
    var r, s, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), Ot(this, "apiKey", void 0), Ot(this, "username", void 0), Ot(this, "password", void 0), Ot(this, "accessToken", void 0), Ot(this, "basePath", void 0), Ot(this, "serverIndex", void 0), Ot(this, "baseOptions", void 0), Ot(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (s = Yo({}, o.baseOptions), i = (i = { headers: Yo({}, (r = o.baseOptions) === null || r === void 0 ? void 0 : r.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(s, a, Object.getOwnPropertyDescriptor(i, a));
    }), s), this.formDataCtor = o.formDataCtor;
  }
  var e, n;
  return e = t, (n = [{ key: "isJsonMime", value: function(r) {
    var s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (s.test(r) || r.toLowerCase() === "application/json-patch+json");
  } }]) && Zf(e.prototype, n), t;
})();
const Hf = {
  [Wt.PENDING]: { color: "default", label: "Scheduled" },
  [Wt.IN_PROGRESS]: { color: "info", label: "In ring" },
  // #696 — score confirmed/frozen and released to the announcer + FVD, judge
  // may still be writing comments. Green like FINAL ("score ready"); the label
  // is what tells the two apart.
  [Wt.CONFIRMED]: { color: "success", label: "Confirmed" },
  [Wt.COMPLETED]: { color: "warning", label: "Scored" },
  [Wt.FINAL]: { color: "success", label: "Final" },
  [Wt.SCRATCHED]: { color: "error", label: "Scratched" }
}, Wf = { color: "default", label: "—" };
function fp({ status: t, labels: e, size: n = "small", ...r }) {
  const s = Hf[t] ?? Wf, i = (e == null ? void 0 : e[t]) ?? s.label;
  return /* @__PURE__ */ m.jsx(aa, { size: n, color: s.color, label: i, ...r });
}
function hp(t, e, { intervalMs: n, enabled: r = !0 } = {}) {
  const [s, i] = z({}), [o, a] = z(!1), [u, c] = z(null), [l, d] = z(null), f = Array.from(new Set((t ?? []).filter(Boolean))), h = f.join(","), v = Ft(e);
  v.current = e;
  const p = Ft(f);
  p.current = f;
  const R = r && f.length > 0 && typeof e == "function", J = $t(async () => {
    const T = p.current;
    if (!(!T.length || typeof v.current != "function")) {
      a(!0);
      try {
        const W = await v.current(T), M = {};
        for (const ne of W ?? []) M[ne.rideId] = ne.status;
        i(M), c(null), d(/* @__PURE__ */ new Date());
      } catch (W) {
        c(W);
      } finally {
        a(!1);
      }
    }
  }, []);
  return Se(() => {
    if (!f.length) {
      i({});
      return;
    }
    if (!R)
      return;
    if (!n) {
      J();
      return;
    }
    document.visibilityState !== "hidden" && J();
    let T = null;
    const W = () => {
      document.visibilityState !== "hidden" && T == null && (T = setInterval(J, n));
    }, M = () => {
      T != null && (clearInterval(T), T = null);
    }, ne = () => {
      document.visibilityState === "hidden" ? M() : (J(), W());
    };
    return W(), document.addEventListener("visibilitychange", ne), () => {
      M(), document.removeEventListener("visibilitychange", ne);
    };
  }, [h, R, n, J]), { statuses: s, loading: o, error: u, refresh: J, lastUpdated: l };
}
function pp({
  judgeName: t,
  url: e,
  loading: n = !1,
  label: r = "Judge signature",
  ...s
}) {
  return n ? /* @__PURE__ */ m.jsxs(Rr, { spacing: 1, alignItems: "center", sx: { mt: 3 }, ...s, children: [
    /* @__PURE__ */ m.jsx(Sr, { variant: "rounded", width: 240, height: 90 }),
    /* @__PURE__ */ m.jsx(Sr, { variant: "text", width: 140 })
  ] }) : e ? /* @__PURE__ */ m.jsxs(
    Rr,
    {
      spacing: 1,
      alignItems: "center",
      "data-testid": "signature-box",
      sx: { mt: 3, pt: 2, borderTop: 1, borderColor: "divider" },
      ...s,
      children: [
        /* @__PURE__ */ m.jsx(_r, { variant: "caption", color: "text.secondary", children: r }),
        /* @__PURE__ */ m.jsx(
          Ae,
          {
            sx: {
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "#ffffff",
              p: 1,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ m.jsx(
              Ae,
              {
                component: "img",
                src: e,
                alt: t || r,
                "data-testid": "signature-box-image",
                sx: { maxWidth: 240, maxHeight: 90, objectFit: "contain" }
              }
            )
          }
        ),
        t && /* @__PURE__ */ m.jsx(
          _r,
          {
            variant: "body2",
            color: "text.primary",
            fontWeight: 600,
            "data-testid": "signature-box-name",
            children: t
          }
        )
      ]
    }
  ) : null;
}
function mp(t, e, { enabled: n = !0 } = {}) {
  const [r, s] = z(null), [i, o] = z(!1), [a, u] = z(null), c = Ft(e);
  c.current = e;
  const l = n && !!t && typeof e == "function";
  return Se(() => {
    if (!l) {
      s(null);
      return;
    }
    let d = !1;
    return o(!0), u(null), (async () => {
      try {
        const f = await c.current(t);
        d || s(f ?? null);
      } catch (f) {
        d || u(f);
      } finally {
        d || o(!1);
      }
    })(), () => {
      d = !0;
    };
  }, [l, t]), { signature: r, loading: i, error: a };
}
function gp({ buildId: t, testId: e = "build-badge" }) {
  const n = t ?? (typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev");
  return n ? /* @__PURE__ */ m.jsx(
    ue,
    {
      "data-testid": e,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 86,
        // Above AppBar/NavRail (both 1300/1200 in common-fe) so it's never
        // hidden by app chrome, but below modals/dialogs so it doesn't cover
        // interactive overlays. It's pointer-events:none anyway.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        // A subtle themed pill so the text reads on top of any content —
        // proven legible in both light and dark (mirrors PinLock's approach).
        px: 0.5,
        py: "1px",
        borderRadius: 0.5,
        bgcolor: "background.paper",
        opacity: 0.75,
        // text.secondary reads on both light and dark backgrounds; never MUI
        // `primary` (dark-grey, vanishes on dark).
        color: "text.secondary",
        fontFamily: "monospace",
        fontSize: "9px",
        lineHeight: 1.2,
        letterSpacing: 0,
        whiteSpace: "nowrap"
      },
      children: n
    }
  ) : null;
}
function vp({ testId: t = "usa-badge" }) {
  return /* @__PURE__ */ m.jsxs(
    ue,
    {
      "data-testid": t,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 2,
        width: 80,
        // Above AppBar/NavRail (both 1300/1200 in common-fe), same layer as
        // BuildBadge so the pair reads as one unit; below modals/dialogs.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        opacity: 0.75
      },
      children: [
        /* @__PURE__ */ m.jsx(
          ue,
          {
            component: "svg",
            viewBox: "0 0 1200 1200",
            "aria-label": "Made in the USA",
            sx: {
              width: 28,
              height: 28,
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark) — same rule as
              // BuildBadge.
              color: "text.secondary",
              fill: "currentColor"
            },
            children: /* @__PURE__ */ m.jsx("path", { d: "m60.84 823.92h1078.4v-49.801h-1078.4zm0-99.48h1078.4v-49.801h-1078.4zm1078.3-398.16v-49.801h-1078.3v348.61h1078.4v-49.801l-647.16-0.003906v-49.801h647.04v-49.801h-647.04v-49.801h647.04v-49.801h-647.04v-49.801zm-718.92 0.95703 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.238 6.3633 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm12.363 107.52-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.719-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.883-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.8398-9.7227 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-32.16-93.121 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68zm283.8-11.398-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.598-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-28.32-58.199-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.562 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2773-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-26.043 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.3984-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-25.922 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.4023-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm199.56-81.48 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.8359 13.801-2.0391zm-42.117-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.363-6.4766-12.359 6.4805 2.3984-13.68-9.957-9.8398zm0 69.602 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9648 9.7227 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7227zm18.477 95.16-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.957-9.8398 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.637-41.281-12.238 6.3594 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2812-83.398 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.598 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-405.36 606.96h1078.4v-49.801h-1078.4z" })
          }
        ),
        /* @__PURE__ */ m.jsx(
          ue,
          {
            sx: {
              mt: "1px",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "0.2px",
              textAlign: "center",
              textTransform: "uppercase",
              whiteSpace: "normal",
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark).
              color: "text.secondary"
            },
            children: "Made in the USA"
          }
        )
      ]
    }
  );
}
const Jf = "5432";
function yp({
  pin: t = Jf,
  onUnlock: e,
  testId: n = "pin-lock",
  ariaLabel: r = "Unlock"
}) {
  const [s, i] = z(!1), [o, a] = z(""), [u, c] = z(!1), l = Ft(null);
  return Se(() => {
    s || (a(""), c(!1));
  }, [s]), Se(() => {
    if (!s || o.length !== t.length) return;
    const d = setTimeout(() => {
      o === t ? (i(!1), e == null || e()) : (c(!0), setTimeout(() => {
        var f;
        a(""), c(!1), (f = l.current) == null || f.focus();
      }, 600));
    }, 80);
    return () => clearTimeout(d);
  }, [o, s, t, e]), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(
      xr,
      {
        onClick: () => i(!0),
        "aria-label": r,
        "data-testid": n,
        sx: {
          position: "fixed",
          bottom: 12,
          right: 12,
          zIndex: 1300,
          // #628 — discreet, but actually findable and tappable: a scribe has to
          // hit it on a tablet when an admin walks over, so it can't be a 16px
          // ghost. Themed text color reads on both light and dark backgrounds.
          color: "text.secondary",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          width: 40,
          height: 40,
          "&:hover": { bgcolor: "action.hover" }
        },
        children: /* @__PURE__ */ m.jsx(vc, { sx: { fontSize: 20 } })
      }
    ),
    /* @__PURE__ */ m.jsxs(
      tr,
      {
        open: s,
        onClose: () => i(!1),
        maxWidth: "xs",
        fullWidth: !0,
        children: [
          /* @__PURE__ */ m.jsx(nr, { children: /* @__PURE__ */ m.jsx(ue, { sx: { pt: 1 }, children: /* @__PURE__ */ m.jsx(
            Tn,
            {
              inputRef: l,
              autoFocus: !0,
              fullWidth: !0,
              type: "password",
              value: o,
              onChange: (d) => (
                // Strip non-digits + cap to PIN length so paste-overflow
                // doesn't sneak past the auto-submit threshold.
                a(
                  d.target.value.replace(/\D/g, "").slice(0, t.length)
                )
              ),
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: t.length,
                style: {
                  textAlign: "center",
                  fontFamily: "monospace",
                  fontSize: 24,
                  letterSpacing: 8
                }
              },
              error: u,
              helperText: u ? "Wrong PIN" : " "
            }
          ) }) }),
          /* @__PURE__ */ m.jsx(bs, { children: /* @__PURE__ */ m.jsx(Ne, { color: "inherit", onClick: () => i(!1), children: "Cancel" }) })
        ]
      }
    )
  ] });
}
function bp(t, e, n = [], r = !0) {
  const [s, i] = z({ data: null, loading: !0, error: null });
  return Se(() => {
    let o = !1;
    return (async () => {
      let a;
      try {
        a = await t();
      } catch {
        a = void 0;
      }
      const u = a != null;
      if (!o && u && i({ data: a, loading: !1, error: null }), r)
        try {
          const c = await e();
          o || i({ data: c, loading: !1, error: null });
        } catch (c) {
          !o && !u && i({ data: null, loading: !1, error: c });
        }
      else !o && !u && i({ data: null, loading: !1, error: null });
    })(), () => {
      o = !0;
    };
  }, [...n, r]), s;
}
function wp(t, e = []) {
  const [n, r] = z({ data: null, loading: !0, error: null });
  return Se(() => {
    let s = !1;
    return r({ data: null, loading: !0, error: null }), t().then((i) => {
      s || r({ data: i, loading: !1, error: null });
    }).catch((i) => {
      s || r({ data: null, loading: !1, error: i });
    }), () => {
      s = !0;
    };
  }, e), n;
}
function Vf({ clientId: t, cognitoDomain: e, logoutUri: n }) {
  if (t && e && n) {
    const r = `https://${e}/logout?client_id=${t}&logout_uri=${encodeURIComponent(n)}`;
    window.location.replace(r);
  }
}
function xp() {
  const { mode: t, setMode: e } = oc();
  return { mode: t, toggleTheme: () => {
    e(t === "dark" ? "light" : "dark");
  } };
}
function Sp({ t, mode: e, toggleTheme: n, navigate: r, cognitoConfig: s, settingsLink: i = "/settings" }) {
  return [
    {
      icon: /* @__PURE__ */ m.jsx(ra, {}),
      text: t("navigation.homeLink"),
      onClick: () => r("/")
    },
    {
      icon: /* @__PURE__ */ m.jsx(sa, {}),
      text: t("navigation.settingsLink"),
      onClick: () => window.location.href = i
    },
    {
      icon: e === "dark" ? /* @__PURE__ */ m.jsx(bc, { fontSize: "small" }) : /* @__PURE__ */ m.jsx(yc, { fontSize: "small" }),
      text: t(e === "dark" ? "navigation.theme.switchToLightMode" : "navigation.theme.switchToDarkMode"),
      onClick: n
    },
    {
      icon: /* @__PURE__ */ m.jsx(wc, {}),
      text: t("navigation.logoutLink"),
      onClick: () => Vf(s)
    }
  ];
}
const Gf = "Server Error";
let Xo = !1;
function Rp(t = xc) {
  Xo || (Xo = !0, t.interceptors.response.use(
    (e) => e,
    (e) => {
      var s, i, o;
      const n = (s = e == null ? void 0 : e.response) == null ? void 0 : s.data, r = ((i = n == null ? void 0 : n.data) == null ? void 0 : i.message) || (n == null ? void 0 : n.message) || (n == null ? void 0 : n.error) || (n == null ? void 0 : n.code) || (e == null ? void 0 : e.message);
      return console.error("[api error]", (o = e == null ? void 0 : e.response) == null ? void 0 : o.status, r, n), e && (e.serverErrorDetail = r, e.message = Gf), Promise.reject(e);
    }
  ));
}
export {
  Lh as AccountMenu,
  Xh as ActiveOrgProvider,
  Qh as ActiveShowProvider,
  Uh as AppBar,
  Nh as AppFooter,
  Dh as AppLayout,
  gp as BuildBadge,
  $h as CallbackPage,
  Bh as CognitoAuthProvider,
  Mh as ConfirmButton,
  rr as FullScreenLoader,
  Yh as ItemCard,
  qh as LoggedOutPage,
  Zh as LogoutPage,
  Tc as MainContent,
  ip as MockAuthProvider,
  ap as MockLoginPage,
  op as MockProtectedRoute,
  Hh as MuiThemeProvider,
  Wh as NavRail,
  Kh as NewItemCard,
  sp as OrgSwitcher,
  Vh as PageLayout,
  tp as PermissionProvider,
  yp as PinLock,
  Jh as ProtectedRoute,
  Hf as RIDE_STATUS_DISPLAY,
  ed as ReportList,
  sd as ReportParamsForm,
  fd as ReportViewer,
  dp as Reports,
  fp as RideStatusBadge,
  ld as RunHistory,
  Gf as SERVER_ERROR_MESSAGE,
  ep as ShowSwitcher,
  pp as SignatureBox,
  Gh as StyledBreadcrumb,
  zh as TableSkeleton,
  Jf as UNLOCK_PIN,
  vp as UsaBadge,
  rp as UserDisplayName,
  Fh as beginSignOut,
  Sp as getDefaultAccountMenuItems,
  Rp as installServerErrorInterceptor,
  kc as isSigningOut,
  Vf as logoutCognito,
  en as unwrapReport,
  fa as useActiveOrg,
  Zc as useActiveShow,
  Kl as useApiConfig,
  wp as useApiResource,
  bp as useCachedResource,
  va as useMockAuth,
  np as usePermission,
  Yl as useReportApi,
  hp as useRideStatuses,
  mp as useSheetSignature,
  xp as useThemeSwitcher
};
//# sourceMappingURL=common-fe.js.map
